import React from "react";

export const phrases = {
	locale: ["cs-CZ", "sk-SK", "en-GB", "pl-PL", "hu-HU"],
	messages: {
		"graphical_template": [
			"Grafická šablona", // cz
			"Grafická šablóna", // sk
			"Graphic template", // en
			"Szablon graficzny", // pl
			"Grafikai sablon", // hu
		],
		"fill": [
			"Výplň",
			"Výplň",
			"Fill",
			"Pożywny",
			"Töltő",
		],
		"none": [
			"Žádný",
			"Žiadny",
			"None",
			"Brak",
			"Nincs",
		],
		"shape_color": [
			"Barva výplně",
			"Farba výplne",
			"Fill color",
			"Kolor wypełnienia",
			"Kitöltőszín",
		],
		"shape_position": [
			"Umístění",
			"Umiestnenie",
			"Position",
			"Lokalizacja",
			"Elhelyezés",
		],
		"shape_size": [
			"Rozměry",
			"Veľkosť",
			"Size",
			"Rozmiar",
			"Méret",
		],
		"triangle": [
			"Trojúhelník",
			"Trojuholník",
			"Triangle",
			"Trójkąt",
			"Háromszög",
		],
		"square": [
			"Čtverec",
			"Štvorec",
			"Square",
			"Kwadrat",
			"Négyzet"
		],
		"square_format": [
			"Čtvercový",
			"Štvorcový",
			"Square format",
			"Kwadratowy",
			"Négyzet alakú"
		],
		"wide": [
			"Na šírku",
			"Na šírku",
			"Wide",
			"Krajobraz",
			"Szélességben"
		],
		"width": [
			"Šířka",
			"Šírka",
			"Width",
			"Szerokość",
			"Szélesség"
		],
		"stroke_width": [
			"Šířka okraje",
			"Šírka okraja",
			"Stroke width",
			"Szerokość krawędzi",
			"Körvonal szélessége"
		],
		"stroke_color": [
			"Barva okraje",
			"Farba okraja",
			"Stroke color",
			"Kolor krawędzi",
			"Körvonal színe"
		],
		"text_stroke_width": [
			"Šířka obrysu textu",
			"Šírka ťahu textu",
			"Text stroke width",
			"Szerokość obrysu tekstu",
			"A szöveg körvonalának szélessége",
		],
		"text_stroke_color": [
			"Barva obrysu textu",
			"Farba ťahu textu",
			"Text stroke color",
			"Kolor obrysu tekstu",
			"Szöveg körvonalának színe",
		],
		"frame_image": [
			"Orámovat obrázek",
			"Orámovať obrázok",
			"Frame image",
			"Wykadruj zdjęcie",
			"Kép keretezése"

		],
		"color": [
			"Barva",
			"Farba",
			"Color",
			"Kolor",
			"Szín"
		],
		"side": [
			"Strana",
			"Strana",
			"Side",
			"Strona",
			"Oldal"
		],
		"text": [
			"Text",
			"Text",
			"Text",
			"Tekst",
			"Szöveg"
		],
		"text_color": [
			"Barva textu",
			"Farba textu",
			"Text color",
			"Kolor tekstu",
			"Szövegszín"
		],
		"text_fontsize": [
			"Velikost textu",
			"Veľkosť písma",
			"Text size",
			"Wielość tekstu",
			"Szövegméret"
		],
		"text_font": [
			"Font",
			"Font",
			"Font",
			"Czcionka",
			"Betűtípus"
		],
		"triangle_orientation": [
			"Orientace trojúhelníku",
			"Orientácia trojuhoľníka",
			"Triangle orientation",
			"Orientacja trójkąta",
			"Háromszög tájolása"
		],
		"search": [
			"Hledat",
			"Hľadať",
			"Search",
			"Szukaj",
			"Keresés"
		],
		"up": [
			"Nahoře",
			"Hore",
			"Up",
			"Góra",
			"Felül"
		],
		"down": [
			"Dole",
			"Dole",
			"Down",
			"Dół",
			"Alul"
		],
		"show_frame": [
			"Zobrazit rám",
			"Zobraziť rám",
			"Show frame",
			"Pokaż ramkę",
			"Keret megjelenítése"
		],
		"dashed": [
			"Čárkovaný",
			"Čiarkovaný",
			"Dashed",
			"Przerywana",
			"Szaggatott vonal"
		],
		"frame_color": [
			"Barva rámečku",
			"Farba rámu",
			"Frame color",
			"Kolor ramki",
			"Keretszín"
		],
		"frame_width": [
			"Šířka rámečku",
			"Šírka rámu",
			"Frame width",
			"Szerokość ramki",
			"Keretszélesség"
		],
		"frame_width_placeholder": [
			"Šířka rámečku v pixelech",
			"šírka rámu v pixeloch",
			"Frame width in pixel",
			"Szerokość ramki w pixelach",
			"Keretszélesség pixelben"
		],
		"show_stripe": [
			"Zobrazit pruh",
			"Zobraziť pruh",
			"Show stripe",
			"Pokaż pasek",
			"Sáv megjelenítése"
		],
		"stripe_color": [
			"Barva pruhu",
			"Farba pruhu",
			"Stripe color",
			"Kolor paska",
			"Sávszín"
		],
		"stripe_position": [
			"Umístění pruhu",
			"Umiestnenie pruhu",
			"Stripe position",
			"Lokalizacja paska",
			"Sáv elhelyezése"
		],
		"horizontal": [
			"Vodorovný pruh",
			"Horizontálny pruh",
			"Horizontal",
			"Poziomy pasek",
			"Vízszintes sáv"
		],
		"vertical": [
			"Svislý pruh",
			"Vertikálny pruh",
			"Vertical",
			"Pionowy pasek",
			"Függőleges sáv"
		],
		"stripe_text_placeholder": [
			"Text v pruhu",
			"Text v pruhu",
			"Text in stripe",
			"Pasek tekstu",
			"Sávszöveg"
		],
		"shape_text_placeholder": [
			"Text v tvaru",
			"Text vo vrstve",
			"Text in shape",
			"Tekst w kształcie",
			"Szöveg alakzatban"
		],
		"text_size_placeholder": [
			"velikost textu",
			"veľkosť textu",
			"font size",
			"Wielkość tekstu",
			"szövegméret"
		],
		"text_font_placeholder": [
			"font",
			"font",
			"font",
			"Czcionka",
			"betűtípus"
		],
		"nav_queries": [
			"Produkty",
			"Produkty",
			"Product selections",
			"Produkty",
			"Termékek"
		],
		"nav_size": [
			"Formát",
			"Formát",
			"Format",
			"Format",
			"Formátum"
		],
		"nav_frame": [
			"Rám",
			"Rám",
			"Frame",
			"Ramka",
			"Keret"
		],
		"nav_filter": [
			"Filtr",
			"Filter",
			"Filter",
			"Filtr",
			"Szűrő"
		],
		"nav_stripe": [
			"Pruh",
			"Pruh",
			"Stripe",
			"Pasek",
			"Sáv"
		],
		"nav_shape": [
			"Vrstva",
			"Vrstva",
			"Layer",
			"Warstwa",
			"Réteg"
		],
		"nav_image": [
			"Obrázek",
			"Obrázok",
			"Image",
			"Obraz",
			"Kép"
		],
		"nav_save": [
			"Uložit",
			"Uložiť",
			"Save",
			"Zapisz",
			"Mentés"
		],
		"nav_shapes": [
			"Vrstvy",
			"Vrstvy",
			"Layers",
			"Warstwy",
			"Rétegek"
		],
		"upscale_image": [
			"Vylepšit rozlišení",
			"Vylepšiť rozlíšenie",
			"Upscale resolution",
			"Ulepszenia rozdzielczości",
			"Felbontásjavítás",
		],
		"template_type_null": [
			"Grafická šablona", // cz
			"Grafická šablóna", // sk
			"Graphic template", // en
			"Szablon graficzny", // pl
			"Grafikai sablon", // hu
		],
		"template_type_1": [
			"Vylepšení rozlišení",
			"Vylepšenia rozlíšenia",
			"Upscale resolution",
			"Ulepszenia rozdzielczości",
			"Felbontás javítása"
		],
		"template_type_2": [
			"Odstranit pozadí",
			"Odstrániť pozadie",
			"Remove background",
			"Usuń tło",
			"Háttéreltávolítás",
		],
		"template_type_3": [
			"Odstranění vodoznaků",
			"Odstránenie vodoznakov",
			"Watermarks removal",
			"Usuń znaki wodne",
			"Vízjelek eltávolítása"
		],
		"template_type_4": [
			"Outpainting",
			"Outpainting",
			"Outpainting",
			"Outpainting",
			"Outpainting",
		],
		"template_type_5": [
			"Animovaný GIF",
			"Animovaný GIF",
			"Animated GIF",
			"Animowany GIF",
			"Animált GIF",
		],
		"template_type_6": [
			"Inpainting",
			"Inpainting",
			"Inpainting",
			"Inpainting",
			"Inpainting",
		],
		"template_type_10": [
			"Obrázek s odstraněným vodoznakem",
			"Obrázok s odstráneným vodoznakom",
			"Image with watermark removed",
			"Obraz z usuniętym znakiem wodnym",
			"Kép eltávolított vízjellel"
		],
		"template_type_11": [
			"Upravený obrázek s odstraněným pozadím",
			"Obrázok s odstráneným pozadím",
			"Image with background removed",
			"Obraz z usuniętym tłem",
			"Kép eltávolított háttérrel"
		],
		"template_type_1_started": [
			"Probíhá vylepšování obrázku",
			"Prebieha vylepšovanie obrázku",
			"Image enhancement in progress",
			"Trwa ulepszanie obrazu",
			"Képfeljavítás folyamatban",
		],
		"template_type_2_started": [
			"Probíhá odstraňování pozadí",
			"Prebieha odstraňovanie pozadia",
			"Background removal in progress",
			"Trwa usuwanie tła",
			"Háttéreltávolítás folyamatban",
		],
		"template_type_3_started": [
			"Probíhá odstraňování vodoznaku",
			"Prebieha odstraňovanie vodoznaku",
			"Watermark removal in progress",
			"Trwa usuwanie znaku wodnego",
			"Vízjeleltávolítás folyamatban",
		],
		"template_type_4_started": [
			"Probíhá outpainting",
			"Prebieha outpainting",
			"Outpainting in progress",
			"Trwa malowanie",
			"A kifestés folyamatban van",
		],
		"template_type_6_started": [
			"Probíhá inpainting",
			"Prebieha inpainting",
			"Inpainting in progress",
			"Malowanie w toku",
			"A festés folyamatban van",
		],
		"template_type_1_done": [
			"Obrázek vylepšen",
			"Obrázok vylepšený",
			"Image upscaled",
			"Poprawiony obraz",
			"Kép feljavítva",
		],
		"template_type_2_done": [
			"Pozadí obrázku odstraněno",
			"Pozadie obrázku odstránené",
			"Image background removed",
			"Usunięto tło obrazu",
			"Képháttér eltávolítva",
		],
		"template_type_3_done": [
			"Vodoznak odstraněn",
			"Vodoznak odstránený",
			"Watermark removed",
			"Usunięto znak wodny",
			"Vízjel eltávolítva",
		],
		"template_type_4_done": [
			"Outpainting hotov",
			"Outpainting hotový",
			"Outpainting done",
			"Malowanie zewnętrzne wykonane",
			"Kifestés megtörtént",
		],
		"template_type_6_done": [
			"Inpainting hotov",
			"Inpainting hotový",
			"Inpainting done",
			"Maľba hotov",
			"Befestés hotov",
		],
		"outpainting_error": [
			"Chyba outpaintingu",
			"Chyba outpaintingu",
			"Outpainting error",
			"Błąd malowania",
			"Túlfestési hiba",
		],
		"outpaint_over": [
			"Outpaintovat přes celé plátno",
			"Náter cez celé plátno",
			"Outpaint over full canvas",
			"Przemalowanie na całym płótnie",
			"Kifesteni a teljes vászonra",
		],
		"upscale_previews_all_done": [
			"Náhledy byly vygenerovány. Pro hromadné vylepšení rozlišení vyberte v pravém panelu produktový výběr, na který chcete vylepšení aplikovat. Nezapomeňte šablonu pojmenovat a uložit.",
			"Náhľady boli vygenerované. Pre hromadné vylepšenie rozlíšenia vyberte v pravom panely produktový výber, na ktorý chcete vylepšenia aplikovať. Nezabudnite šablónu pomenovať a uložiť.",
			"Previews were generated. For bulk upscale select the product selection in right panel. Don't forget to name and save the template.",
			"Miniatury zostały wygenerowane. W przypadku rozszerzeń rozdzielczości zbiorczej wybierz produkty, do których chcesz zastosować ulepszenia w prawym oknie. Pamiętaj, aby nazwać i zapisać szablon.",
			"Az előnézetek generálása megtörtént. Tömeges felbontásjavításhoz válassza ki a jobb oldali panelen a terméklekérdezést, amelyre a javítást alkalmazni szeretné. Ne felejtse el elnevezni és elmenteni a sablont."
		],
		"min_detection_accuracy": [
			"minimální přesnost detekce",
			"minimálna presnosť detekcie",
			"min detection accuracy",
			"minimalna dokładność wykrywania",
			"minimális detektálási pontosság"
		],
		"min_detection_accuracy_info": [
			"bude-li přesnost detekce nižší, ponechá se původní obrázek s vodoznakem",
			"ak bude presnosť detekcie nižšia, ponechá sa pôvodný obrázok s vodoznakom",
			"if the detection accuracy is lower, the original watermarked image will be kept",
			"jeśli dokładność wykrywania jest niższa, oryginalny obraz ze znakiem wodnym zostanie zachowany",
			"ha kisebb a detektálási pontosság, megmarad az eredeti vízjeles kép"
		],
		"get_previews": [
			"Vygenerovat náhledy",
			"Vygenerovať náhľady",
			"Get previews",
			"Generować podglądy",
			"Előnézetek generálása"
		],
		"select_images_for_upscale_previews": [
			"Vyberte obrázky, ze kterých si přejete vytvořit náhledy vylepšení rozlišení.",
			"Vyberte obrázky, z ktorých si prajete vytvoriť náhľady vylepšenia rozlíšenia.",
			"To create previews, select the images and tap generate previews.",
			"Wybierz obrazki z których chcesz utworzyć podglądy poprawy rozdzielczości.",
			"Válassza ki a képeket, amikből felbontásjavító előnézetet szeretne készíteni."
		],
		"creating_upscale_previews": [
			"Generují se náhledy obrázků. Tato operace je časově náročná, chvíli to potrvá.",
			"Generujú sa náhľady obrázkov. Táto operácia je časovo náročná, chvíľu to potrvá.",
			"Generating previews. This process is time consuming, it will take a while.",
			"Generowane są podglądy obrazów. Ta operacja jest czasochłonna, może chwilę potrwać. ",
			"A képek előnézetének generálása folyamatban. Ez a művelet időigényes, így eltart egy darabig."
		],
		"sending_images_for_upscale_previews": [
			"Odesílám obrázky",
			"Odosielam obrázky",
			"Uploading images",
			"Przesyłanie obrazy",
			"Képek küldése"
		],
		"original_image": [
			"Původní obrázek",
			"Pôvodný obrázok",
			"Original image",
			"Oryginalny obrazek",
			"Eredeti kép"
		],
		"other_images": [
			"Jiné obrázky",
			"Iné obrázky",
			"Other Images",
			"Inne obrazy",
			"Egyéb képek"
		],
		"bgremoved_image": [
			"Obrázek s odstraněným pozadím",
			"Upravený obrázok s odstráneným pozadím",
			"Edited image with background removed",
			"Edytowany obraz z usuniętym tłem",
			"Szerkesztett kép, háttér eltávolítva"
		],
		"bgremoved_edited_image": [
			"Upravený obrázek s odstraněným pozadím",
			"Obrázok s odstráneným pozadím",
			"Image with background removed",
			"Obraz z usuniętym tłem",
			"Kép eltávolított háttérrel"
		],
		"wmremoved_image": [
			"Obrázek s odstraněným vodoznakem",
			"Obrázok s odstráneným vodoznakom",
			"Image with watermark removed",
			"Obraz z usuniętym znakiem wodnym",
			"Kép eltávolított vízjellel"
		],
		"upscaled_image": [
			"Vylepšený obrázek",
			"Vylepšený obrázok",
			"Upscaled image",
			"Ulepszony obrazek",
			"Feljavított kép"
		],
		"no_images_for_upscale": [
			"Ve vašem feedu jsme nenašli žádné obrázky s rozměry do 600 x 600 pixelů. Vylepšení rozlíšení není nutné.",
			"Vo vašom feede sme nenašli žiadne obrázky s rozmermi do 600 x 600 pixelov. Velepšenie rozlíšenia nie je nutné.",
			"There are no images with dimensions up to 600 x 600 pixels. Upscale is not necessary.",
			"W Twoim feedzie nie znaleźliśmy żadnych obrazków w rozmiarze do do 600 x 600 pikseli. Nie ma potrzeby poprawiania rozdzielczości.",
			"Nem található 600 x 600 pixelnél nagyobb méretű kép a feedjében. A felbontás javítása nem szükséges."
		],
		"upscale_template": [
			"Vylepšení rozlišení obrázků",
			"Vylepšenie rozlíšenia obrázkov",
			" Image upscaler",
			"Popraw rozdzielczość obrazu",
			"Képek felbontásjavítása"
		],
		"upscale_how_does_it_work": [
			"<h3>Jak to funguje</h3><p>....</p>",
			"<h3>Ako to funguje</h3><p>....</p>",
			"<h3>How does it work?</h3><p>The upscale method is based on ....</p>",
			"<h3>Jak to działa</h3><p>....</p>",
			"<h3>Hogy működik?</h3><p>....</p>"
		],
		"upscale_method_preview": [
			"Ukázky vylepšení rozlišení",
			"Ukážky vylepšenia rozlíšenia",
			"Upscale previews",
			"Przykłady ulepszeń rozdzielczości",
			"Felbontásjavítás szemléltetők"
		],
		"image_is_upscaled": [
			"Obrázek s vylepšeným rozlišením",
			"Obrázok s vylepšeným rozlíšením",
			"The upscaled image",
			"Obraz o ulepszonej rozdzielczości",
			"Kép felbontásjavítással"
		],
		"show_larger_preview": [
			"Zobrazit větší náhled",
			"Zobraziť väčší náhľad",
			"Show larger preview",
			"Zobacz większy podgląd",
			"Nagyobb előnézet megjelenítése"
		],
		"upscale_loading_products": [
			"Analyzujeme rozměry obrázků ve vašem feedu. Vylepšení rozlišení má smysl pouze u obrázků s rozměry do 600 x 600 pixelů.",
			"Analyzujeme rozmery obrázkov vo vašom feede. Vylepšenie rozlíšenie má zmysel iba pre obrázky s rozmermi do 600 x 600 pixelov.",
			"Analyzing dimensions of images. Upscale makes sense for images with dimensions up to 600 x 600 pixels only.",
			"Analizujemy wymiary obrazów w Twoim feedzie. Poprawa rozdzielczości ma sens tylko w przypadku obrazów do 600 x 600 pikseli.",
			"A feedjében található képek méretének elemzése. A felbontásjavításnak csak max. 600 x 600 pixel méretű kép esetében van értelme."
		],
		"upscale_clear_interval": [
			"Zrušit a vybrat jiné obrázky",
			"Zrušiť a vybrať iné obrázky",
			"Cancel and select other images",
			"Anuluj czynność i wybierz inne obrazy",
			"Visszavonás és más képek kijelölése"
		],
		"clear_selection": [
			"Zrušit výběr",
			"Zrušiť výber",
			"Deselect",
			"Anuluj wybór",
			"Kijelölés visszavonása"
		],
		"selected_count": [
			"Vybráno",
			"Vybraných",
			"Selected",
			"Wybrano",
			"Kijelölve"
		],
		"cancel": [
			"Zrušit",
			"Zrušiť",
			"Cancel",
			"Anuluj",
			"Visszavonás"
		],
		"position": [
			"Pozice",
			"Pozícia",
			"Position",
			"Pozycja",
			"Pozíció"
		],
		"opacity": [
			"Průhlednost",
			"Priehľadnosť",
			"Opacity",
			"Przejrzystość",
			"Áttetszőség"
		],
		"apply_on_queries": [
			"Aplikovat na produkty",
			"Aplikovať na produkty",
			"Apply on products",
			"Zastosuj do produktów",
			"Alkalmazás termékekre"
		],
		"template_name": [
			"Název šablony",
			"Názov šablóny",
			"Template name",
			"Nazwa szablonu",
			"Sablon neve"
		],
		"template_type": [
			"Typ",
			"Typ",
			"Type",
			"Typ",
			"Típus"
		],
		"save_template": [
			"Uložit šablonu",
			"Uložiť šablónu",
			"Save template",
			"Zapisz szablon",
			"Sablon mentése"
		],
		"show_shape": [
			"Zobrazit vrstvu",
			"Zobraziť vrstvu",
			"Show layer",
			"Pokaż warstwę",
			"Réteg megjelenítése"
		],
		"stroke_opacity": [
			"Průhlednost okraje",
			"Priehľadnosť okraju",
			"Stroke opacity",
			"Przezroczystość krawędzi",
			"Szegélyek áttetszősége"
		],
		"priority": [
			"Priorita",
			"Priorita",
			"Priority",
			"Priorytet",
			"Prioritás"
		],
		"template_list": [
			"Seznam šablon",
			"Zoznam šablón",
			"Template list",
			"Lista szablonów",
			"Sablonlista"
		],
		"products": [
			"Produkty",
			"Produkty",
			"Products",
			"Produkty",
			"Termékek"
		],
		"images": [
			"Obrázky",
			"Obrázky",
			"Images",
			"Zdjęcia",
			"Képek"
		],
		"count_images": [
			"počet obrázků",
			"počet obrázkov",
			"count images",
			"liczba obrazów",
			"képek száma"
		],
		"validations": [
			"Validace obrázků",
			"Validácia obrázkov",
			"Images validations",
			"Sprawdzanie poprawności obrazu",
			"Képek validálása"
		],
		"new_template": [
			"Nová šablona",
			"Nová šablóna",
			"New template",
			"Nowy szablon",
			"Új sablon"
		],
		"new_upscale_template": [
			"Vylepšení rozlišení obrázků",
			"Vylepšenie rozlíšenia obrázkov",
			"Image upscaler",
			"Popraw rozdzielczość obrazu",
			"Képek felbontásjavítása"
		],
		"new_bgremove_template": [
			"Odstranění pozadí",
			"Odstránenie pozadia",
			"Background removal",
			"Usuwanie tła",
			"Háttér eltávolítása"
		],
		"new_wmremove_template": [
			"Odstrannění vodoznaku",
			"Odstránenie vodoznaku",
			"Watermark removal",
			"Usuwanie znaku wodnego",
			"Vízjel eltávolítása"
		],
		"template_gallery": [
			"Galerie šablon",
			"Galéria šablón",
			"Template gallery",
			"Galeria szablonów",
			"Sablongaléria"
		],
		"blank_template": [
			"Prázdná šablona",
			"Prázdna šablóna",
			"Blank template",
			"Pusty szablon",
			"Üres sablon"
		],
		"background_color": [
			"Barva pozadí",
			"Farba pozadia",
			"Background color",
			"Kolor tła",
			"Háttérszín"
		],
		"text_background_color": [
			"Barva pozadí",
			"Farba pozadia",
			"Background color",
			"Kolor tła",
			"Háttérszín"
		],
		"background_width": [
			"Šířka",
			"Šírka",
			"Width",
			"Szerokość",
			"Szélesség"
		],
		"background_height": [
			"Výška",
			"Výška",
			"Height",
			"Wysokość",
			"Magasság"
		],
		"background_type": [
			"Typ pozadí",
			"Typ pozadia",
			"Background type",
			"Typ tła",
			"Háttértípus"
		],
		"background_type_none": [
			"Žádné",
			"Žiadne",
			"None",
			"Brak",
			"Nincs"
		],
		"background_type_circle": [
			"Kolečko",
			"Koliesko",
			"Circle",
			"Koło",
			"Kör"
		],
		"background_type_rectangle": [
			"Obdélník",
			"Obdĺžnik",
			"Rectangle",
			"Prostokąt",
			"Téglalap"
		],
		"background_type_rectangle-each-line": [
			"Obdélník na každý řádek",
			"Obdĺžnik na každý riadok",
			"Rectangle per each line",
			"Prostokąt na każdą linię",
			"Téglalap soronként"
		],
		"background_type_ellipse": [
			"Elipsa",
			"Elipsa",
			"Ellipse",
			"Elipsa",
			"Ellipszis"
		],
		"background_type_image": [
			"Obrázek",
			"Obrázok",
			"Image",
			"Obraz",
			"Kép"
		],
		"random_product": [
			"Náhodný produkt",
			"Náhodný produkt",
			"Random Product",
			"Losowy produkt",
			"Random termék"
		],
		"stroke": [
			"Okraj",
			"Okraj",
			"Stroke",
			"Krawędź",
			"Szegély"
		],
		"full": [
			"Plný",
			"Plný",
			"Full",
			"Pełny",
			"Telt"
		],
		"no_templates": [
			"Zatím nemáte žádné šablony. Vytvořte první!",
			"Zatiaľ nemáte žiadne šablóny. Vytvorte prvú!",
			"You don't have any templates yet. Let's create a first one!",
			"Nie masz jeszcze żadnych szablonów. Stwórz pierwszy!",
			"Még nincs sablonja. Hozza létre az elsőt!"
		],
		"no_alternative_templates": [
			"Zatím nemáte žádné alternativní šablony",
			"Zatiaľ nemáte žiadne alternatívne šablóny.",
			"You don't have any alternative templates yet.",
			"Nie masz jeszcze żadnych alternatywnych szablonów.",
			"Még nincsenek alternatív sablonjaid.",
		],
		"all_products": [
			"Všechny produkty",
			"Všetky produkty",
			"All products",
			"Wszystkie produkty",
			"Összes termék"
		],
		"back": [
			"Zpět",
			"Späť",
			"Back",
			"Wróć",
			"Vissza"
		],
		"back_to_template_list": [
			"Zpět na seznam šablon",
			"Späť na zoznam šablón",
			"Back to template list",
			"Powrót do listy szablonów",
			"Vissza a sablonlistára"
		],
		"due_date": [
			"Termín",
			"Termín",
			"Due date",
			"Termin",
			"Esedékesség"
		],
		"created_at": [
			"Vytvořeno",
			"Vytvorené",
			"Created at",
			"Utworzono",
			"Létrehozva"
		],
		"save": [
			"Uložit",
			"Uložiť",
			"Save",
			"Zapisz",
			"Mentés"
		],
		"save_and_exit": [
			"Uložit a odejít",
			"Uložiť a odísť",
			"Save and exit",
			"Zapisz i wyjdź",
			"Mentés és bezárás"
		],
		"save_and_apply": [
			"Uložit a použít",
			"Uložit a použiť",
			"Save and apply",
			"Zapisz i użyj",
			"Mentés és alkalmazás"
		],
		"save_as_new_template": [
			"Uložit jako novou šablonu",
			"Uložiť ako novú šablónu",
			"Save as new template",
			"Zapisz jako nowy szablon",
			"Mentés új sablonként",
		],
		"apply": [
			"Aplikovat",
			"Aplikovať",
			"Apply",
			"Zastosować",
			"Alkalmazás"
		],
		"saving": [
			"Ukládá se",
			"Ukládá sa",
			"saving",
			"jest zapisywany",
			"Mentés folyamatban"
		],
		"no_shape_selected": [
			"Nebyla vybrána žádná vrstva.",
			"Nebola vybraná žiadna vrstva.",
			"No layer selected.",
			"Nie wybrano warstwy.",
			"Nincs kiválasztva réteg."
		],
		"user": [
			"Uživatel",
			"Užívateľ",
			"User",
			"Użytkownik",
			"Felhasználó"
		],
		"delete": [
			"Smazat",
			"Zmazať",
			"Delete",
			"Usuń",
			"Törlés"
		],
		"insert": [
			"Vložit",
			"Vložiť",
			"Insert",
			"Wstawić",
			"Beillesztés"
		],
		"preview": [
			"Náhled",
			"Náhľad",
			"Preview",
			"Podgląd",
			"Előnézet"
		],
		"pause": [
			"Pozastavit",
			"Pozastavit",
			"Pause",
			"Pauza",
			"Szüneteltetés"
		],
		"start": [
			"Spustit",
			"Spustiť",
			"Start",
			"Uruchom",
			"Indítás"
		],
		"action": [
			"Akce",
			"Akcia",
			"Action",
			"Działanie",
			"Művelet"
		],
		"edit": [
			"Upravit",
			"Upraviť",
			"Edit",
			"Edytuj",
			"Szerkesztés"
		],
		"next": [
			"Následující",
			"Nasledujúci",
			"Next",
			"Następne",
			"Következő"
		],
		"previous": [
			"Předchozí",
			"Predchádzajúci",
			"Previous",
			"Poprzednie",
			"Előző"
		],
		"project": [
			"Export",
			"Export",
			"Export",
			"Export",
			"Export"
		],
		"eshop": [
			"E-shop",
			"Eshop",
			"Online store",
			"E-shop",
			"E-shop"
		],
		"agency": [
			"Agentura",
			"Agentúra",
			"Agency",
			"Agencja",
			"Ügynökség",
		],
		"freelancer": [
			"Freelancer",
			"Freelancer",
			"Freelancer",
			"Freelancer",
			"Szabadúszó",
		],
		"title": [
			"Nadpis",
			"Nadpis",
			"Title",
			"Tytuł",
			"Cím"
		],
		"date": [
			"Datum",
			"Dátum",
			"Date",
			"Data",
			"Dátum"
		],
		"created_by": [
			"Vytvořil",
			"Vytvoril",
			"Created by",
			"Stworzył",
			"Létrehozó"
		],
		"max_length": [
			"Maximální  délka: 1000 znaků",
			"Maximálna dĺžka: 1000 znakov",
			"Maximum length: 1000 characters",
			"Maksymalna długość: 1000 znaków",
			"Maximális hossz: 1000 karakter"
		],
		"chars_left": [
			"Zbývajících znaků",
			"Ostávajúcich znakov",
			"Characters left",
			"Pozostałe znaki",
			"Fennmaradó karakterszám"
		],
		"monday": [
			"Pondělí",
			"Pondelok",
			"Monday",
			"Poniedziałek",
			"Hétfő"
		],
		"tuesday": [
			"Úterý",
			"Utorok",
			"Tuesday",
			"Wtorek",
			"Kedd"
		],
		"wednesday": [
			"Středa",
			"Streda",
			"Wednesday",
			"Środa",
			"Szerda"
		],
		"thursday": [
			"Čtvrtek",
			"Štvrtok",
			"Thursday",
			"Czwartek",
			"Csütörtök"
		],
		"friday": [
			"Pátek",
			"Piatok",
			"Friday",
			"Piątek",
			"Péntek"
		],
		"saturday": [
			"Sobota",
			"Sobota",
			"Saturday",
			"Sobota",
			"Szombat"
		],
		"sunday": [
			"Neděle",
			"Nedeľa",
			"Sunday",
			"Niedziela",
			"Vasárnap"
		],
		"mon": [
			"Po",
			"Po",
			"Mon",
			"Pon",
			"H"
		],
		"tue": [
			"Út",
			"Ut",
			"Tue",
			"Wt",
			"K"
		],
		"wed": [
			"St",
			"St",
			"Wed",
			"Śr",
			"SZ"
		],
		"thu": [
			"Čt",
			"Št",
			"Thu",
			"Czw",
			"CS"
		],
		"fri": [
			"Pá",
			"Pia",
			"Fri",
			"Pt",
			"P"
		],
		"sat": [
			"So",
			"So",
			"Sat",
			"So",
			"SZ"
		],
		"sun": [
			"Ne",
			"Ne",
			"Sun",
			"Nd",
			"V"
		],
		"yes": [
			"Ano",
			"Áno",
			"Yes",
			"Tak",
			"Igen"
		],
		"no": [
			"Ne",
			"Nie",
			"No",
			"Nie",
			"Nem"
		],
		"currency": [
			"Kč",
			"€",
			"CZK",
			"PLN",
			"Ft"
		],
		"filter": [
			"Filtrovat",
			"Filtrovať",
			"Filter",
			"Filtruj",
			"Szűrés"
		],
		"calcel_filter": [
			"Zrušit filtrování",
			"Zrušiť filtrovanie",
			"Cancel filter",
			"Anuluj filtrowanie",
			"Szűrő eltávolítása"
		],
		"name": [
			"Název",
			"Názov",
			"Name",
			"Nazwa",
			"Név"
		],
		"confirm_delete": [
			"Opravdu chcete smazat tuto šablonu?",
			"Naozaj chcete túto šablónu zmazať?",
			"Do you really want to delete this template?",
			"Czy na pewno chcesz usunąć ten szablon?",
			"Tényleg törölni szeretné ezt a sablont?"
		],
		"margin": [
			"Odsazení",
			"Odsadenie",
			"Margin",
			"Margines",
			"Margó"
		],
		"add_shape_button": [
			"Nová vrstva",
			"Nová vrstva",
			"New Layer",
			"Nowa warstwa",
			"Új réteg"
		],
		"add_shape": [
			"Přidat novou vrstvu",
			"Pridať novú vrstvu",
			"Add new layer",
			"Dodaj nową warstwę",
			"Új réteg hozzáadása"
		],
		"shape_list": [
			"Seznam vrstev",
			"Zoznam vrstiev",
			"List of layers",
			"Lista warstw",
			"Réteglista"
		],
		"diameter": [
			"Průměr",
			"Priemer",
			"Diameter",
			"Średnica",
			"Átmérő"
		],
		"active": [
			"Aktivní",
			"Aktívne",
			"Active",
			"Aktywny",
			"Aktív"
		],
		"active_from": [
			"Aktivní od",
			"Aktívne od",
			"Active from",
			"Aktywny od",
			"Aktiváció kezdete"
		],
		"active_to": [
			"Aktivní do",
			"Aktívne do",
			"Active to",
			"Aktywny do",
			"Aktiváció vége"
		],
		"inactive": [
			"Neaktivní",
			"Neaktívne",
			"Inactive",
			"Nieaktywny",
			"Inaktív"
		],
		"set_active_date": [
			"Aktivita šablony",
			"Aktivita šablóny",
			"Template scheduler",
			"Aktywność na szablonach",
			"Sablon aktivitása"
		],
		"timer": [
			"Časovač",
			"Časovač",
			"Timer",
			"Timer",
			"Időzítő"
		],
		"invalid_active_date_range": [
			"Neplatný rozsah datumu",
			"Neplatný rozsah dátumov",
			"Invalid date range",
			"Nieprawidłowy zakres dat",
			"Érvénytelen dátumtartomány"
		],
		"circle": [
			"Kruh",
			"Kruh",
			"Circle",
			"Okrąg",
			"Kör"
		],
		"frame": [
			"Rám",
			"Rám",
			"Frame",
			"Ramka",
			"Keret"
		],
		"rectangle": [
			"Obdélník",
			"Obdĺžnik",
			"Rectangle",
			"Prostokąt",
			"Téglalap"
		],
		"triangle1": [
			"Trojúhelník",
			"Trojuhoľník",
			"Triangle",
			"Trójkąt",
			"Háromszög"
		],
		"triangle2": [
			"Trojúhelník",
			"Trojuhoľník",
			"Triangle",
			"Trójkąt",
			"Háromszög"
		],
		"triangle_side_length": [
			"Délka strany",
			"Dĺžka strany",
			"Side length",
			"Długość boku",
			"Oldalhossz"
		],
		"corner_radius": [
			"Zaoblení",
			"Zaoblenie",
			"Border radius",
			"Zaokrąglanie",
			"Lekerekítés"
		],
		"dynamicText": [
			"Feed element",
			"Feed element",
			"Feed element",
			"Feed element",
			"Feedelem"
		],
		"imageFromElements": [
			"Obrázek z elementu",
			"Obrázok z elementu",
			"Image from element",
			"Obraz z elementu",
			"kép elemből",
		],
		"curvedText": [
			"Text podél křivky",
			"Text pozdĺž krivky",
			"Text along path",
			"Tekst wzdłuż krzywej",
			"Szöveg görbe mentén"
		],
		"circleText": [
			"Text podél kruhu",
			"Text pozdĺž kruhu",
			"Text along circle",
			"Tekst wzdłuż okręgu",
			"Szöveg a kör mentén"
		],
		"textWithElements": [
			"Text s elementy",
			"Text s elementmi",
			"Text with elements",
			"Tekst z elementami",
			"Szöveg elemekkel"
		],
		"background_settings": [
			"Nastavení pozadí",
			"Nastavenie pozadia",
			"Background settings",
			"Ustawienia tła",
			"Háttérbeállítások",
		],
		"text_wrap": [
			"Zalamování textu",
			"Zalamovanie textu",
			"Text wrap",
			"Zawijanie tekstu",
			"Szövegcsomagolás",
		],
		"text_overflow": [
			"Přetékání textu",
			"Pretekania textu",
			"Text overflow",
			"Przepełnienie tekstu",
			"Szöveg túlcsordulása",
		],
		"text_overflow_keep": [
			"ponechat nezměněné",
			"ponechať nezmenené",
			"unchanged",
			"pozostawić bez zmian",
			"változatlanul hagy",
		],
		"text_overflow_fontsize": [
			"zmenšit písmo",
			"zmenšiť písmo",
			"decrease fontsize",
			"zmniejsz rozmiar czcionki",
			"betűméret csökkentése",
		],
		"text_overflow_layersize": [
			"zvětšit vrstvu",
			"zväčšiť vrstvu",
			"enlarge layer",
			"powiększ warstwę",
			"réteg növelése",
		],
		"text_decoration": [
			"Čára",
			"Čiara",
			"Decoration",
			"Linia",
			"Vonal",
		],
		"text_decoration_color": [
			"Barva čáry",
			"Farba čiary",
			"Decoration color",
			"Kolor linii",
			"Vonalszín",
		],
		"text_decoration_linethickness": [
			"Tloušťka čáry",
			"Hrúbka čiary",
			"Line thickness",
			"Grubość linii",
			"Vonalvastagság",
		],
		"text_decoration_lineoverlap": [
			"Přesah čáry",
			"Presah čiary",
			"Line overlap",
			"Linia nakładania się",
			"Vonalátfedés",
		],
		"text_decoration_none": [
			"žádná",
			"žiadna",
			"none",
			"brak",
			"nincs",
		],
		"text_decoration_underline": [
			"pod",
			"pod",
			"underline",
			"strąk",
			"aláhúzás",
		],
		"text_decoration_overline": [
			"nad",
			"nad",
			"overline",
			"ponad",
			"föléhúzás",
		],
		"text_decoration_linethrough": [
			"přes",
			"cez",
			"line-through",
			"przez",
			"áthúzás",
		],
		"text_direction": [
			"Směr textu",
			"Smer textu",
			"Text direction",
			"Kierunek tekstu",
			"Szöveg iránya",
		],
		"text_align": [
			"Zarovnání textu",
			"Zarovnanie textu",
			"Text align",
			"Wyrównanie tekstu",
			"Szövegigazítás",
		],
		"text_align_left": [
			"nalevo",
			"naľavo",
			"Left",
			"po lewej stronie",
			"balra",
		],
		"text_align_right": [
			"napravo",
			"napravo",
			"Right",
			"po prawej stronie",
			"jobbra",
		],
		"text_align_center": [
			"vycentrovat",
			"centrovať",
			"Center",
			"centrum",
			"középre",
		],
		"text_valign": [
			"Vertikální zarovnání",
			"Vertikálne zarovnanie",
			"Vertical align",
			"Wyrównanie w pionie",
			"Függőleges igazítás",
		],
		"text_valign_start": [
			"nahoru",
			"hore",
			"Start",
			"w górę",
			"fel",
		],
		"text_valign_middle": [
			"nastřed",
			"na stred",
			"Middle",
			"wyśrodkowany",
			"középre",
		],
		"text_valign_end": [
			"naspod",
			"dole",
			"End",
			"w dół",
			"le",
		],
		"height": [
			"Výška",
			"Výška",
			"Height",
			"Wysokość",
			"Magasság",
		],
		"aspect_size_ratio": [
			"Zachovat poměr stran",
			"Zachovať pomer strán",
			"Maintain aspect ratio",
			"Zachowaj proporcje",
			"Oldalarány fenntartása",
		],
		"dash_length": [
			"Délka čárkování",
			"Dĺžka čiarkovania",
			"Dash lenght",
			"Długość linii",
			"Szaggatások hossza",
		],
		"dash_density": [
			"Mezera",
			"Medzera",
			"Dash density",
			"Przerwa",
			"Hézagok",
		],
		"dashedFrame": [
			"Čárkovaný rám",
			"Čiarkovaný rám",
			"Dashed frame",
			"Przerywana ramka",
			"Szaggatott keret",
		],
		"coordinate_x": [
			"Souřadnice x",
			"Súradnica x",
			"Coordinate x",
			"Współrzędne x",
			"x koordináta",
		],
		"coordinate_y": [
			"Souřadnice y",
			"Súradnica y",
			"Coordinate y",
			"Współrzędne y",
			"y koordináta",
		],
		"template_saved": [
			"Šablona uložena.",
			"Šablóna uložená.",
			"Template saved.",
			"Szablon zapisany",
			"Sablon elmentve.",
		],
		"upload_error_unsupported_type": [
			"Nepodporovaný typ souboru",
			"Nepodporovaný typ súboru",
			"Unsupported file type",
			"Niedozwolony format pliku",
			"Nem támogatott fájltípus",
		],
		"upload_error_large_file": [
			"Soubor je příliš veliký. Max. velikost je 1MB.",
			"Súbor je príliš veľký. Max. veľkosť je 1MB.",
			"Image file is too big. Max. size is 1MB.",
			"Plik jest za duży. Max. rozmiar to 1 MB.",
			"A fájl túl nagy. A maximális méret 1MB.",
		],
		"upload_error_image_too_big": [
			"Rozměry obrázku jsou příliš veliké. Prosím změnšete obrázek a zkuste to znovu.",
			"Rozmery obrázku sú príliš veľké. Prosím zmenšite obrázok a skúste to znova.",
			"The image size is too big. Please resize the image and try again.",
			"Wymiary obrazu są za duże. Zmień rozmiar obrazu i spróbuj ponownie.",
			"A kép méretei túl nagyok. Kérjük, méretezze át a képet, és próbálja újra.",
		],
		"active_templates": [
			"Aktivní šablony",
			"Aktívne šablóny",
			"Active templates",
			"Aktywne szablony",
			"Aktív sablonok",
		],
		"type": [
			"Typ",
			"Typ",
			"Type",
			"Typ",
			"Típus",
		],
		"file_too_big": [
			"Soubor je příliš velký. Maximální velikost je 0,5 MB",
			"Súbor je príliš veľký",
			"File is too big. Maximum size is 0,5 MB",
			"Plik jest za duży. Maksymalny rozmiar to 0,5 MB",
			"A fájl túl nagy. A maximális méret 0,5 MB",
		],
		"file": [
			"Soubor",
			"Súbor",
			"File",
			"Plik",
			"Fájl",
		],
		"bitmap": [
			"Obrázek",
			"Obrázok",
			"Image",
			"Obraz",
			"Kép",
		],
		"polygon": [
			"Polygon",
			"Polygon",
			"Polygon",
			"Polygon",
			"Poligon",
		],
		"bezier": [
			"Křivka",
			"Krivka",
			"Curve",
			"Krzywa",
			"Görbe",
		],
		"line": [
			"Čára",
			"Čiara",
			"Line",
			"Linia",
			"Vonal",
		],
		"line_cap": [
			"Zakončení čáry",
			"Zakončenie čiary",
			"Line Cap",
			"Koniec linii",
			"Vonalvégződés",
		],
		"line_join": [
			"Napojení čáry",
			"Napojenie čiary",
			"Line Join",
			"Połączenie linii",
			"Vonali csatlakozás",
		],
		"line_cap_round": [
			"oblé",
			"oblé",
			"round",
			"okrągły",
			"lekerekített",
		],
		"line_cap_inherit": [
			"-",
			"-",
			"-",
			"-",
			"-",
		],
		"line_cap_butt": [
			"plochou hranou",
			"plochou hranou",
			"butt",
			"płaska krawędź",
			"levágott",
		],
		"line_cap_square": [
			"čtvercové",
			"štvorcové",
			"square",
			"kwadrat",
			"négyzetes",
		],
		"line_join_inherit": [
			"-",
			"-",
			"-",
			"-",
			"-",
		],
		"line_join_miter": [
			"ostrý roh",
			"ostrý roh",
			"miter",
			"ostry róg",
			"éles sarok",
		],
		"line_join_round": [
			"oblé",
			"oblé",
			"round",
			"okrągły",
			"lekerekített",
		],
		"line_join_bevel": [
			"zkosený roh",
			"skosený roh",
			"bevel",
			"ścięty narożnik",
			"levágott sarok",
		],
		"collage_layouts": [
			"Koláže",
			"Koláže",
			"Collages",
			"Kolaże",
			"Kollázsok",
		],
		"add_layout_button": [
			"Vlastní",
			"Vlastné",
			"Custom",
			"Dodaj",
			"Egyéni",
		],
		"save_as_new_collage": [
			"Uložit jako novou koláž",
			"Uložiť ako novú koláž",
			"Save as new collage",
			"Zapisz jako nowy kolaż",
			"Mentés új kollázsként",
		],
		"preview_for_format": [
			"Náhled pro formát",
			"Náhľad pre formát",
			"Preview for format",
			"Podgląd formatu",
			"Formátum előnézet",
		],
		"no_custom_sets": [
			"Nemáte zatím žádné vlastní sady obrázků",
			"Nemáte zatiaľ žiadne vlastné sady obrázkov",
			"You have no custom image sets yet",
			"Nie masz jeszcze żadnych niestandardowych zestawów obrazów",
			"Még nincs egyéni képkészlete",
		],
		"custom_image_set_add": [
			"Vytvořit sadu obrázků",
			"Vytvoriť sadu obrázkov",
			"Create image set",
			"Utwórz zestaw obrazów",
			"Egyéni képkészlet létrehozása",
		],
		"custom_image_set_remove": [
			"Smazat sadu obrázků",
			"Zrušiť sadu obrázkov",
			"Delete image set",
			"Anuluj zestaw zdjęć",
			"Képkészlet törlése",
		],
		"custom_image_set_remove_image": [
			"Vymazat obrázek ze sady",
			"Vymazať obrázok zo sady",
			"Delete image from set",
			"Usuń obraz z zestawu",
			"Kép törlése a készletből",
		],
		"custom_image_set_selected_image": [
			"Vybraný obrázek",
			"Vybraný obrázok",
			"Selected image",
			"Wybrany obraz",
			"Kijelölt kép",
		],
		"custom_image_set_selected": [
			"Obrázky ze sady",
			"Obrázky zo sady",
			"Images from set",
			"Obrazy z zestawu",
			"Képek a készletből",
		],
		"custom_set_name": [
			"Název sady obrázků",
			"Názov sady obrázkov",
			"Custom set name",
			"Nazwa zestawu obrazów",
			"Képkészlet neve",
		],
		"custom_image_set_no_set_selected": [
			"Vyberte sadu",
			"Vyberte sadu",
			"Select image set",
			"Wybierz zestaw",
			"Készlet kiválasztása",
		],
		"custom_image_set_no_images_yet": [
			"V této sadě nejsou zatím žádné obrázky.",
			"V tejto sade nie sú zatiaľ žiadne obrázky.",
			"There are no images in this set.",
			"W tym zestawie nie ma jeszcze zdjęć.",
			"Ebben a készletben még nincs kép.",
		],
		"custom_image_set_no_image_selected": [
			"Vyberte obrázek",
			"Vyberte obrázok",
			"No image selected",
			"Wybierz obraz",
			"Kép kiválasztása",
		],
		"custom_image_set_uploaded": [
			"Obrázek byl nahrán do sady",
			"Obrázok bol nahraný do sady",
			"The image was uploaded",
			"Obraz przesłany do zestawu",
			"A kép fel lett töltve a készletbe",
		],
		"custom_image_set_cannot_remove_is_used": [
			"Obrázek je používán v některé ze šablon! Nelze smazat.",
			"Obrázok je používaný v niektorej zo šablón! Nemožno zmazať",
			"The image is used in a template! It cannot be removed.",
			"Obraz jest używany w jednym z szablonów! Nie można usunąć.",
			"A képet az egyik sablon használja! Nem törölhető.",
		],
		"custom_image_set_cannot_remove_success": [
			"Obrázek byl smazán.",
			"Obrázok bol zmazaný.",
			"The image was deleted.",
			"Obraz usunięty.",
			"A kép törölve.",
		],
		"custom_image_set_deleted_success": [
			"Sada byla smazána",
			"Sada bola zmazaná",
			"The image set was deleted.",
			"Zestaw został usunięty",
			"A készlet törölve",
		],
		"custom_image_set_delete_set_is_used": [
			"Nelze smazat tuto sadu, je použita v šablonách.",
			"Nie je možné zmazať túto sadu, je použitá v šablónach.",
			"This image set cannot be deleted since some of the images from the set are used in templates.",
			"Nie można usunąć tego zestawu, jest używany w szablonach.",
			"A készlet nem törölhető, egyes képeket sablonok használnak.",
		],
		"scale": [
			"Velikost",
			"Pomer veľkosti",
			"Scale",
			"Wielkość",
			"Méret",
		],
		"adjust_size": [
			"Přizpůsobení velikosti produktu",
			"Prispôsobenie veľkosti produktu",
			"Product size customization",
			"Personalizacja rozmiaru produktu",
			"Termékméret testreszabása",
		],
		"enlarge": [
			"Přizpůsobit velikost obrázku",
			"Prispôsobiť veľkosť obrázku",
			"Adjust dimensions",
			"Dopasuj do formatu",
			"Képméret korrekció",
		],
		"no_enlarge_nor_crop": [
			"žádné přizpůsobení",
			"žiadne prispôsobenie",
			"no adjustment",
			"bez dostosowania",
			"nincs korrekció",
		],
		"duplicate": [
			"Duplikovat šablonu",
			"Duplikovať šablónu",
			"Duplicate the template",
			"Szablon powielony",
			"Sablon duplikálása",
		],
		"horizontal_flip": [
			"Překlopit horizontálně",
			"Preklopiť horizontálne",
			"Flip horizontally",
			"Odwróć w poziomie",
			"Vízszintes tükrözés",
		],
		"vertical_flip": [
			"Překlopit vertikálně",
			"Preklopiť vertikálne",
			"Flip vertically",
			"Odwróć w pionie",
			"Függőleges tükrözés",
		],
		"flip": [
			"Vertikálně",
			"Vertikálne",
			"Vertical",
			"Pionowo",
			"Függőlegesen",
		],
		"flop": [
			"Horizontálně",
			"Horizontálne",
			"Horizontal",
			"Poziomo",
			"Vízszintesen",
		],
		"rotation": [
			"Pootočení",
			"Pootočenie",
			"Rotation",
			"Obróć",
			"Elforgatás",
		],
		"elements": [
			"Název elementu ze kterého vložit obsah",
			"Názov elementu, z ktorého chcete vložiť obsah",
			"Name of the attribute",
			"Nazwa elementu, z którego należy wstawić treść",
			"Az elem neve, amiből a tartalom beillesztendő",
		],
		"xml_element_name": [
			"Název elementu",
			"Názov elementu",
			"Attribute name",
			"Nazwa elementu",
			"Elem neve",
		],
		"rating_xml_element": [
			"Element s hodnocením",
			"Element s hodnotením",
			"Rating element",
			"Element z oceną",
			"Egy elem minősítéssel",
		],
		"rating_count_xml_element": [
			"Element s počtem hodnocení",
			"Element s počtom hodnotení",
			"Rating count element",
			"Element z wieloma ocenami",
			"Számos minősítéssel rendelkező elem",
		],
		"rating_max_value": [
			"Maximální hodnota v elementu s hodnocením",
			"Maximálna hodnota v elemente s hodnotením",
			"Maximum value in a rated element",
			"Maksymalna wartość w elemencie ocenianym",
			"Maximális érték egy értékelt elemben",
		],
		"rating_hide_empty": [
			"Pouze jsou-li dostupné všechny elementy z feedu",
			"Iba ak sú dostupné všetky elementy z feedu",
			"Only if all elements from the feed are available",
			"Tylko jeśli wszystkie elementy z kanału są dostępne",
			"Csak akkor, ha a hírcsatorna összes eleme elérhető",
		],
		"rating_min_stars": [
			"Zobrazovat hodnocení od",
			"Zobrazovať hodnotenie od",
			"Show ratings from",
			"Pokaż oceny od",
			"Értékelések megjelenítése innen",
		],
		"no_rating_yet": [
			"Tento produkt dosud nikdo nehodnotil",
			"Tento produkt zatiaľ nikto nehodnotil",
			"No one has reviewed this product yet",
			"Nikt jeszcze nie ocenił tego produktu",
			"Még senki sem értékelte ezt a terméket",
		],
		"empty_element": [
			"<ELEMENT JE PRÁZDNÝ>",
			"<ELEMENT JE PRÁZDNY>",
			"<EMPTY ATTRIBUTE>",
			"<ELEMENT JEST PUSTY>",
			"<AZ ELEM ÜRES>",
		],
		"imagick_fonts": [
			"Font",
			"Font",
			"Font",
			"Czcionka",
			"Betűtípus",
		],
		"imagick_fonts_family": [
			"Filtrovat rodinu písem",
			"Filtrovať rodinu písiem",
			"Filter font family",
			"Filtruj rodzinę czcionek",
			"Betűtípuscsalád szűrése",
		],
		"imagick_fonts_style": [
			"Styl",
			"Štýl",
			"Style",
			"Styl",
			"Stílus",
		],
		"imagick_fonts_info": [
			"Upozornění: některé fonty pro dynamický text nejsou v rychlém náhledu dostupné a tedy se nemusejí zobrazovat stejně jako vysledný vygenerovaný obrázek. Pro ukázku textu ve vybraném fontu použijte prosím tlačítko Náhled.",
			"Upozornenie: niektoré fonty pre dynamický text nie sú dostupné a teda sa nemusia zobrazovať rovnako, ako výsledný vygenerovaný obrázok. Pre ukážku textu vo vybranom fonte použite tlačidlo Náhľad.",
			"Warning: some fonts used for dynamic content are not available in the live preview so the preview image may differ from the final image. Please, use the Preview button to display text in the selected font.",
			"Uwaga: niektóre dynamiczne czcionki tekstowe nie są dostępne w szybkim widoku. Nie mogą być wyświetlane w taki sam sposób, jak wygenerowany obraz. Aby wyświetlić podgląd tekstu w wybranej czcionce, użyj przycisku Podgląd.",
			"Figyelmeztetés: a dinamikus szöveg egyes betűtípusai gyors előnézetben nem állnak rendelkezésre, ezért az előnézeti kép eltérhet a generált képtől. Kérjük, használja az Előnézet gombot a kiválasztott betűtípusú szöveg megjelenítéséhez.",
		],
		"render_preview": [
			"Náhled",
			"Náhľad",
			"Render preview",
			"Podgląd",
			"Előnézet",
		],
		"rotate_right": [
			"Pootočit doprava",
			"Pootočiť doprava",
			"Rotate right",
			"Obróć w prawo",
			"Forgatás jobbra",
		],
		"rotate_left": [
			"Pootočit doleva",
			"Pootočiť doľava",
			"Rotate left",
			"Obróć w lewo",
			"Forgatás balra",
		],
		"image_enlargment": [
			"Zvětšení obrázku",
			"Zväčšenie obrázkov",
			"Image enlargement",
			"Powiększ obraz",
			"Kép nagyítása",
		],
		"format": [
			"Formát",
			"Formát",
			"Format",
			"Format",
			"Formátum",
		],
		"first": [
			"První",
			"Prvá",
			"First",
			"Pierwszy",
			"Első",
		],
		"last": [
			"Poslední",
			"Posledná",
			"Last",
			"Ostatni",
			"Utolsó",
		],
		"previews": [
			"Náhledy",
			"Náhľady",
			"Preview",
			"Podgląd",
			"Előnézetek",
		],
		"more_previews": [
			"Další náhledy",
			"Ďalšie náhľady",
			"More Previews",
			"Więcej podglądów",
			"További előnézetek",
		],
		"edit_template": [
			"Upravit šablonu",
			"Upraviť šablónu",
			"Edit template",
			"Edytuj szablon",
			"Sablon szerkesztése",
		],
		"no_templates_this_size": [
			"Takové šablony zatím nemáte",
			"Takéto šablóny zatiaľ nemáte",
			"You have no template of this size yet",
			"Nie masz jeszcze takich szablonów",
			"Ilyen sablon még nincs",
		],
		"all_templates": [
			"Všechny šablony",
			"Všetky šablóny",
			"All templates",
			"Wszystkie szablony",
			"Összes sablon",
		],
		"reload_images": [
			"Další náhledy",
			"Ďalšie náhľady",
			"Reload images",
			"Więcej podglądów",
			"További előnézetek",
		],
		"show_unmodified": [
			"Zobrazit neupravené",
			"Zobraziť neupravené",
			"Show original",
			"Pokaż niezmodyfikowany",
			"Eredeti megjelenítése",
		],
		"show_modified": [
			"Zobrazit upravené",
			"Zobraziť upravené",
			"Show modified",
			"Pokaż modyfikowany",
			"Módosítottak megjelenítése",
		],
		"help": [
			"Nápověda",
			"Nápoveda",
			"Help",
			"Pomoc",
			"Súgó",
		],
		"manage_templates": [
			"Spravovat šablony",
			"Spravovať šablóny",
			"Manage templates",
			"Zarządzaj szablonami",
			"Sablonok kezelése",
		],
		"inactive_templates": [
			"Neaktivní šablony",
			"Neaktívne šablóny",
			"Inactive templates",
			"Nieaktywne szablony",
			"Inaktív sablonok",
		],
		"show_template": [
			"Zobrazit šablonu",
			"Zobraziť šablónu",
			"Show templates",
			"Pokaż szablon",
			"Sablon megjelenítése",
		],
		"no_image": [
			"Produkt nemá obrázek.",
			"Produkt nemá obrázok.",
			"Product has no image.",
			"Produkt nie ma zdjęcia.",
			"A termékhez nincs kép.",
		],
		"active_templates_only": [
			"Pouze aktivní šablony",
			"Iba aktívne šablóny",
			"Active templates only",
			"Tylko aktywne szablony",
			"Csak aktív sablonok",
		],
		"unmodified_images": [
			"Neupravené obrázky",
			"Neupravené obrázky",
			"Original images",
			"Nieedytowane obrazy",
			"Eredeti képek",
		],
		"allow_cache": [
			"Povolit cache",
			"Povoliť cache",
			"Allow cache",
			"Zezwalaj na pamięć podręczną",
			"Gyorsítótár engedélyezése",
		],
		"no_products_in_query": [
			"Výběry pro tuto šablonu neobsahují produkty. Zobrazujeme náhodné produkty z XML feedu.",
			"Výbery produktov pre túto šablónu neobsahujú produkty. Zobrazujeme náhodné produkty z XML feedu.",
			"The product queries for this template are empty. We display a random product from your feed.",
			"Wybory dla tego szablonu zawierają produkty. Wyświetla losowe produkty z kanału XML.",
			"A sablonhoz tartozó szűrők nem tartalmaznak termékeket. Random termékek kerülnek megjelenítésre az XML feedből.",
		],
		"size_format": [
			"Rozměr",
			"Rozmer",
			"Size",
			"Rozmiar",
			"Méret",
		],
		"add_new": [
			"přidat nový",
			"pridať nový",
			"Add new",
			"Dodaj nowy",
			"Új hozzáadása",
		],
		"new": [
			"Nový",
			"Nový",
			"New",
			"Nowy",
			"Új",
		],
		"format_name": [
			"Název formátu",
			"Názov formátu",
			"Format name",
			"Nazwa formatu",
			"Formátum neve",
		],
		"select_format": [
			"Zvolte jeden z výstupních formátů...",
			"Zvoľte jeden z výstupných formátov...",
			"Select the output formats...",
			"Wybierz jeden z formatów wyjściowych...",
			"Válasszon egyet a kimeneti formátumok közül...",
		],
		"query_is_required": [
			"Musíte vybrat alespoň jeden výběr produktu",
			"Musíte vybrať aspoň jeden výber produktu",
			"You have to choose at least one product query",
			"Musisz wybrać co najmniej jeden wybór produktu",
			"Legalább egy termékszűrőt ki kell választani",
		],
		"format_name_is_required": [
			"Musíte vyplnit název rozměru",
			"Musíte vyplniť názov rozmeru",
			"You have to fill the format name",
			"Musisz podać nazwę wymiaru",
			"Ki kell tölteni a méret nevét",
		],
		"width_is_required": [
			"Šířka musí být větší než 0",
			"Šírka musí byť väčšia ako 0",
			"Width must be more than 0",
			"Szerokość musi być większa niż 0.",
			"Szélességnek nagyobbnak kell lennie, mint 0",
		],
		"height_is_required": [
			"Výška musí být větší než 0",
			"Výška musí byť väčšia ako 0",
			"Height must be more than 0",
			"Wysokość musi być większa niż 0.",
			"A magasságnak nagyobbnak kell lennie, mint 0",
		],
		"bad_file_format": [
			"Nepovolený formát souboru",
			"Nepovolený formát súboru",
			"Wrong file format",
			"Niedozwolony format obrazu",
			"Nem megengedett fájlformátum",
		],
		"name_is_required": [
			"Musíte vyplnit název šablony",
			"Musíte vyplniť názov šablóny",
			"You have to fill the template name.",
			"Musisz wypełnić nazwę szablonu",
			"Ki kell tölteni a sablon nevét",
		],
		"error_loading_image": [
			"Chyba při načítání obrázku",
			"Chyba pri načítaní obrázku",
			"An error occured during image loading",
			"Błąd podczas ładowania obrazu",
			"Képbetöltési hiba",
		],
		"confirm__bulk_delete": [
			"Opravdu chcete smazat vybrané šablony?",
			"Naozaj chcete zmazať vybrané šablóny?",
			"Do you really want to delete selected templates?",
			"Czy na pewno chcesz usunąć wybrane szablony?",
			"Tényleg törölni szeretné a kijelölt sablonokat?",
		],
		"svg_change_colors": [
			"Změnit barvy",
			"Zmeniť farby",
			"Change colors",
			"Zmień kolory",
			"Színek módosítása",
		],
		"apply_color_change": [
			"Aplikovat změnu barev",
			"Aplikovať zmenu farieb",
			"Apply color change",
			"Zastosuj zmianę koloru",
			"Színváltoztatás alkalmazása",
		],
		"load_image_error": [
			"Nepodařilo se načíst obrázek",
			"Nepodarilo sa načítať obrázok",
			"Failed to load the image.",
			"Nie udało się załadować obrazu.",
			"Nem sikerült betölteni a képet.",
		],
		"badge": [
			"Samolepka",
			"Samolepka",
			"Badge",
			"Naklejka",
			"Matrica",
		],
		"badges": [
			"Samolepky",
			"Samolepky",
			"Badges",
			"Naklejki",
			"Matricák",
		],
		"icons": [
			"Ikony",
			"Ikony",
			"Icons",
			"Ikony",
			"Ikonok",
		],
		"search_badges_or_icons": [
			"Hledat grafické prvky nebo ikony",
			"Hľadať grafické prvky alebo ikony",
			"Search for graphic elements or icons",
			"Wyszukaj elementy graficzne lub ikony",
			"Keressen grafikai elemeket vagy ikonokat",
		],
		"tags": [
			"Štítky",
			"Štítky",
			"Tags",
			"Etykiety",
			"Címkék",
		],
		"emoji": [
			"Emoji",
			"Emoji",
			"Emoji",
			"Emoji",
			"Emoji",
		],
		"change": [
			"Změnit",
			"Zmeniť",
			"Change",
			"Zmień",
			"Módosítás",
		],
		"summer": [
			"Léto",
			"Leto",
			"Summer",
			"Lato",
			"Nyár",
		],
		"borders": [
			"Rámečky",
			"Rámčeky",
			"Borders",
			"Ramki",
			"Keretek",
		],
		'rating': [
			"Hodnocení",
			"Hodnotenie",
			"Rating",
			"Ranking",
			"Értékelés",
		],
		'rating_source': [
			"Zdroj hodnocení",
			"Zdroj hodnotenia",
			"Rating source",
			"Źródło oceny",
			"Értékelés forrása",
		],
		"xml_element": [
			"XML element",
			"XML element",
			"XML element",
			"XML element",
			"XML element",
		],
		"depots_extension": [
			"Rozšíření Depots",
			"Rozšírenie Depots",
			"Depots extension",
			"Depots extension",
			"Depots extension",
		],
		"depots_not_enabled": [
			"Pro využití Depots jako zdroje hodnocení do obrazků jej aktivujte zdarma v <span class=\"link\" onClick=Mergado.openWindow(\"https://store.mergado.com/detail/mergadodepots/#about\")>Mergado Store</span>.",
			"Pre využitie Depots ako zdroja hodnotenia do obrazkov ho aktivujte zadarmo v <span class=\"link\" onClick=Mergado.openWindow(\"https://store.mergado.com/detail/mergadodepots/#about\")>Mergado Store</span>.",
			"To use Depots as a source of image ratings, activate it for free in the <span class=\"link\" onClick=Mergado.openWindow(\"https://store.mergado.com/detail/mergadodepots/#about\")>Mergado Store</span>.",
			"Aby korzystać z Depots jako źródła ocen obrazów, aktywuj tę funkcję bezpłatnie w sklepie <span class=\"link\" onClick=Mergado.openWindow(\"https://store.mergado.com/detail/mergadodepots/#about\")>Mergado Store</span>.",
			"Ha a Depots-t szeretné képértékelések forrásaként használni, aktiválja ingyenesen a <span class=\"link\" onClick=Mergado.openWindow(\"https://store.mergado.com/detail/mergadodepots/#about\")>Mergado Store</span>-ban.",
		],
		'rating_from_element': [
			"Hodnocení produktů",
			"Hodnotenie produktov",
			"Product ratings",
			"Oceny produktów",
			"Termékértékelések",
		],
		"star_symbol": [
			"Symbol hvězdy",
			"Symbol hviezdy",
			"Star symbol",
			"Symbol gwiazdy",
			"Csillag szimbólum",
		],
		"active_only": [
			"Pouze aktivní",
			"Len aktívne",
			"Active only",
			"Użyj aktywnego",
			"Csak aktív",
		],
		"dynamic_only": [
			"Pouze dynamické",
			"Len dynamické",
			"Dynamic only",
			"Użyj dynamicznego",
			"Csak dinamikus",
		],
		"autumn": [
			"Podzim",
			"Jeseň",
			"Autumn",
			"Jesień",
			"Ősz",
		],
		"showroom": [
			"Náhledy šablon",
			"Náhľady šablón",
			"Templates previews",
			"Podgląd szablonu",
			"Sablon előnézetek",
		],
		"translate": [
			"Posunutí",
			"Posunutie",
			"Translation",
			"Przenieś",
			"Eltolás",
		],
		"crop": [
			"Oříznout obrázek",
			"Orezať obrázok",
			"Crop image",
			"Przytnij",
			"Kép kivágása",
		],
		"image_format": [
			"Velikost obrázku produktu",
			"Veľkosť obrázku produktu",
			"Product image size",
			"Wielkość zdjęcia produktu",
			"Termékkép mérete",
		],
		"enlarge_hint": [
			"Velikost obrázku produktu se upraví tak, aby vždy vyplnila požadovaný formát (při zachování poměru stran)",
			"Veľkosť obrázku produktu sa upraví tak, aby vždy vyplnila požadovaný formát (pri zachování pomeru strán)",
			"Product image size is adjusted to always fill the requested format (while keeping the aspect ratio).",
			"Rozmiar obrazu produktu zostanie dostosowany tak, aby zawsze wypełniał żądany format (zachowując proporcje)",
			"Termékkép mérete úgy van beállítva, hogy mindig kitöltse a kért formátumot (az oldalarány fenntartásával).",
		],
		"crop_hint": [
			"Pokud je obrázek produktu větší než nastavený formát, systém ho automaticky ořízne.",
			"Ak je obrázok produktu väčší ako nastavený formát, systém ho automaticky oreže.",
			"If the product image is bigger than the set format, it will be automatically cropped.",
			"Jeśli obraz produktu jest większy niż ustawiony format, system automatycznie go przyciął.",
			"Ha a termékkép nagyobb, mint a beállított formátum, automatikusan levágásra kerül.",
		],
		"winter": [
			"Vánoce",
			"Vianoce",
			"Christmas",
			"Boże Narodzenie",
			"Karácsony",
		],
		"vertical_align_center": [
			"Vycentrovat vertikálně",
			"Vycentrovať vertikálne",
			"Center vertically",
			"Wyśrodkuj w pionie",
			"Függőleges középre igazítás",
		],
		"horizontal_align_center": [
			"Vycentrovat horizontálně",
			"Vycentrovať horizontálne",
			"Center horizontally",
			"Wyśrodkuj w poziomie",
			"Vízszintes középre igazítás",
		],
		"enlarge_by": [
			"Přizpůsobení velikosti obrázku dle",
			"Prispôsobenie veľkosti obrázku podľa",
			"Enlarge image by",
			"Dostosowywanie rozmiaru obrazu według",
			"A kép méretének beállítása a kívánt méretnek megfelelően",
		],
		"by_width": [
			"šířky obrázku",
			"šírky obrázku",
			"width",
			"Szerokość zdjęcia",
			"kép szélessége",
		],
		"by_height": [
			"výšky obrázku",
			"výšky obrázku",
			"height",
			"Wysokość zdjęcia",
			"kép magassága",
		],
		"by_smaller": [
			"menšího rozměru obrázku",
			"menšieho rozmeru obrázku",
			"smaller dimension",
			"mniejszy rozmiar obrazu",
			"kisebb képméret",
		],
		"by_bigger": [
			"většího rozměru obrázku",
			"väčšieho rozmeru obrázku",
			"bigger dimension",
			"większy rozmiar obrazu",
			"nagyobb képméret",
		],
		"by_fit": [
			"fit na rozměry výstupního formátu",
			"fit na rozmery výstupného formátu",
			"fit the output dimensions",
			"dopasowanie obrazu wyjściowego",
			"a kimeneti formátum méreteihez igazodva",
		],
		"max_image_width": [
			"Max šířka obrázku (px)",
			"Max šírka obrázku (px)",
			"Max image width (px)",
			"Maksymalna szerokość obrazu (px)",
			"Maximális képszélesség (px)",
		],
		"max_image_height": [
			"Max výška obrázku (px)",
			"Max výška obrázku (px)",
			"Max image height (px)",
			"Maksymalna wysokość obrazu (px)",
			"Maximális képmagasság (px)",
		],
		"by_max_size": [
			"Nastavit max velikost (px)",
			"Nastaviť max veľkosť (px)",
			"Set max size (px)",
			"Ustaw maksymalny rozmiar (px)",
			"Maximális méret beállítása (px)",
		],
		"by_overscan": [
			"Nastavit přesah (px)",
			"Nastaviť presah (px)",
			"Set Overlap (px)",
			"Ustaw nakładanie (px)",
			"Átfedés beállítása (px)",
		],
		"overscan": [
			"Ochranná zóna",
			"Ochranná zóna",
			"Protection zone",
			"Strefa ochronna",
			"Védőövezet",
		],
		"overscan_hint": [
			"Zde si můžete nastavit, o kolik pixelů se má obrázek zmenšit oproti velikosti původního formátu. Můžete zde nastavit kladnou i zápornou hodnotu. Kladnou hodnotou dosáhnete orámování původního obrázku nastavenou podkladovou barvou, zápornou zvětšení.",
			"Tu si môžete nastaviť, o koľko pixelov sa má obrázok zmenšiť oproti veľkosti pôvodného formátu. Môžete tu nastaviť kladnú aj zápornú hodnotu. Kladnou hodnotou dosiahnete orámovanie pôvodného obrázku nastavenou podkladovou farbou, zápornou zväčšenie.",
			"Here you can set by how many pixels the image should be reduced compared to the size of the original format. You can set a positive or negative value here. With a positive value, you achieve framing of the original image with the set background color, negative magnification.",
			"Tutaj możesz ustawić, o ile pikseli obraz ma zostać zmniejszony w porównaniu do rozmiaru oryginalnego formatu. Można tutaj ustawić wartość dodatnią lub ujemną. Przy wartości dodatniej uzyskujesz kadrowanie oryginalnego obrazu z ustawionym kolorem tła, ujemne powiększenie.",
			"Itt beállíthatja, hogy a kép hány pixellel legyen kicsinyítve az eredeti formátum méretéhez képest. Itt beállíthat pozitív vagy negatív értéket. Pozitív értékkel az eredeti kép keretezését éri el a beállított háttérszínnel, negatív nagyítással.",
		],
		"enlarge_by_hint": [
			"Zde si zvolte, podle jakého rozměru se mají obrázky produktů přizpůsobit do velikosti formátu. U všech zdrojových obrázků se vždy zachovává poměr stran.",
			"Tu si zvoľte, podľa akého rozmeru sa majú obrázky produktov prispôsobiť do veľkosti formátu. Pri všetkých zdrojových obrázkoch sa vždy zachováva pomer strán.",
			"Here you can choose according to which dimension should images be adjusted to format size. All source images always keep the aspect ratio.",
			"„Wybierz rozmiar obrazu produktu, aby dopasować go do formatu. Zawsze zachowuj proporcje dla wszystkich obrazów źródłowych.",
			"Itt kiválaszthatja, hogy a termékképeket milyen formátummérethez szeretné igazítani. Az oldalarány minden forráskép esetében mindig fenntartásra kerül.",
		],
		"enlarge_by_blog_link": [
			"Podrobnější vysvětlení",
			"Podrobnejšie vysvetlenie",
			"A more detailed explanation",
			"Bardziej szczegółowe wyjaśnienie",
			"Részletesebb magyarázat",
		],
		"error_save_template": [
			"Při ukládání šablony se vyskytla chyba",
			"Pri ukladaní šablóny sa vyskytla chyba.",
			"An error occured while trying to save template",
			"Wystąpił błąd podczas zapisywania szablonu",
			"Hiba történt a sablon mentése során",
		],
		"free-delivery": [
			"Dny dopravy zdarma",
			"Dni dopravy zdarma",
			"Free delivery days",
			"Dni darmowej dostawy",
			"Ingyenes szállítási napok",
		],
		"black-friday": [
			"BLACK FRIDAY   &   CYBER MONDAY",
			"BLACK FRIDAY   &   CYBER MONDAY",
			"BLACK FRIDAY   &   CYBER MONDAY",
			"BLACK FRIDAY   &   CYBER MONDAY",
			"BLACK FRIDAY   &   CYBER MONDAY",
		],
		"valentine": [
			"Valentýn",
			"Valentín",
			"Valentine\'s Day",
			"Walentynki",
			"Valentin-nap",
		],
		"easter": [
			"Velikonoce",
			"Veľká noc",
			"Easter",
			"Wielkanoc",
			"Húsvét",
		],
		"generic": [
			"Univerzální šablony",
			"Univerzálne šablóny",
			"Generic templates",
			"Uniwersalne szablony",
			"Univerzális sablonok",
		],
		"source_image": [
			"Zdrojový obrázek",
			"Zdrojový obrázok",
			"Source image",
			"Obraz źródłowy",
			"Forráskép",
		],
		"sourceImage": [
			"Zdrojový obrázek",
			"Zdrojový obrázok",
			"Source image",
			"Obraz źródłowy",
			"Forráskép",
		],
		"edit_shape": [
			"Editace vrstvy",
			"Editácia vrstvy",
			"Edit layer",
			"Edycja warstw",
			"Rétegszerkesztés",
		],
		"new_shape": [
			"Nová vrstva",
			"Nová vrstva",
			"New layer",
			"Nowa warstwa",
			"Új réteg",
		],
		"modal_close": [
			"Zavřít",
			"Zavrieť",
			"Close",
			"Zamknij",
			"Bezárás",
		],
		"done": [
			"Hotovo",
			"Hotovo",
			"Done",
			"Gotowy",
			"Kész",
		],
		"general_error": [
			"Chyba",
			"Chyba",
			"Error",
			"Błąd",
			"Hiba",
		],
		"validation_error_fields.queries": [
			"Nebyly vybrány produkty.",
			"Neboli vybrané produkty.",
			"No products selected.",
			"Nie wybrano żadnych produktów.",
			"Nincs kiválasztva termék.",
		],
		"validation_error_fields.shapes": [
			"Šablona je prázdná.",
			"Šablóna je prázdna.",
			"Template is empty.",
			"Szablon jest pusty.",
			"A sablon üres.",
		],
		"validation_error_queries": [
			"Nebyly vybrány produkty.",
			"Neboli vybrané produkty.",
			"No products selected.",
			"Nie wybrano żadnych produktów.",
			"Nincs kiválasztva termék.",
		],
		"validation_error_size.id": [
			"Chybí formát výsledného obrázku.",
			"Chýba formát výsledného obrázku.",
			"No image format selected.",
			"Brakuje ostatecznego formatu obrazu.",
			"Nincs kiválasztott képformátum.",
		],
		"validation_error_name": [
			"Chybí název.",
			"Chýba názov.",
			"Name is empty",
			"Błąd nazwy",
			"Nincs megadva név.",
		],
		"validation_error_setName": [
			"Chybí název sady",
			"Chýba názov setu",
			"Set name cannot be empty",
			"Brak nazwy zestawu.",
			"Nincs megadva készletnév",
		],
		"validation_error_visual_similarity_templateids": [
			"Vyberte šablony, ve kterých chcete hledat podobné produkty.",
			"Vyberte šablóny, v ktorých chcete hľadať podobné produkty.",
			"Select the templates in which you want to search for similar products.",
			"Wybierz szablony, w których chcesz szukać podobnych produktów.",
			"Válassza ki azokat a sablonokat, amelyekben hasonló termékeket szeretne keresni.",
		],
		"shape_name": [
			"Název vrstvy",
			"Názov vrstvy",
			"Layer name",
			"Nazwa warstwy",
			"Rétegnév",
		],
		"shape_badge_set_change": [
			"Změnit set",
			"Zmeniť set",
			"Select another set",
			"Zmień zestaw",
			"Készletváltás",
		],
		"delete_shape": [
			"Smazat vrstvu",
			"Zmazať vrstvu",
			"Delete layer",
			"Usuń warstwę",
			"Réteg törlése",
		],
		"edit_done": [
			"OK",
			"OK",
			"OK",
			"OK",
			"OK",
		],
		"loading": [
			"Načítám...",
			"Načítavam...",
			"Loading...",
			"Ładowanie ...",
			"Betöltés folyamatban...",
		],
		"low_contrast": [
			"Nízký kontrast",
			"Nízky kontrast",
			"Low contrast",
			"Niski kontrast",
			"Alacsony kontraszt",
		],
		"same_image_in_preview": [
			"Stejný produkt v náhledu",
			"Rovnaký produkt v náhľade",
			"Same product in preview",
			"Ten sam produkt w podglądzie",
			"Ugyanaz a termék előnézetben",
		],
		"processed_at": [
			"Datum zpracování",
			"Dátum spracovania",
			"Processed on",
			"Data modyfikacji",
			"Feldolgozás dátuma",
		],
		"total_processed": [
			"zpracováno",
			"spracované",
			"processed",
			"Pretworzono",
			"feldolgozva",
		],
		"with_status_ok": [
			"bez chyb",
			"bez chýb",
			"without error",
			"Bez błędów",
			"hiba nélkül",
		],
		"with_status_error": [
			"chybných",
			"chybných",
			"with error",
			"Błednych",
			"hibásak",
		],
		"without_images": [
			"bez obrázků",
			"bez obrázkov",
			"without images",
			"Bez obrazów",
			"képek nélkül",
		],
		"image_link": [
			"Adresa obrázku",
			"Adresa obrázku",
			"Image link",
			"Adres obrazu",
			"Képhivatkozás",
		],
		"content_length": [
			"Velikost souboru",
			"Veľkosť súboru",
			"Content length",
			"Rozmiar pliku",
			"Fájlméret",
		],
		"probability": [
			"Pravděpodobnost",
			"Pravdepodobnosť",
			"Probability",
			"Prawdopodobieństwo",
			"Valószínűség",
		],
		"showGroup": [
			"Skupina",
			"Skupina",
			"Group",
			"Grupa",
			"Csoport",
		],
		"user_set": [
			"Nastaveno uživatelem",
			"Nastavené užívateľom",
			"Set by user",
			"Zestaw użytkownika",
			"Felhasználó által beállítva",
		],
		"status_code": [
			"stavový kód",
			"kód stavu",
			"status code",
			"Kod statusu",
			"állapotkód",
		],
		"error": [
			"chyba",
			"chyba",
			"error",
			"Błąd",
			"hiba",
		],
		"status_null": [
			"?",
			"?",
			"?",
			"?",
			"?",
		],
		"status_0_0": [
			"V době zpracování nedostupný",
			"V dobe spracovania nedostupný",
			"Unavailable at the time of processing",
			"W czasie przetwarzania niedostępny",
			"A feldolgozás időpontjában nem áll rendelkezésre",
		],
		"status_200_0": [
			"V pořádku",
			"V poriadku",
			"Status ok",
			"W porządku",
			"Sikeres kérés",
		],
		"status_200_null": [
			"V pořádku",
			"V poriadku",
			"Status ok",
			"W porządku",
			"Sikeres kérés",
		],
		"status_200_1": [
			"Nulová velikost obrázku",
			"Nulová veľkosť obrázku",
			"Zero size image",
			"Obraz o zerowym rozmiarze",
			"Nullás képméret",
		],
		"status_200_435": [
			"Chybí šablona",
			"Chýba šablóna",
			"Template file missing",
			"Brak szablonu",
			"Hiányzó sablon",
		],
		"status_200_425": [
			"Too Early",
			"Too Early",
			"Too Early",
			"Too Early",
			"Too Early",
		],
		"status_200_450": [
			"Neznámý formát",
			"Neznámy formát",
			"Unknown format",
			"Nieznany format",
			"Ismeretlen formátum",
		],
		"status_500_0": [
			"Interní chyba serveru",
			"Interná chyba servera",
			"Internal server error",
			"Wewnętrzny błąd serwera",
			"Belső szerverhiba",
		],
		"status_503_0": [
			"Služba je nedostupná",
			"Služba je nedostupná",
			"Service Unavailable",
			"Serwis niedostępny",
			"A szolgáltatás nem elérhető",
		],
		"status_400_0": [
			"Chybný požadavek",
			"Chybná požiadavka",
			"Bad Request",
			"Zła prośba",
			"Rossz kérés",
		],
		"status_404_0": [
			"Stránka nenalezena",
			"Stránka nenájdená",
			"Page not found",
			"Nieznaleziono strony",
			"Az oldal nem található",
		],
		"status_404_null": [
			"Stránka nenalezena",
			"Stránka nenájdená",
			"Page not found",
			"Nieznaleziono strony",
			"Az oldal nem található",
		],
		"status_403_0": [
			"Přístup odmítnut",
			"Prístup odmietnutý",
			"Forbidden",
			"Brak dostępu",
			"Nincs jogosultság",
		],
		"status_200_420": [
			"Neznámý formát",
			"Neznámy formát",
			"Unknown format",
			"Nieznany format",
			"Ismeretlen formátum",
		],
		"status_429_0": [
			"Příliš mnoho požadavků",
			"Príliš veľa žiadostí",
			"Too Many Requests",
			"Zbyt wiele próśb",
			"Túl sok kérés",
		],
		"status_200_465": [
			"Výška nebo šířka obrázku přesahuje limit",
			"Výška alebo šírka obrázka presahuje limit",
			"Width or height exceeds limit",
			"Wysokość lub szerokość obrazu przekracza limit",
			"A kép magassága vagy szélessége meghaladja a korlátot",
		],
		"status_too_many_alts": [
			"Mnoho alternativních obrázků",
			"Mnoho alternatívnych obrázkov",
			"Too many alternative images",
			"Wiele alternatywnych zdjęć",
			"Túl sok alternatív kép",
		],
		"status_same_images": [
			"Produkty se stejným obrázkem",
			"Produkty s rovnakými obrázkami",
			"Products with the same image",
			"Produkty z tym samym obrazem",
			"Azonos képpel rendelkező termékek",
		],
		"status_empty_images": [
			"Chybějící obrázky",
			"Chýbajúce obrázky",
			"Missing images",
			"Brakujące obrazy",
			"Hiányzó képek",
		],
		"status_empty_images_description": [
			"Ve vašem XML feedu chybí u produktů element IMGURL. Produkty nejsou propojené s obrázky, anebo obrázkové soubory úplně chybí. Důsledkem toho se nebudou ve vašem e-shopu ani ve srovnávačích zobrazovat. ",
			"Vo vašom xml feede chýba u produktov element IMGURL. Produkty nie sú prepojené s obrázkami, alebo obrázkové súbory úplne chýbajú. Dôsledkom toho sa nebudú vo vašom e-shope ani v porovnávačoch zobrazovať.",
			"Your XML feed is missing the IMGURL tag for your products. Products are not linked to images, or image files are completely missing. As a result, they will not appear in your online store or comparison shopping engines.",
			"W pliku XML brakuje elementu IMGURL dla Twoich produktów. Produkty nie są sparowane ze zdjęciami lub całkowicie brakuje plików obrazów. W rezultacie nie pojawią się one w twoim sklepie internetowym ani w komparatorach.",
			"Hiányzik a termékekhez tartozó IMGURL elem az XML feedben. A termékek nem kapcsolódnak képekhez, vagy a képfájlok teljesen hiányoznak. Ennek következtében nem jelennek meg sem a webáruházában, sem az árösszehasonlító oldalakon. ",
		],
		"status_unavailable_description": [
			"Webová stránka, kde jsou obrázky uložené, nebyla nalezena.",
			"Webová stránka, kde sú obrázky uložené, nebola nájdená.",
			"The web page where the images are stored could not be found.",
			"Jiný status než 200",
			"A képeket tároló weboldal nem található.",
		],
		"status_unsupported_mime_type_description": [
			"Formát souboru, na který URL adresa odkazuje nepatří mezi standardní obrázkové formáty. Produktové obrázky se nebudou zobrazovat.",
			"Formát súboru, na ktorý URL adresa odkazuje nepatrí medzi štandardné obrázkové formáty. Produktové obrázky sa nebudú zobrazovať.",
			"The file format to which the URL refers does not belong to the standard image format. Product images will not appear in your store.",
			"Format pliku, do którego odwołuje się URL, nie jest obsługiwany przez jedną z porównywarek lub nie jest ustandaryzowany. W pierwszym przypadku zdjęcia produktów zostaną odrzucone przez porównywarkę, w drugim nie zostaną wyświetlone w Twoim sklepie internetowym.",
			"A fájlformátum, amelyre az URL hivatkozik, nem szabványos képformátum. A termékképek nem jelennek majd meg a webáruházban.",
		],
		"status_invalid_url_description": [
			"Produktové obrázky mohou být srovnávači zamítnuty, když je jejich URL adresa příliš dlouhá, nebo obsahuje znaky, které nejsou podle kritérií povolené. Častým problémem je diakritika či mezery v názvu obrázku.",
			"Produktové obrázky môžu byť porovnávačmi zamietnuté, ak je ich URL adresa príliš dlhá alebo obsahuje znaky, ktoré nie sú podľa kritérií povolené. Častým problémom je diakritika alebo medzery v názve obrázkov.",
			"Product images can be rejected by the comparison engine if their URL is too long or contains characters that are not allowed by the criteria. A common problem is accents or spaces in the image name.",
			"Zdjęcia produktów mogą zostać odrzucone przez porównywarkę, jeśli adres URL jest za długi lub zawiera niedozwolone znaki takie jak np. spacje.",
			"Az árösszehasonlító oldalak elutasíthatják a termékképeket, ha az URL túl hosszú, vagy olyan karaktereket tartalmaz, amelyeket a kritériumok nem engedélyeznek. Gyakori probléma az írásjel vagy szóköz a kép nevében.",
		],
		"has_watermark_description": [
			"Pokud chráníte vaše produktové obrázky vodoznaky, počítejte s tím, že reklamní systémy jako Heureka, GLAMI, FAVI či Google Nákupy vám tyto produkty nezobrazí.",
			"Ak chránite svoje produktové obrázky vodoznakmi, počítajte s tým, že reklamné systémy ako Heureka, GLAMI, FAVI či Google Nákupy vám tieto produkty nezobrazia.",
			"If you're protecting your product images with watermarks, be aware that advertising systems like Heureka, GLAMI, FAVI and Google Shopping won't show you these products.",
			"Wiele systemów reklamowych jak np. Google, nie wyświetla produktów na które naniesiony jest znak wodny. ",
			"Ha vízjelekkel védi a termékképeket, számoljon azzal, hogy a Heureka, a GLAMI, a FAVI vagy a Google Shopping típusú hirdetési rendszerek ezeket a termékeket nem fogják megjeleníteni.",
		],
		"status_wrong_placement_description": [
			"V ideálním případě by měly produkty na obrázku vyplňovat co největší plochu a být zarovnané na střed. V opačném případě se u nich ztrácí informační hodnota a působí nejednotně.",
			"V ideálnom prípade by mali produkty na obrázku vypĺňať čo najväčšiu plochu a byť zarovnané na stred. V opačnom prípade sa u nich stráca informačná hodnota a pôsobia nejednotne. ",
			"Ideally, the products in the image should be as flat as possible and centered. Otherwise, the information value is lost, and they appear inconsistent.",
			"Idealnie, produkty na obrazie powinny być wyśrodkowane i w rozmiarze pasującym do jego wielkości. W przeciwnym razie wartość informacji zostanie utracona i będą wyglądać na niespójne.",
			"Ideális esetben a termékek a lehető legnagyobb helyet foglalják el a képen, és középre vannak rendezve. Ellenkező esetben elveszítik információs értéküket, és nem keltenek egységes benyomást.",
		],
		"status_poor_quality_images_description": [
			"Pokud nejsou produktové obrázky dostatečně ostré, obsahují glitch nebo jsou jiným způsobem rozmazané, mohou svojí nedostatečnou kvalitou odradit zákazníky.",
			"Ak produktové obrázky nie sú dostatočne ostré, obsahujú glitch alebo sú iným spôsobom rozmazané, môžu svojou kvalitou odradiť zákazníkov. ",
			"If your product images aren't sharp enough, contain glitches, or are otherwise blurred, they may deter customers by their poor quality.",
			"Nieostre zdjęcia o kiepskiej jakości mogą zniechęcić potencjalnych klientów. Zaprezentuj swoje produkty w jak najlepszy sposób. ",
			"Ha a termékképek nem elég élesek, glitch-t tartalmaznak vagy más módon elmosódottak, rossz minőségükkel elriaszthatják a vásárlókat.",
		],
		"status_seo_large_file_description": [
			"<h3>Popis doporučení:</h3> Velikost obrázků přesahuje hranici 400 kB. Ve vašem e-shopu se to negativně projeví tak, že se obrázky budou dlouho načítat, což může vést ke zvýšené míře opuštěnosti.<br/><h3>Detail řešení:</h3> Feed Image Editor hromadně zkomprimuje příliš velké obrázky a sníží tak jejich velikost, aby se rychleji načítaly na webu. Víc se dočtete v článku na <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.cz/zlepsete-seo-obrazku-pomoci-automaticke-komprese\")>našem blogu</span>.",
			"<h3>Popis odporúčania:</h3> Veľkosť obrázkov presahuje hranicu 400 kB. Vo vašom e-shope sa to negatívne prejaví tak, že sa obrázky budú dlho načítať, čo môže viesť k zvýšenej miere opustenosti. <br/><h3>Detail riešenia:</h3> Feed Image Editor hromadne skomprimuje príliš veľké obrázky a zníži tak ich veľkosť aby sa rýchlejšie načítavali na webe. Viac sa dočítate v článku na <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.sk/zlepsite-seo-obrazkov-pomocou-automatickej-kompresie\")>našom blogu</span>.",
			"<h3>The recommendation description:</h3> The size of the images exceeds the limit of 400 kB. It harms your online store, as they take a long time to load. It can lead to an increased dropout rate. <br/><h3>The solution detail:</h3> Feed Image Editor bulk compresses oversized images to reduce their size so that they load faster on the web. You can read more in the article on <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.com/improve-image-seo-automatic-compression\")>our blog</span>.",
			"<h3>Opis rekomendacji:</h3> Rozmiar zdjęć przekracza limit 400 kB. Szkodzi Twojemu sklepowi internetowemu, ponieważ ładowanie zajmuje dużo czasu. Może to prowadzić do zwiększonego wskaźnika rezygnacji. <br/><h3>Szczegóły rozwiązania:</h3> Feed Image Editor zbiorczo kompresuje zbyt duże obrazy, aby zmniejszyć ich rozmiar, aby szybciej ładowały się w Internecie. Więcej przeczytasz w artykule na <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.com/improve-image-seo-automatic-compression\")>naszym blogu</span>.",
			"<h3>Javaslat leírása:</h3> A kép mérete meghaladja a 400 kB-ot. Ez negatívan hat webáruházára, mivel hosszú ideig tart a betöltésük, ami pedig az elhagyási arány növekedéséhez vezethet.<br/><h3>Megoldás részletezés:</h3> A Feed Image Editor tömegesen tömöríti a túlméretezett képeket, csökkentve ezáltal méretüket, hogy gyorsabban betöltődjenek az oldalon. Többet olvashat erről <span class=\link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.com/improve-image-seo-automatic-compression\")>blogunkon</span>.",
		],
		"status_few_alt_images_description": [
			"<h3>Detailní popis problému:</h3> Srovnávače, na kterých chcete inzerovat, k produktům umožňují zobrazovat alternativní obrázky. K následujícím produktům přitom nemáte dostupný ani jeden alternativny obrázek.<br/><h3>Řešení:</h3> Doplňte do feedu alternativní obrázky a využijte možnosti srovnávačů na maximum. Jak k produktům vyhledat obrázky se dozvíte v článku na našem blogu.",
			"<h3>Detailný popis problému:</h3> Porovnávače, na ktorých chcete inzerovať, umožňujú k produktom zobrazovať alternatívne obrázky. K nasledujúcim produktom pritom nemáte dostupný ani jeden alternatívny obrázok.<br/><h3>Riešenie:</h3> Doplňte do feedu alternatívne obrázky a využite možnosti porovnávačov na maximum. Ako k produktom vyhľadať obrázky sa dozviete v článku na našom blogu.",
			"<h3>Detailed description of the problem:</h3> The comparison engines where you want to advertise allow you to display alternative images for your products. There is no single alternative image available for the following products.<br/><h3>Solution:</h3> Add alternative images to the feed and make the most of the comparison engines. Learn how to find images for products in our blog article.",
			"<h3>Szczegółowy opis problemu:</h3> todo: without alternative images description",
			"<h3>A probléma részletes leírása:</h3> Az árösszehasonlító oldalak, melyeken hirdetni szeretne, a termékekhez alternatív képek megjelenítését is lehetővé teszik. A következő termékekhez nem áll rendelkezésre egyetlen alternatív kép sem.<br/><h3>Megoldás:</h3> Egészítse ki alternatív képekkel a feedjét, és használja ki maximálisan az árösszehasonlító oldalak nyújtotta lehetőségeket. Blogcikkünkből megtudhatja, hogyan találhat képeket a termékekhez.",
		],
		"status_transparent_background_description": [
			"Bílé pozadí produktových obrázků je nepsaným standardem u většiny reklamních systémů a srovnávačů. V případě, že některé z vašich obrázků mají průhledné pozadí, budou zamítnuté, anebo se jim pozadí doplní automaticky a budou vypadat kostrbatě.",
			"Biele pozadie produktových obrázkov je nepísaným štandardom u väčšiny reklamných systémov a porovnávačov. V prípade, že niektoré z vašich obrázkov majú priehľadné pozadie, budú zamietnuté alebo sa im pozadie doplní automaticky a budú vyzerať kostrbato.",
			"The white background of product images is an unwritten standard for most advertising systems and comparison engines. If some of your images have a transparent background, they will be rejected, or the background automatically fills in and looks gritty.",
			"Białe tło zdjęć produktów jest niepisanym standardem dla większości porównywarek. Jeśli niektóre z twoich zdjęć mają przezroczyste tło, zostaną odrzucone lub tło automatycznie wypełni się i będzie wyglądać na ziarniste.",
			"A legtöbb hirdetési rendszer és árösszehasonlító oldal íratlan szabálya a termékképek fehér háttere. Ha egy kép háttere áttetsző, a rendszer elutasítja, vagy automatikusan hozzáadja a hátteret, így szemcsésnek fog tűnni.",
		],
		"status_same_images_description": [
			"Některé produkty mají stejné obrázky, například u velikostních variant oblečení, u ilustračních obrázků autosoučástek či nehmotných produktů. V ostatních případech to nedělá dobrý dojem.",
			"Niektoré produkty majú rovnaké obrázky, napríklad pri veľkostných variantoch oblečenia, pri ilustračných obrázkoch autosúčiastok či nehmotných produktoch. V iných prípadoch to nerobí dobrý dojem.",
			"Some products have the same images, e. g. for clothing sizes, car parts, and intangible products. In other cases, it does not make a good impression.",
			"Niektóre produkty, np. ten sam t-shirt w różnych rozmiarach, mają takie same obrazy. Niektóre porównywarki cenowe odrzucają takie obrazy, a co za tym idzie nie wyświetlają ich przy pożądanych produktach.",
			"Egyes termékek azonos képekkel rendelkeznek, például ruházat esetében a méretváltozatok, autóalkatrészek illusztrációs képei vagy az immateriális termékek. Más esetben ez nem kelt jó benyomást.",
		],
		"alternative_images_description": [
			"Vaše produkty mají víc alternativních obrázků, než je povoleno srovnávačem. Tyto obrázky, které jsou navíc se v srovnávači nezobrazí. Zohledněte to a inzerujte ty nejatraktivnější alternativní obrázky.",
			"Vaše produkty majú viac alternatívnych obrázkov, než je povolené porovnávačom. Tieto obrázky, ktoré sú naviac sa v porovnávači nezobrazia. Zohľadnite to a inzerujte tie najatraktívnejšie alternatívne obrázky.",
			"Your products have too many alternative images. Images over this threshold will not be displayed in the comparison engine. Take this into account and advertise the most attractive alternative images only.",
			"Produkty mogą być odrzucone przez porównywarkę cenową ponieważ istnieje zbyt wiele obrazów alternatywnych.",
			"A termékek több alternatív képpel rendelkeznek, mint amennyit az árösszehasonlító oldal engedélyez. Ezek az extra képek nem jelennek meg az árösszehasonlító keresőben. Vegye ezt figyelembe, és csak a legmegnyerőbb alternatív képeket hirdesse.",
		],
		"status_poor_quality_images": [
			"Kvalita obrázku",
			"Kvalita obrázku",
			"Image quality",
			"Jakość obrazu",
			"Képminőség",
		],
		"status_seo_large_file": [
			"Velikost souboru s obrázkem z hlediska SEO",
			"Veľkosť súboru s obrázkom z hľadiska SEO",
			"The size of the image file in terms of SEO",
			"Rozmiar pliku graficznego pod kątem SEO",
			"A képfájlok mérete SEO szempontból",
		],
		"status_few_alt_images": [
			"Možnost doplnit alternativní obrázky",
			"Možnosť doplniť alternatívne obrázky",
			"Option to add alternative images",
			"Możliwość dodania alternatywnych zdjęć",
			"Alternatív képek hozzáadásának lehetősége",
		],
		"status_all": [
			"Všechny produkty",
			"Všetky produkty",
			"All products",
			"Wszystkie produkty",
			"Összes termék",
		],
		"status_unavailable": [
			"Nedostupné obrázky",
			"Nedostupné obrázky",
			"Status unavailable",
			"Niedostępne obrazy",
			"Nem elérhető képek",
		],
		"status_invalid_url": [
			"Nevalidní URL adresa",
			"Neplatná URL adresa",
			"Invalid URL characters",
			"Niewłaściwy adres URL",
			"Érvénytelen URL-cím",
		],
		"status_unsupported_mime_type": [
			"Nepodporovaný formát",
			"Nepodporovaný formát",
			"Unsupported file format",
			"Niewłaściwy typ mim",
			"Nem támogatott formátum",
		],
		"status_wrong_placement": [
			"Pozice, zarovnání a velikost produktu na obrázku",
			"Pozícia, zarovnanie a veľkosť produktu na obrázku",
			"Position, alignment and product image size",
			"Wyśrodkowanie produktu",
			"Pozíció, igazítás és a termék mérete a képen",
		],
		"status_transparent_background": [
			"Průhledné pozadí",
			"Priehľadné pozadie",
			"Transparent background",
			"Przezroczyste tło",
			"Áttetsző háttér",
		],
		"unsupported_mime_by_engines": [
			"Obrázky nepodporované inzertním kanálem: Formát souboru, který jste zvolili pro export obrázků, není podporovaný zbožákem, na kterém chcete inzerovat. Výstupní formát změníte v nastaveních.",
			"Obrázky nepodporované inzertným kanálom: Formát súboru, ktorý ste zvolili pre export obrázkov, nie je podporovaný porovnávačom, na ktorom chcete inzerovať. Výstupný formát zmeníte v nastaveniach.",
			"Images not supported by comparison engine: Export file format is not supported by the comparison engine. Change file format in app settings.",
			"Format nieobsługiwany przez porównywarki cenowe",
			"Az árösszehasonlító oldal által nem támogatott képek: Az árösszehasonlító oldal, melyen hirdetni szeretne, nem támogatja az exporthoz választott fájlformátumot. A kimeneti formátumot a beállításoknál módosíthatja.",
		],
		"supports_formats": [
			"podporuje formáty",
			"podporuje formáty",
			"supports formats",
			"obsługuje formaty",
			"támogatott formátumok",
		],
		"with_problems": [
			"s chybami",
			"s chybami",
			"with errors",
			"z błędami",
			"hibákkal",
		],
		"clear_old_products": [
			"Smazat staré produkty v db",
			"Zmazať staré produkty v db",
			"Clear old products in db",
			"Usuń stare produkty z db",
			"Régi termékek törlése az adatbázisból",
		],
		"info_is_new": [
			"Zatím žádné importované produkty. Zdá se, že na tomto projektu ješte neproběhla pravidla.",
			"Zatiaľ žiadne importované produkty. Zdá sa, že na tomto projekte ešte neprebehli pravidlá.",
			"No imported products yet. It seems the rules in this export were not applied yet.",
			"Brak importowanych produktów. Wydaje się, że nie ma żadnych zasad dotyczących tego projektu",
			"Még nincs importált termék. Úgy tűnik, hogy a szabályokat még nem futtatták le ezen a projekten.",
		],
		"info_no_data": [
			"Nastaveným filtrům neodpovídají žádné produkty.",
			"Nastaveným filtrom nezodpovedajú žiadne produkty.",
			"No products seem to match your filters.",
			"Żadne produkty nie pasują do ustawionych filtrów.",
			"Egyetlen termék sem felel meg a beállított szűrőknek.",
		],
		"info_not_processed_yet": [
			"Zpracování a diagnostika probíhá průběžně během dne.",
			"Spracovanie a diagnostika prebieha priebežne počas dňa.",
			"Image processing and diagnostics run continuously throughout the day.",
			"Przetwarzanie i diagnostyka są przeprowadzane regularnie na przestrzeni dnia",
			"A feldolgozás és a diagnosztika folyamatosan történik a nap folyamán.",
		],
		"info_apply_one_rule": [
			"V připadě, že máte pro stejné produkty více šablon, aplikuje se pouze šablona s nejvyšší prioritou. Výběr produktů pro jednotlivé šablony můžete zvolit při editaci šablony v záložce produkty.",
			"V prípade, že máte pre rovnaké produkty viac šablón, aplikuje sa iba šablóna s najvyššou prioritou. Výber produktov pre jednotlivé šablóny môžete zvoliť pri editácii šablóny v záložke produkty.",
			"If you have multiple templates for the same products, only the highest priority template is applied. You can assign products for each template when editing the template on the Products tab.",
			"Jeśli masz wiele szablonów dla tych samych produktów, stosowany jest tylko szablon o najwyższym priorytecie. Możesz wybrać produkty dla każdego szablonu podczas edycji szablonu na karcie Produkty",
			"Ha több sablonja van ugyanarra a termékre, csak a legmagasabb prioritású sablon kerül alkalmazásra. Az egyes sablonokhoz tartozó termékválasztékot a termékek fülön választhatja ki a sablon szerkesztésekor.",
		],
		"filter_image_url": [
			"Adresa obrázku",
			"Adresa obrázka",
			"Image url",
			"Adres zdjęcia",
			"Képhivatkozás",
		],
		"filter_product_url": [
			"Adresa produktu",
			"Adresa produktu",
			"Product url",
			"Adres produktu",
			"Termékhivatkozás",
		],
		"filter_product_urls": [
			"Adresy produktů",
			"Adresy produktov",
			"Product urls",
			"Adresy produktów",
			"Termékhivatkozások",
		],
		"fulltext": [
			"Fulltextové vyhledávání",
			"Fulltextové vyhľadávanie",
			"Full-text search",
			"Wyszukiwanie pełnotekstowe",
			"Teljes szöveges keresés",
		],
		"input_list": [
			"Zadejte více adres oddělených čárkou nebo koncem řádku",
			"Zadajte viac adries oddelených čiarkou alebo koncom riadku",
			"Enter multiple addresses separated by commas or carriage returns",
			"Wprowadź wiele adresów oddzielonych przecinkami lub znakami powrotu karetki",
			"Adjon meg több címet vesszővel vagy sortöréssel elválasztva",
		],
		"more": [
			"Více",
			"Viac",
			"More",
			"Więcej",
			"Több",
		],
		"less": [
			"Méně",
			"Menej",
			"Less",
			"Mniej",
			"Kevesebb",
		],
		"filter_status_code": [
			"Stavový kód",
			"Stavový kód",
			"Status code",
			"Kod statusu",
			"Állapotkód",
		],
		"filter_template": [
			"Šablona",
			"Šablóna",
			"Template",
			"Szablon",
			"Sablon",
		],
		"filter_from": [
			"Datum od",
			"Dátum od",
			"Date from",
			"Data od",
			"Kezdődátum",
		],
		"filter_to": [
			"Datum do",
			"Dátum do",
			"Date to",
			"Data do",
			"Végdátum",
		],
		"filter_productname": [
			"Název produktu",
			"Názov produktu",
			"Product name",
			"Nazwa produktu",
			"Terméknév",
		],
		"filter_productid": [
			"MERGADO id produktu",
			"MERGADO id produktu",
			"Product MERGADO id",
			"MERGADO id produktu",
			"MERGADO termékazonosító",
		],
		"filter_element": [
			"Element",
			"Element",
			"Attribute",
			"Element",
			"Elem",
		],
		"filter_element_value": [
			"Hodnota elementu",
			"Hodnota elementu",
			"Attribute value",
			"Wartość elementu",
			"Elemérték",
		],
		"filter_value_from": [
			"Od",
			"Od",
			"From",
			"Od",
			"Kezdet",
		],
		"filter_value_to": [
			"Do",
			"Do",
			"To",
			"Do",
			"Vég",
		],
		"filter_add": [
			"Element",
			"Element",
			"Element",
			"Element",
			"Elem",
		],
		"filter_remove": [
			"Zrušit <br/>všechny filtry",
			"Zrušiť <br/>všetky filtre",
			"Remove <br/>all filters",
			"Anuluj <br/>wszystkie filtry",
			"Töröld <br/>az összes szűrőt",
		],
		"filter_group": [
			"Skupina",
			"Skupina",
			"Group",
			"Grupa",
			"Csoport",
		],
		"filter_content_type": [
			"Formát obrázku",
			"Formát obrázku",
			"Image format",
			"Format obrazu",
			"Képformátum",
		],
		"filter_content_length": [
			"Velikost",
			"Veľkosť",
			"Length",
			"Wielkość",
			"Méret",
		],
		"custom_filter": [
			"Vlastní filtr",
			"Vlastný filter",
			"Custom filter",
			"Vlastní filtr",
			"Egyéni szűrő",
		],
		"preset_ranges": [
			"Přednastavené rozsahy",
			"Predvolené rozsahy",
			"Preset ranges",
			"Přednastavené rozsahy",
			"Előre beállított tartományok",
		],
		"filter_mistake_set_by_user": [
			"Stav nastavený uživatelem",
			"Stav nastavený užívateľom",
			"User-set status",
			"Status użytkownika",
			"Felhasználó által beállított állapot",
		],
		"filter_correctness_percentage_offset": [
			"Vzdálenost od okraje",
			"Vzdialenosť od okraja",
			"Distance to edge",
			"Odległość do krawędzi",
			"Szegélytől való távolság",
		],
		"filter_has_alpha": [
			"Průhledné pozadí",
			"Priehľadné pozadie",
			"Has Alpha",
			"Przezroczyste tło",
			"Áttetsző háttér",
		],
		"filter_status_reason": [
			"Důvod stavu",
			"Dôvod stavu",
			"Status Reason",
			"Powód stanu",
			"Állapot oka",
		],
		"filter_status": [
			"Stav",
			"Stav",
			"Status",
			"Stav",
			"Állapot",
		],
		"filter_probability": [
			"Pravděpodobnost výskytu vodoznaku [%]",
			"Pravdepodobnosť výskytu vodoznaku [%]",
			"Probability of watermark occurence [%]",
			"Prawdopodobieństwo wystąpienia znaku wodnego [%]",
			"Az előfordulás valószínűsége [%]",
		],
		"filter_user_set_watermark": [
			"Vodoznak v obrázku (uživatel)",
			"Vodoznak v obrázku (užívateľ)",
			"Image with watermark (user)",
			"Znak wodny na obrazku (użytkownik)",
			"Vízjel a képen (felhasználó)",
		],
		"filter_user_set": [
			"Stav nastavený uživatelem",
			"Stav nastavený užívateľom",
			"User-set status",
			"Status użytkownika",
			"Felhasználó által beállított állapot",
		],
		"watermarks": [
			"Vodoznaky",
			"Vodoznaky",
			"Watermarks",
			"Znaki wodne",
			"Vízjelek",
		],
		"images_quality": [
			"Kvalita obrázků",
			"Kvalita obrázkov",
			"Quality status",
			"Status jakości",
			"Minőségi állapot",
		],
		"quality_status": [
			"Stav kvality",
			"Stav kvality",
			"Images Quality",
			"Jakość obrazu",
			"Képek minősége",
		],
		"bad_quality_score": [
			"Skóre špatné kvality",
			"Skóre zlej kvality",
			"Bad quality score",
			"Słaba jakość wyniku",
			"Gyenge minőségi pontszám",
		],
		"good_quality": [
			"Dobrá",
			"Dobrá",
			"Good",
			"Dobra",
			"Jó",
		],
		"bad_quality": [
			"Špatná",
			"Zlá",
			"Bad",
			"Zła",
			"Rossz"
		],
		"middle_quality": [
			"Střední",
			"Stredná",
			"Medium",
			"Średniej",
			"Közepes",
		],
		"diagnostics": [
			"Diagnostika",
			"Diagnostika",
			"Diagnostics",
			"Diagnostyka",
			"Diagnosztika",
		],
		"processed_alt_images": [
			"Zpracovávaných alternativních obrázků",
			"Spracovávaných alternatívnych obrázkov",
			"Processed alternative images",
			"Przetworzone obrazy alternatywne",
			"Feldolgozott alternatív képek",
		],
		"processed_images": [
			"Zpracovávaných obrázků",
			"Spracovávaných obrázkov",
			"Processed images",
			"Przetworzone obrazy",
			"Feldolgozott képek",
		],
		"problems": [
			"Problémy",
			"Problémy",
			"Problems",
			"Problemy",
			"Problémák",
		],
		"warnings": [
			"Varování",
			"Upozornenie",
			"Warnings",
			"Ostrzeżenia",
			"Figyelmeztetések",
		],
		"recommendations": [
			"Doporučení",
			"Odporúčanie",
			"Recommendations",
			"Rekomendacje",
			"Javaslatok",
		],
		"overview": [
			"Přehled",
			"Prehľad",
			"Overview",
			"Przegląd",
			"Áttekintés",
		],
		"watermarks_removal": [
			"Odstranění vodoznaků",
			"Odstránenie vodoznakov",
			"Watermarks removal",
			"Usuwanie znaków wodnych",
			"Vízjelek eltávolítás",
		],
		"selected_watermark_pattern": [
			"Tento obrázek bude použit jako vzor hledaného vodoznaku",
			"Tento obrázok bude použitý ako vzor hľadaného vodoznaku",
			"This image will be used as a pattern for the watermark you are looking for",
			"Ten obraz zostanie użyty jako wzór znaku wodnego, którego szukasz",
			"Ez a kép szolgál a keresett vízjel mintájaként",
		],
		"select_watermark_pattern": [
			"Přidat do vzorů obsahující vodoznak",
			"Pridať do vzorov obsahujúce vodoznak",
			"Add to watermarkMasks containing a watermark",
			"Dodaj do wzorów zawierających znak wodny",
			"Hozzáadás a vízjelet tartalmazó mintákhoz",
		],
		"user_set_objects": [
			"Uživatelem označené pozice vodoznaků",
			"Užívateľom označené pozície vodoznakov",
			"User-marked watermark positions",
			"Pozycje znaku wodnego oznaczone przez użytkownika",
			"Felhasználó által megjelölt vízjel pozíciók",
		],
		"with_or_without_objects": [
			"Označené vodoznaky",
			"Označené vodoznaky",
			"Marked watermarks",
			"Oznaczone znaki wodne",
			"Megjelölt vízjelek",
		],
		"with_objects": [
			"S označenými vodoznaky",
			"S označenými vodoznakmi",
			"With marked watermarks",
			"Z zaznaczonymi znakami wodnymi",
			"Megjelölt vízjelekkel",
		],
		"without_objects": [
			"Bez označených vodoznaků",
			"Bez označených vodoznakov",
			"Without marked watermarks",
			"Bez oznaczonych znaków wodnych",
			"Megjelölt vízjelek nélkül",
		],
		"all": [
			"Všechny",
			"Všetky",
			"All",
			"Wszystko",
			"Összes",
		],
		"first": [
			"První",
			"Prvý",
			"First",
			"Pierwszy",
			"Első",
		],
		"last": [
			"Poslední",
			"Posledný",
			"Last",
			"Ostatni",
			"Utolsó",
		],
		"view_mode": [
			"Zobrazení",
			"Zobrazenie",
			"View",
			"Widok",
			"Megjelenítés",
		],
		"problems_text": [
			"U tolika produktů se <b>nezobrazují produktové obrázky</b>, protože se vyskytl minimálně jeden z těchto problémů:",
			"U toľkých produktov sa <b>nezobrazujú produktové obrázky</b>, pretože sa vyskytol minimálne jeden z týchto problémov:",
			"For so many products, <b>the product images do not display</b>, because at least one of the following issues has occurred:",
			"Następująca ilość  <b>obrazów produktów nie jest wyświetlana</b>, ponieważ wystąpił co najmniej jeden z problemów:",
			"Ennyi terméknél <b>nem jelenik meg termékkép</b>, mert legalább egy felmerült az alábbi problémák közül:",
		],
		"warnings_text": [
			"U tolika produktů jsou <b>limity v zobrazování vašich obrázků</b>, protože se vyskytlo minimálně jedno z těchto varování:",
			"U toľkých produktov sú <b>limity v zobrazovaní vašich obrázkov</b>, pretože sa vyskytlo minimálne jedno z týchto varovaní:",
			"For so many products, <b>there are limits on the display of your images</b>, because at least one of the following issues has occurred:",
			"Dla następującej listy produktów, <b>obrazy nie będą wyświetlane</b>, ponieważ pojawił się co najmniej jeden z problemów:",
			"Ennyi terméknél <b>korlátozva van a képek megjelenítése</b>, mert legalább egy felmerült az alábbi figyelmeztetések közül:",
		],
		"recommendations_text": [
			"U tolika produktů se <b>nezobrazují produktové obrázky</b>, protože se vyskytl minimálně jeden z těchto problémů:",
			"U toľkých produktov sa <b>nezobrazujú produktové obrázky</b>, pretože sa vyskytol minimálne jeden z týchto problémov:",
			"For so many products, <b>the product images do not display</b>, because at least one of the following issues has occurred:",
			"Dla następującej listy produktów, <b>obrazy nie będą wyświetlane</b>, ponieważ pojawił się co najmniej jeden z problemów:",
			"Ennyi terméknél <b>nem jelenik meg termékkép</b>, mert legalább egy felmerült az alábbi problémák közül:",
		],
		"one_product": [
			"produkt",
			"produkt",
			"product",
			"produkt",
			"termék",
		],
		"less_than_five_products": [
			"produkty",
			"produkty",
			"products",
			"produkty",
			"termék",
		],
		"products_count": [
			"produktů",
			"produktov",
			"products",
			"produktów",
			"termék",
		],
		"image_id": [
			"ID obrázku",
			"ID obrázku",
			"Image ID",
			"ID obrázku",
			"Kép ID szám",
		],
		"mistake_set_by_user": [
			"Chyba nastavená uživatelem",
			"Chyba nastavená uživatelem",
			"Mistake set by user",
			"Błąd ustawiony przez użytkownika",
			"Felhasználó által beállított hiba",
		],
		"correctness_percentage_offset": [
			"Vzdálenost od okraje",
			"Vzdialenosť od okraja",
			"Distance to edge",
			"Odległość do krawędzi",
			"Szegélytől való távolság",
		],
		"has_alpha": [
			"Průhlednost",
			"Priehľadnosť",
			"Has Alpha",
			"Przejrzystość",
			"Áttetszőség",
		],
		"status_reason": [
			"Důvod stavu",
			"Dôvod stavu",
			"Status Reason",
			"Powód stanu",
			"Állapot oka",
		],
		"status": [
			"Stav",
			"Stav",
			"Status",
			"Stav",
			"Állapot",
		],
		"updated_at": [
			"Aktualizováno",
			"Aktualizované",
			"Updated At",
			"Zaktualizowano",
			"Frissítve",
		],
		"no_alpha": [
			"Ne",
			"Nie",
			"No",
			"Nie",
			"Nem",
		],
		"with_alpha": [
			"Ano",
			"Áno",
			"Yes",
			"Tak",
			"Igen",
		],
		"info_status_suspicious": [
			"Nelze rozpoznat zda je obrázek záměrně takto umístěn",
			"Nie je možné rozpoznať či je obrázok zámerne takto umiestnený",
			"Unable to detect whether the image is intentionally in this position",
			"Nie można wykryć, czy obraz został celowo umieszczony",
			"Nem felismerhető, hogy szándékosan van-e így elhelyezve a kép",
		],
		"vertical_image": [
			"Vertikální obrázek",
			"Vertikálny obrázok",
			"Vertical image",
			"Obraz pionowy",
			"Függőleges kép",
		],
		"horizontal_image": [
			"Horizontální obrázek",
			"Horizontálny obrázok",
			"Horizontal image",
			"Obraz poziomy",
			"Vízszintes kép",
		],
		"image_down": [
			"Obrázek dole",
			"Obrázok dole",
			"Image down",
			"Rysunek poniżej",
			"Kép lent",
		],
		"image_up": [
			"Obrázek nahoře",
			"Obrázok hore",
			"Image up",
			"Obraz powyżej",
			"Kép fent",
		],
		"image_right": [
			"Obrázek napravo",
			"Obrázok napravo",
			"Image right",
			"Rysunek po prawej stronie",
			"Kép jobbra",
		],
		"image_left": [
			"Obrázek nalevo",
			"Obrázok naľavo",
			"Image left",
			"Obraz po lewej stronie",
			"Kép balra",
		],
		"image_in_the_middle": [
			"Obrázek uprostřed",
			"Obrázok uprostred",
			"Image in the middle",
			"Obraz w środku",
			"Kép középen",
		],
		"image_could_not_be_read": [
			"Obrázek nelze přečíst",
			"Obrázok nemožno prečítať",
			"Image couldn't be read",
			"Nie można odczytać obrazu",
			"A kép nem olvasható",
		],
		"unknown_image_format": [
			"Neznámý formát",
			"Neznámy formát",
			"Unknown image format",
			"Nieznany format",
			"Ismeretlen formátum",
		],
		"option_false": [
			"Ne",
			"Nie",
			"No",
			"Nie",
			"Nem",
		],
		"option_true": [
			"Ano",
			"Áno",
			"Yes",
			"Tak",
			"Igen",
		],
		"option_not_set": [
			"Hodnota nenastavena",
			"Hodnota nenastavená",
			"Value not set",
			"Wartość nie ustawiona",
			"Nincs beállítva érték ",
		],
		"mistake_by_user_successfully_changed": [
			"Hodnota změněna",
			"Hodnota zmenená",
			"Value changed",
			"Zmieniono wartość",
			"Módosított érték",
		],
		"status_N/A": [
			"Podezřelý",
			"Podozrivý",
			"Suspicious",
			"Podejrzany",
			"Gyanús",
		],
		"status_ERROR": [
			"Chyba",
			"Chyba",
			"Error",
			"Błąd",
			"Hiba",
		],
		"status_OK": [
			"V pořádku",
			"V poriadku",
			"OK",
			"W porządku",
			"OK",
		],
		"status_NOT_OK": [
			"Není v pořádku",
			"Nie je v poriadku",
			"Not OK",
			"Nie w porządku",
			"Nincs rendben",
		],
		"status_NOT_DETECTED": [
			"Nedetekován",
			"Nezistený",
			"Not detected",
			"Niewykryty",
			"Nem található",
		],
		"importance_HIGH": [
			"Vysoká",
			"Vysoká",
			"High",
			"Wysoki",
			"Magas",
		],
		"importance_MEDIUM": [
			"Střední",
			"Stredná",
			"Medium",
			"Średni",
			"Közepes",
		],
		"importance_SMALL": [
			"Nízká",
			"Nízka",
			"Low",
			"Niski",
			"Alacsony",
		],
		"filter_is_active": [
			"fiter je aktivní",
			"Fiter je aktívny",
			"filter is active",
			"Filtr jest aktywny",
			"A szűrő aktív",
		],
		"export_to_csv": [
			"Exportovat",
			"Exportovať",
			"Export",
			"Eksportuj",
			"Exportálás",
		],
		"csv_download_started": [
			"Vytvářím csv, prosím čekejte",
			"Vytváram csv, prosím čakajte",
			"Generating CSV file, please wait",
			"Wytwarzam CSV, proszę czekać",
			"CSV fájl generálása, kérjük várjon",
		],
		"csv_download_success": [
			"Soubor byl vytvořen",
			"Súbor bol vytvorený",
			"The file was successfully created",
			"Plik został utworzony",
			"Fájl létrehozva",
		],
		"csv_download_error": [
			"Došlo k chybě při exportu do csv",
			"Došlo k chybe pri exporte do csv",
			"An error occurred while exporting to CSV",
			"Wystąpił błąd podczas eksportowania do pliku CSV",
			"Hiba történt a csv-be történő exportálás során",
		],
		"shop_link": [
			"Odkaz do e-shopu",
			"Odkaz do e-shopu",
			"Link to online store",
			"Link do e-shopu",
			"Link a webáruházba",
		],
		"unmodified_link": [
			"Neupravený obrázek",
			"Neupravený obrázok",
			"Original image",
			"Nieedytowany obraz",
			"Eredeti kép",
		],
		"modified_link": [
			"Obrázek přes šablonu",
			"Obrázok cez šablónu",
			"Modified image",
			"Obraz nad szablonem",
			"Kép sablonon keresztül",
		],
		"total_products": [
			"Produktů",
			"Produktov",
			"Products",
			"Produkty",
			"Termék",
		],
		"total_images": [
			"Obrázků",
			"Obrázkov",
			"Images",
			"Obrazów",
			"Kép",
		],
		"total_alt_images": [
			"Alternativních obrázků",
			"Alternatívnych obrázkov",
			"Alternative images",
			"Alternatywne obrazy",
			"Alternatív képek",
		],
		"total_products_info": [
			"Celkem produktů importovaných z MERGADA",
			"Celkom produktov importovaných z MERGADA",
			"Total number of products imported from MERGADO",
			"Łączna ilość produktów importowanych z MERGADY",
			"A MERGADÓBÓL importált termékek összesen",
		],
		"no_products_yet": [
			"Zatím žádné importované produkty k této šabloně.",
			"Zatiaľ žiadne importované produkty k tejto šablóne.",
			"No imported products for this template yet.",
			"Brak produktów importowanych do tego szablonu.",
			"Még nincs importált termék ehhez a sablonhoz.",
		],
		"total_processed_products_info": [
			"Celkem před-zpracovaných produktů",
			"Celkom pred-spracovaných produktov",
			"Total pre-processed products.",
			"Łącznie produkty wstępnie przetworzone",
			"Előfeldolgozott termékek összesen",
		],
		"product": [
			"Produkt",
			"Produkt",
			"Product",
			"Produkt",
			"Termék",
		],
		"product_category": [
			"Kategorie",
			"Kategória",
			"Category",
			"Kategoria",
			"Kategória",
		],
		"product_links": [
			"Odkazy",
			"Odkazy",
			"Links",
			"Referencje",
			"Hivatkozások",
		],
		"eshop_product": [
			"Produkt v E-shopu",
			"Produkt v E-shope",
			"Product in online store",
			"Produkt w e-shopie",
			"Termék a webáruházban",
		],
		"barcode_lookup": [
			"Produkt v BarcodeLookup",
			"Produkt v BarcodeLookup",
			"Product in BarcodeLookup",
			"Produkt w BarcodeLookup",
			"Termék a BarcodeLookup-ban",
		],
		"product_name": [
			"Produkt",
			"Produkt",
			"Product",
			"Produkt",
			"Termék",
		],
		"product_no": [
			"Číslo produktu",
			"Číslo produktu",
			"Product number",
			"Numer produktu",
			"Termékszám",
		],
		"product_code": [
			"Kód produktu",
			"Kód produktu",
			"Product code",
			"Kod produktu",
			"Termékkód",
		],
		"product_image": [
			"Obrázek",
			"Obrázok",
			"Image",
			"Zdjęcie",
			"Kép",
		],
		"product_template": [
			"Šablona",
			"Šablóna",
			"Template",
			"Szablon",
			"Sablon",
		],
		"product_image_link": [
			"Adresa obrázku",
			"Adresa obrázku",
			"Image url",
			"Adres zdjęcia",
			"Képhivatkozás",
		],
		"element_item_id": [
			"ID produktu",
			"ID produktu",
			"Product ID",
			"ID produktu",
			"Termék ID",
		],
		"element_url": [
			"Adresa do E-shopu",
			"Adresa do E-shopu",
			"Link to online store",
			"Adres E-shopu",
			"Link a webáruházba",
		],
		"element_cpc": [
			"CPC",
			"CPC",
			"CPC",
			"CPC",
			"CPC",
		],
		"element_name": [
			"Název produktu",
			"Názov produktu",
			"Product name",
			"Nazwa produktu",
			"Terméknév",
		],
		"element_img_url": [
			"Adresa výstupního obrázku",
			"Adresa výstupného obrázku",
			"Output image address",
			"Adres obrazu wyjściowego",
			"Képhivatkozás",
		],
		"element_img_url_input": [
			"Adresa vstupního obrázku",
			"Adresa vstupného obrázku",
			"Input image address",
			"Adres obrazu wejściowego",
			"Kimeneti kép címe",
		],
		"element_alt_img_url": [
			"Adresa výstupního alternativního obrázku",
			"Adresa výstupného alternatívneho obrázku",
			"Output alternative image link",
			"Adres alternatywnego obrazu wyjściowego",
			"Kimeneti alternatív képcím",
		],
		"element_alt_img_url_input": [
			"Adresa vstupního alternativního obrázku",
			"Adresa vstupného alternatívneho obrázku",
			"Input alternative image link",
			"Wprowadź alternatywny adres obrazu",
			"Adja meg az alternatív képcímet",
		],
		"element_price_vat": [
			"Cena s DPH",
			"Cena s DPH",
			"Price with VAT",
			"Cena z VAT",
			"Ár ÁFÁ-val",
		],
		"element_delivery_date": [
			"DELIVERY_DATE",
			"DELIVERY_DATE",
			"DELIVERY_DATE",
			"DELIVERY_DATE",
			"DELIVERY_DATE",
		],
		"element_manufacturer": [
			"Výrobce",
			"Výrobca",
			"Manufacturer",
			"Producent",
			"Gyártó",
		],
		"element_categorytext": [
			"Kategorie",
			"Kategória",
			"Category",
			"Kategoria",
			"Kategória",
		],
		"element_ean": [
			"EAN",
			"EAN",
			"EAN",
			"EAN",
			"EAN",
		],
		"element_productno": [
			"Číslo produktu",
			"Číslo produktu",
			"Product no",
			"Numer produktu",
			"Termékszám",
		],
		"element_accessory": [
			"Příslušenství",
			"Príslušenstvo",
			"Accessory",
			"Akcesoria",
			"Kiegészítő",
		],
		"element_gift": [
			"Dárek",
			"Darček",
			"Gift",
			"Prezent",
			"Ajándék",
		],
		"element_itemgroup_id": [
			"ITEMGROUP_ID",
			"ITEMGROUP_ID",
			"ITEMGROUP_ID",
			"ITEMGROUP_ID",
			"ITEMGROUP_ID",
		],
		"advanced_search": [
			"Rozšírené vyhledávání",
			"Rozšírené vyhľadávanie",
			"Advanced Search",
			"Wyszukiwanie zaawansowane",
			"Speciális keresés",
		],
		"export_is_ready": [
			"Export je připravený. ",
			"Export je pripravený.",
			"Export is ready. ",
			"Export jest gotowy. ",
			"Az export elkészült. ",
		],
		"download": [
			"Stáhnout",
			"Stiahnuť",
			"Download",
			"Pobierz",
			"Letöltés",
		],
		"please_wait_generating_export": [
			"Prosím čekejte, generuji export",
			"Prosím čakajte, generujem export",
			"Please wait, generating export",
			"Proszę czekać, eksport się generuje.",
			"Kérjük, várjon, az exportálás folyamatban",
		],
		"please_wait_generating_export2": [
			"Toto okno můžete zavřít. V okamžiku, kdy bude export připravený zobrazí se vám notifikace s odkazem ke stažení.",
			"Toto okno môžete zavrieť. V okamžiku, kedy bude export pripravený, zobrazí se vám notifikácia s odkazom k stiahnutiu. ",
			"This window can be closed. When the export is ready, you will get a notification with a download link.",
			"Możesz zamknąć to okno. Gdy eksport jest gotowy, zostaniesz powiadomienie o linku do pobierania.",
			"Ezt az ablakot bezárhatja. Amint elkészül az export, megjelenik egy értesítés a letöltési linkkel.",
		],
		"click_to_download_export": [
			"Stažení exportu provedete kliknutím na tlačítko Stáhnout",
			"Stiahnutie exportu vykonáte kliknutím na tlačítko Stiahnuť",
			"To download the export, click the Download button",
			"Aby pobrać eksport, kliknij przycisk Pobierz",
			"Az export letöltéséhez kattintson a Letöltés gombra.",
		],
		"exported": [
			"Exportováno",
			"Exportované",
			"Exported",
			"Eksportowano",
			"Exportálva",
		],
		"close": [
			"Zavřít",
			"Zatvoriť",
			"Close",
			"Zamknij",
			"Bezárás",
		],
		"n_products": [
			"produktů",
			"Produktov",
			"products",
			"Produkty",
			"termék",
		],
		"template_exported": [
			"Šablona byla exportována",
			"Šablóna bola exportovaná",
			"Template exported",
			"Szablon został wyeksportowany",
			"A sablon exportálása megtörtént",
		],
		"export_template": [
			"Exportovat šablonu",
			"Exportovať šablónu",
			"Export template",
			"Eksportuj szablon",
			"Sablon exportálása",
		],
		"import_template": [
			"Importovat šablonu",
			"Importovať šablónu",
			"Import template",
			"Zaimportuj szablon",
			"Sablon importálása",
		],
		"link_image_url": [
			"Adresa obrázku",
			"Adresa obrázku",
			"Image link",
			"Adres zdjęcia",
			"Képhivatkozás",
		],
		"link_fie": [
			"Obrázek z Feed Image Editoru",
			"Obrázok z Feed Image Editora",
			"Image from Feed Image Editor",
			"Zdjęcie z Feed Image Editoru",
			"Kép a Feed Image Editor-ból",
		],
		"link_mergado": [
			"Produkt v MERGADU",
			"Produkt v MERGADE",
			"Product in MERGADO",
			"Produkt w MERGADO",
			"Termék a MERGADÓBAN",
		],
		"link_eshop": [
			"Produkt v E-shopu",
			"Produkt v E-shope",
			"Product in online store",
			"Produkt w E-shopie",
			"Termék a webáruházban",
		],
		"template_not_found": [
			"Šablona nenalezena!",
			"Šablóna nenájdená!",
			"Template not found!",
			"Nie znaleziono szablonu!",
			"A sablon nem található!",
		],
		"template_preview": [
			"Náhled",
			"Náhľad",
			"Preview",
			"Podgląd",
			"Előnézet",
		],
		"template_is_dynamic": [
			"Šablona s dynamickými prvky",
			"Šablóna s dynamickými prvkami",
			"Template with dynamic elements",
			"Szablon z elementami dynamicznymi",
			"Sablon dinamikus elemekkel",
		],
		"input_width": [
			"Šířka vstup. obrázku",
			"Šírka vstup. obrázka",
			"Input image width",
			"Szerokość obrazu wejśc.",
			"Bemeneti kép szélessége",
		],
		"input_height": [
			"Výška vstup. obrázku",
			"Výška vstup. obrázka",
			"Input image height",
			"Wysokość obrazu wejśc.",
			"Bemeneti kép magassága",
		],
		"product_content_type": [
			"Formát obrázku",
			"Formát obrázku",
			"Image format",
			"Format obrazu",
			"Képformátum",
		],
		"product_content_length": [
			"vstupní velikost [kB]",
			"vstupná veľkosť [kB]",
			"input size [kB]",
			"wielkość wejściowa [kB]",
			"bemeneti méret [kB]",
		],
		"rendered_content_length": [
			"výstupní velikost [kB]",
			"výstupná veľkosť [kB]",
			"output size [kB]",
			"wielkość wyjściowa [kB]",
			"kimeneti méret [kB]",
		],
		"copy_to_clipboard": [
			"Zkopírovat do schránky",
			"Skopírovať do schránky",
			"Copy to clipboard",
			"Skopiuj do schowka",
			"Vágólapra másolás",
		],
		"copy_mergado_query": [
			"Zkopírovat dotaz pro MERGADO do schránky",
			"Skopírovať dotaz pre MERGADO do schránky",
			"Copy MERGADO query to clipboard",
			"Skopiuj zapytanie MERGADO",
			"MERGADO lekérdezés másolása a vágólapra",
		],
		"copied_to_clipboard": [
			"zkopírováno",
			"skopírované",
			"copied",
			"Skopiowano",
			"átmásolva",
		],
		"products_per_page": [
			"Počet produktů na stránce náhledy",
			"Počet produktov na stránke náhľady",
			"Products count on the previews page",
			"Liczba produktów na podglądy stron",
			"A termékek száma az előnézeti lapon",
		],
		"layer_copied": [
			"Vrstva byla zkopírována do schránky",
			"Vrstva bola skopírovaná do schránky",
			"The layer has been copied to the clipboard",
			"Warstwa została skopiowana do schowka",
			"A réteget a vágólapra másolva",
		],
		"ask_save_before_leave": [
			"Pokud odejdete, vaše změny nemusí být uloženy.",
			"Ak odídete, vaše zmeny nemusia byť uložené.",
			"Your changes might not be saved if you leave.",
			"Twoje zmiany mogą nie zostać zapisane, jeśli wyjdziesz.",
			"Előfordulhat, hogy a módosítások nem kerülnek mentésre, ha kilép.",
		],
		"ask_save_before_leave_title": [
			"Odejít bez uložení?",
			"Odísť bez uloženia?",
			"Leave without saving?",
			"Wyjść bez zapisywania?",
			"Kilépés mentés nélkül?",
		],
		"ask_save_before_leave_leave": [
			"Odejít",
			"Odísť",
			"Leave",
			"Wyjdź",
			"Kilépés",
		],
		"ask_save_before_leave_stay": [
			"Zůstat",
			"Zostať",
			"Stay",
			"Zostań",
			"Marad",
		],
		"history_undo": [
			"Zpět",
			"Späť",
			"Undo",
			"Cofnij",
			"Mégsem",
		],
		"history_redo": [
			"Znovu",
			"Znovu",
			"Redo",
			"Przerobić",
			"Mégis",
		],
		"history_initial": [
			"Vrátit vše",
			"Vrátiť všetko",
			"Undo all",
			"Cofnij wszystko",
			"Összes visszavonása",
		],
		"settings": [
			"Nastavení",
			"Nastavenie",
			"Settings",
			"Ustawienia",
			"Beállítások",
		],
		"confirm_delete_format": [
			"Opravdu smazat formát",
			"Naozaj zmazať formát",
			"Delete this format",
			"Czy naprawdę usuwasz format",
			"A formátum törlése",
		],
		"confirm_delete_format_yes": [
			"Ano",
			"Áno",
			"Yes",
			"Tak",
			"Igen",
		],
		"confirm_delete_format_no": [
			"Ne",
			"Nie",
			"No",
			"Ne",
			"Nem",
		],
		"templates_having_this_size": [
			"Šablony s tímto formátem",
			"Šablóny s týmto formátom",
			"Templates with this format",
			"Szablony z tym formatem",
			"Sablonok ezzel a formátummal",
		],
		"project_settings": [
			"Nastavení projektu",
			"Nastavenie projektu",
			"Project settings",
			"Ustawienia projektu",
			"Projekt beállítások",
		],
		"ui_settings": [
			"Nastavení uživatelského rozhraní",
			"Nastavenia užívateľského rozhrania",
			"User interface Settings",
			"Ustawienia interfejsu użytkownika",
			"Felhasználói felület beállításai",
		],
		"output_image_format": [
			"Nastavení výstupního formátu",
			"Nastavenie výstupného formátu",
			"Output format settings",
			"Ustawienie formatu wyjściowego",
			"Kimeneti formátum beállítása",
		],
		"output_image_compression": [
			"Komprese výstupního obrázku",
			"Kompresia výstupného obrázku",
			"Output image compression",
			"Kopiuje obraz wyjściowy",
			"Kimeneti kép tömörítése",
		],
		"auto_compression_to_size": [
			"Automatická komprese do velikosti",
			"Automatická kompresia do veľkosti",
			"Automatic compression to size",
			"Automatyczna kompresja do rozmiaru",
			"Automatikus tömörítés méretre",
		],
		"group_by_image": [
			"Seskupovat podle obrázku",
			"Zoskupovať podľa obrázku",
			"Group by image",
			"Grupuj według obrazu",
			"Csoportosítás kép alapján",
		],
		"products_per_page_on_list": [
			"Produktů na stránce",
			"Produktov na stránke",
			"Products per page",
			"Liczba produktów",
			"Termékek oldalanként",
		],
		"ask_before_leave": [
			"Před ukončením editoru se ptát na uložení změn",
			"Pred ukončením editora sa pýtať na uloženie zmien",
			"Ask before leaving editor to save changes",
			"Zapytaj przed zapisaniem edytora, aby zapisać zmiany",
			"A szerkesztőből való kilépés előtt rákérdezni a módosítások mentésére",
		],
		"settings_value": [
			"hodnota",
			"hodnota",
			"value",
			"wartość",
			"érték",
		],
		"settings_update_success": [
			"Nastavení uloženo",
			"Nastavenie uložené",
			"Settings saved",
			"Ustawienia zapisane",
			"Beállítások elmentve",
		],
		"settings_update_error": [
			"Došlo k chybě při ukládání nastavení",
			"Nastala chyba pri ukladaní nastavení",
			"There was an error while saving settings",
			"Podczas zapisywania ustawień wystąpił błąd",
			"Hiba történt a beállítások mentése során",
		],
		"save_sizes_success": [
			"Formát uložen",
			"Formát uložený",
			"Format saved",
			"Zapisany format",
			"Formátum elmentve",
		],
		"save_sizes_error": [
			"Došlo k chybě při ukládání formátu",
			"Nastala chyba pri ukladaní formátu",
			"An error occurred while saving the format",
			"Wystąpił błąd podczas zapisywania formatu",
			"Hiba történt a formátum mentése során",
		],
		"different_hash": [
			"Údaje nemusejí být aktuální",
			"Údaje nemusia byť aktuálne",
			"The data may not be up to date",
			"Dane mogą nie być aktualne",
			"Az adatok nem biztos, hogy aktuálisak",
		],
		"filtered_items": [
			"Vyfiltrováno",
			"Vyfiltrované",
			"Filtered items",
			"Filtrowane",
			"Szűrt tételek",
		],
		"set_template_active_date_success": [
			"Datum nastaveno",
			"Dátum bolo nastavené",
			"Date set",
			"Ustawiona data",
			"Dátum beállítva",
		],
		"set_template_active_date_error": [
			"Nepodařilo se nastavit datum",
			"Nepodarilo sa nastaviť dátum",
			"Failed to set date",
			"Nie udało się ustawić daty",
			"Nem sikerült beállítani a dátumot",
		],
		"from_date": [
			"od",
			"od",
			"from",
			"od",
			"kezdődátum",
		],
		"to_date": [
			"do",
			"do",
			"to",
			"do",
			"végdátum",
		],
		"is_active": [
			"je aktivní",
			"je aktívny",
			"is active",
			"jest aktywny",
			"aktív",
		],
		"not_active": [
			"není aktivní",
			"nie je aktívny",
			"is not active",
			"nie jest aktywny",
			"inaktív",
		],
		"is_date_limited": [
			"Aktivní od - do",
			"Aktívny od - do",
			"Active from - to",
			"Aktywny od - do",
			"Aktiváció kezdete - vége",
		],
		"active_now": [
			"Aktivní hned",
			"Aktívna hneď",
			"Active now",
			"Aktywny teraz",
			"Azonnal aktív",
		],
		"set_timer": [
			"Načasovat spuštění",
			"Načasovať spustenie",
			"Set the timer",
			"Ustaw minutnik",
			"Időzítő beállítása",
		],
		"show_more": [
			"Více...",
			"Viac...",
			"More...",
			"Więcej...",
			"Mutass többet...",
		],
		"show_less": [
			"Méně...",
			"Menej...",
			"Less...",
			"Mniej...",
			"Mutass kevesebbet...",
		],
		"output_image_preview": [
			"Náhled výstupního obrázku",
			"Náhľad výstupného obrázku",
			"Output image preview",
			"Podgląd obrazu wyjściowego",
			"Kimeneti kép előnézete",
		],
		"output_image_content_length": [
			"Velikost",
			"Veľkosť",
			"Content length",
			"Długość",
			"Méret",
		],
		"original_output_image_content_length": [
			"Původně",
			"Pôvodné",
			"Originally",
			"Pierwotnie",
			"Eredetileg",
		],
		"less_than_original": [
			"méně než původně",
			"menej ako pôvodne",
			"less than originally",
			"mniej niż pierwotnie",
			"kevesebb, mint eredetileg",
		],
		"more_than_original": [
			"více než původně",
			"viac než pôvodne",
			"more than originally",
			"więcej niż pierwotnie",
			"több, mint eredetileg",
		],
		"about": [
			"o",
			"o",
			"about",
			"około",
			"About",
		],
		"has_no_watermark": [
			"Neobsahuje vodoznak",
			"Neobsahuje vodoznak",
			"With no watermark",
			"Nie zawiera znaku wodnego",
			"Nem tartalmaz vízjelet",
		],
		"has_watermark": [
			"Obsahuje vodoznak",
			"Obsahuje vodoznak",
			"Has watermark",
			"Zawiera znak wodny",
			"Vízjelet tartalmaz",
		],
		"watermark_status": [
			"Vodoznak v obrázku",
			"Vodoznak v obrázku",
			"Image with watermark",
			"Znak wodny na obrazku",
			"Vízjel a képen",
		],
		"hiding_products": [
			"Skrývání produktů",
			"Skrývanie výrobkov",
			"Hiding products",
			"Ukrywanie produktów",
			"Termékek elrejtése",
		],
		"hide_products_by_filter": [
			"Skrýt produkty podle filtru",
			"Skryť produkty podľa filtra",
			"Hide products by filter",
			"Ukryj produkty według filtra",
			"Termékek elrejtése szűrő szerint",
		],
		"unhide_products": [
			"Odkrýt",
			"Odkryť",
			"Un-hide",
			"Odkryć",
			"Elrejtés felfedése",
		],
		"hidden_by_filter": [
			"Skryto podle filtru",
			"Skryté podľa filtra",
			"Hidden by filter",
			"Ukryty przez filtr",
			"Szűrővel elrejtve",
		],
		"hide_by_has_watermark": [
			"Skrýt produkty s vodoznaky",
			"Skryť produkty s vodoznaky",
			"Hide products with watermarks",
			"Ukryj produkty ze znakami wodnymi",
			"Vízjeles termékek elrejtése",
		],
		"hide_by_wrong_placement": [
			"Skrýt produkty se špatným umístěním obrázku",
			"Skryť produkty so zlým umiestnením obrázku",
			"Hide products with wrong image placement",
			"Ukryj produkty z nieprawidłowym rozmieszczeniem obrazu",
			"Rossz képelhelyezésű termékek elrejtése",
		],
		"hide_by_low_quality": [
			"Skrýt produkty s nízkou kvalitou",
			"Skryť produkty s nízkou kvalitou",
			"Hide low quality products",
			"Ukryj produkty niskiej jakości",
			"Alacsony minőségű termékek elrejtése",
		],
		"hide_by_seo_large_file": [
			"Skrýt produkty s velkým obrázkem z hlediska SEO",
			"Skryť produkty s veľkým obrázkom z hľadiska SEO",
			"Hide products with a large image file in terms of SEO",
			"Ukryj produkty z szerokim obrazem pod kątem SEO",
			"A SEO szempontjából nagy képfájllal rendelkező termékek elrejtése",
		],
		"filter_content_length_gt": [
			"Velikost větší než ... [kB]",
			"Veľkosť väčšiu ako ... [kB]",
			"Content length greater than ... [kB]",
			"Długość treści większa niż ... [kB]",
			"A tartalom hossza nagyobb, mint ... [kB]",
		],
		"filter_content_length_lt": [
			"Velikost menší než ... [kB]",
			"Veľkosť menšiu ako ... [kB]",
			"Content length smaller than ... [kB]",
			"Długość treści mniejsza niż ... [kB]",
			"A tartalom hossza kisebb, mint ... [kB]",
		],
		"set_by_user": [
			"Nastaveno uživatelem",
			"Nastavené užívateľom",
			"Set by user",
			"Zestaw użytkownika",
			"Felhasználó által beállítva",
		],
		"filter_empty_content": [
			"Prázdný obsah obrázku",
			"Prázdny obsah obrázku",
			"Empty image content",
			"Pusta zawartość obrazu",
			"Üres képtartalom",
		],
		"filter_no_image": [
			"Bez obrázku",
			"Bez obrázku",
			"No image",
			"Brak obrazu",
			"Nincs kép",
		],
		"is_collage": [
			"Rozložení",
			"Rozloženie",
			"Layout",
			"Układ",
			"Elrendezés",
		],
		"all_available_only": [
			"Pouze jsou-li dostupné všechny alternativní obrázky",
			"Iba ak sú dostupné všetky alternatívne obrázky",
			"Only if all alternative images are available",
			"Tylko wtedy, gdy wszystkie alternatywne obrazy są dostępne",
			"Csak akkor, ha az összes alternatív kép elérhető",
		],
		"single_image": [
			"Jeden produktový obrázek",
			"Jeden produktový obrázok",
			"Single product image",
			"Jeden obraz produktu",
			"Egy termékkép",
		],
		"collage_layout": [
			"Zvolte rozvržení",
			"Vyberte rozloženie",
			"Choose layout",
			"Wybierz układ",
			"Válasszon elrendezést",
		],
		"export_layouts": [
			"Exportovat rozložení",
			"Exportovať rozloženia",
			"Export layouts",
			"Eksportuj układy",
			"Elrendezések exportálása",
		],
		"import_layouts": [
			"Importovat rozložení",
			"Importovať rozloženia",
			"Import layouts",
			"Importuj układy",
			"Elrendezések importálása",
		],
		"export_gradients": [
			"Exportovat gradienty",
			"Exportovať gradienty",
			"Export gradients",
			"Eksportuj gradienty",
			"Színátmenetek exportálása",
		],
		"import_gradients": [
			"Importovat gradienty",
			"Importovať gradienty",
			"Import gradients",
			"Importuj gradienty",
			"Színátmenetek importálása",
		],
		"main_image": [
			"Obrázek",
			"Obrázok",
			"Image",
			"Obraz",
			"Kép",
		],
		"alt_image": [
			"Alt",
			"Alt",
			"Alt",
			"Alt",
			"Alt",
		],
		"alternative_images": [
			"Alternativní obrázky",
			"Alternatívne obrázky",
			"Alternative images",
			"Alternatywne obrazy",
			"Alternatív képek",
		],
		"save_layouts_error": [
			"Došlo k chybě při ukádání",
			"Došlo ku chybe pri ukladaní",
			"An error occurred while saving layouts",
			"Wystąpił błąd podczas zapisywania",
			"Hiba történt a mentés során",
		],
		"save_layouts_success": [
			"Uloženo",
			"Uložené",
			"Saved",
			"Zapisane",
			"Elmentve",
		],
		"delete_layouts_error": [
			"Při mazání rozvržení došlo k chybě. Rozložení je používáno v šabloně.",
			"Pri odstraňovaní rozloženia sa vyskytla chyba. Rozloženie je používané v šablóne.",
			"An error occurred while deleting layout. The layout is used in the template.",
			"Wystąpił błąd podczas usuwania układu. Układ jest używany w szablonie.",
			"Hiba történt az elrendezés törlése során. Az elrendezést sablon használja",
		],
		"delete_layout_image_error": [
			"Při mazání obrázku rozvržení došlo k chybě",
			"Pri odstraňovaní obrázka rozloženia sa vyskytla chyba.",
			"An error occurred while deleting layout image.",
			"Wystąpił błąd podczas usuwania obrazu układu.",
			"Hiba történt az elrendezési kép törlése során",
		],
		"delete_layouts_success": [
			"Smazáno",
			"Vymazané",
			"Deleted",
			"Usunięte",
			"Törölve",
		],
		"add_layout_image_success": [
			"Obrázek přidán do rozložení",
			"Obrázok pridaný do rozloženia",
			"Image added to layout",
			"Obraz dodany do układu",
			"Kép hozzáadva az elrendezéshez",
		],
		"add_layout_image_error": [
			"Došlo k chybě při přidávání obrázku rozložení",
			"Došlo k chybe pri pridávaní obrázku rozložení",
			"There was an error while adding the layout image",
			"Wystąpił błąd podczas dodawania obrazu układu",
			"Hiba történt az elrendezési kép hozzáadása során",
		],
		"create_default_layouts": [
			"Znovu vytvořit výchozí sadu rozložení",
			"Znovu vytvoriť predvolenú sadu rozloženie",
			"Re-create the default layout set",
			"Ponownie utwórz domyślny zestaw układów",
			"Alapértelmezett elrendezéskészlet újbóli létrehozása",
		],
		"create_default_layouts_success": [
			"Výchozí rozložení úspěšne vytvořeno",
			"Predvolené rozloženie úspešne vytvorené",
			"Default layout successfully created",
			"Pomyślnie utworzono domyślny układ",
			"Alapértelmezett elrendezés sikeresen létrehozva",
		],
		"create_default_layouts_error": [
			"Chyba při vytváření výchozího rozložení",
			"Chyba pri vytváraní predvoleného rozložení",
			"Error creating default layout",
			"Błąd podczas tworzenia domyślnego układu",
			"Hiba az alapértelmezett elrendezés létrehozása során",
		],
		"delete_all_unused": [
			"Smazat všechny nepoužívané",
			"Zmazať všetky nepoužívané",
			"Delete all unused",
			"Usuń wszystkie nieużywane",
			"Az összes használaton kívüli törlése",
		],
		"delete_all_unused_success": [
			"Úspěšně smazáno",
			"Úspešne zmazané",
			"Deleted successfully",
			"Pomyślnie usunięto",
			"Sikeresen törölve",
		],
		"delete_all_unused_error": [
			"Chyba při mazání",
			"Chyba pri mazaní",
			"Error while deleting unused",
			"Błąd podczas usuwania",
			"Hiba a törlés során",
		],
		"layout_name": [
			"Název rozložení",
			"Názov rozloženie",
			"Layout name",
			"Nazwa układu",
			"Elrendezésnév",
		],
		"selected_layout_image": [
			"Vybraný obrázek",
			"Vybraný obrázok",
			"Selected image",
			"Wybrany obraz",
			"Kijelölt kép",
		],
		"add_layout": [
			"Přidat rozložení",
			"Pridať rozloženie",
			"Add layout",
			"Dodaj układ",
			"Elrendezés hozzáadása",
		],
		"delete_layout": [
			"Smazat rozložení",
			"Zmazať rozloženie",
			"Delete layout",
			"Usuń układ",
			"Elrendezés törlése",
		],
		"delete_layout_image": [
			"Smazat obrázek rozložení",
			"Odstrániť obrázok rozloženia",
			"Delete layout image",
			"Usuń obraz układu",
			"Elrendezési kép törlése",
		],
		"add_layout_image": [
			"Přidat obrázek rozložení",
			"Pridajte obrázok rozloženia",
			"Add layout image",
			"Dodaj obraz układu",
			"Elrendezési kép hozzáadása",
		],
		"save_all_layouts": [
			"Uložit všechna rozložení",
			"Uložiť všetky rozloženie",
			"Save all layouts",
			"Zapisz wszystkie układy",
			"Az összes elrendezés mentése",
		],
		"save_layout": [
			"Uložit rozložení",
			"Uložiť rozloženie",
			"Save layout",
			"Zapisz układ",
			"Elrendezés mentése",
		],
		"padding_px": [
			"Odsazení obrázku [px]",
			"Odsadenie obrázku [px]",
			"Layout padding [px]",
			"Przesunięcie obrazu [px]",
			"Kép eltolása [px]",
		],
		"assigned_image": [
			"Přiřazený obrázek",
			"Priradený obrázok",
			"Assigned image",
			"Przypisany obraz",
			"Hozzárendelt kép",
		],
		"units": [
			"Jednotky",
			"Jednotky",
			"Units",
			"Jednostki",
			"Egységek",
		],
		"layout_pos": [
			"Umístění",
			"Umiestnenie",
			"Relative pos",
			"Miejsce",
			"Pozíció",
		],
		"layout_size": [
			"Rozměry",
			"Rozmery",
			"Relative size",
			"Rozmiar",
			"Méret",
		],
		"add_layout_success": [
			"Nové rozložení přidáno",
			"Nové rozloženie pridané",
			"Nové rozložení přidáno",
			"Dodano nowy układ",
			"Új elrendezés hozzáadva",
		],
		"add_layout_error": [
			"Došlo k chybě při přidávání rozložení",
			"Došlo ku chybe pri pridávaní rozložení",
			"Došlo k chybě při přidávání rozložení",
			"Wystąpił błąd podczas dodawania układu",
			"Hiba történt az elrendezés hozzáadása során",
		],
		"template_sizes": [
			"Rozměry výstupního obrázku",
			"Rozmery výstupného obrázku",
			"Output image size",
			"Wymiary obrazu wyjśc",
			"Kimeneti képméret",
		],
		"save_order": [
			"Uložit pořadí",
			"Uložiť poradí",
			"Save settings order",
			"Zapisz zamówienie",
			"Beállítási sorrend mentése",
		],
		"save_settings_order_success": [
			"Pořadí nastavní uloženo",
			"Poradie nástavný uložené",
			"Setting order saved",
			"Zapisano kolejność ustawiania",
			"Beállítási sorrend elmentve",
		],
		"save_settings_order_error": [
			"Chyba při ukládání pořadí",
			"Chyba pri ukladaní poradí",
			"Error saving order",
			"Błąd zapisywania zamówienia",
			"Hiba a beállítási sorrend mentése során",
		],
		"import_template_success": [
			"Šablona importována",
			"Šablóna bola importovaná",
			"Template imported",
			"Szablon został zaimportowany",
			"Sablon importálva",
		],
		"import_template_error": [
			"Při importu šablony došlo k chybě",
			"Pri importovaní šablóny sa vyskytla chyba",
			"Error while importing template",
			"Błąd podczas importowania szablonu",
			"Hiba történt a sablon importálása során",
		],
		"representative_colors": [
			"Reprezentativní barvy z obrázku",
			"Reprezentatívne farby z obrázku",
			"Representative colors from the image",
			"Reprezentatywne kolory z obrazu",
			"Reprezentatív színek a képből",
		],
		"shortcuts": [
			"Klávesové zkratky",
			"Klávesové skratky",
			"Shortcut keys",
			"Skróty klawiaturowe",
			"Gyorsbillentyűk",
		],
		"shortcut_ins": [
			"Vložit novou vrstvu",
			"Vložiť novú vrstvu",
			"Insert a new layer",
			"Dodaj nową warstwę",
			"Új réteg beillesztése",
		],
		"shortcut_del": [
			"Smazat vrstvu",
			"Zmazať vrstvu",
			"Delete layer",
			"Usuń warstwę",
			"Réteg törlése",
		],
		"shortcut_save": [
			"Uložit šablonu",
			"Uložiť šablónu",
			"Save template",
			"Zapisz szablon",
			"Sablon mentése",
		],
		"shortcut_undo": [
			"Editace zpět",
			"Editácia späť",
			"Undo",
			"Wróć",
			"Mégsem",
		],
		"shortcut_redo": [
			"Editace znovu",
			"Editácia znova",
			"Redo",
			"Przywróć",
			"Mégis",
		],
		"shortcut_copy": [
			"Kopírovat vrstvu",
			"Kopírovať vrstvu",
			"Copy layer",
			"Skopiuj warstwę",
			"Réteg másolása",
		],
		"shortcut_paste": [
			"Vložit vrstvu",
			"Vložiť vrstvu",
			"Paste layer",
			"Wstaw warstwę",
			"Réteg beillesztése",
		],
		"product_is_rendering": [
			"Generuji náhled",
			"Generujem náhľad",
			"Rendering preview",
			"Generowanie podglądu",
			"Előnézet generálása",
		],
		"product_is_loading": [
			"Načítám produkt",
			"Načítavam produkt",
			"Loading product",
			"Ładowanie produktu",
			"A termék betöltése folyamatban",
		],
		"is_saving": [
			"Ukládám",
			"Ukladám",
			"Saving",
			"Oszczędzam",
			"Mentés folyamatban",
		],
		"invalid_filed_value": [
			"Neplatná hodnota pole",
			"Neplatná hodnota poľa",
			"Invalid field value",
			"Niepoprawna wartość pola",
			"Érvénytelen mezőérték",
		],
		"value_not_set": [
			"nenastaveno",
			"nenastavené",
			"not set",
			"nie ustawiono",
			"nincs beállítva",
		],
		"font_not_found": [
			"Font nebyl nalezen. Nahrazeno defaultním.",
			"Font nebol nájdený. Nahradený defaultným.",
			"Font was not found. Changing to default.",
			"Nie znaleziono czcionki. Zastąpione domyślnie.",
			"A betűtípus nem található. Alapértelmezettre váltás.",
		],
		"radius": [
			"Poloměr",
			"Polomer",
			"Radius",
			"Promień",
			"Sugár",
		],
		"gradient_type_linear": [
			"Lineární",
			"Lineárny",
			"Linear",
			"Liniowy",
			"Lineáris",
		],
		"gradient_type_radial": [
			"Radiální",
			"Radiálny",
			"Radial",
			"Promieniowy",
			"Sugárirányú",
		],
		"no_gradient": [
			"Žádný gradient",
			"Žiadny gradient",
			"No gradient",
			"Brak gradientu",
			"Nincs gradiens",
		],
		"select_gradient": [
			"Vybrat gradient",
			"Vybrať gradient",
			"Select gradient",
			"Wybierz gradient",
			"Gradiens kijelölése",
		],
		"select_gradients": [
			"Vyberte gradienty",
			"Vyberte gradienty",
			"Select gradients",
			"Wybierz gradienty",
			"Színátmenetek kiválasztása",
		],
		"save_as_new_gradient": [
			"Uložit jako nový gradient",
			"Uložiť ako nový gradient",
			"Save as new gradient",
			"Zapisz jako nowy gradient",
			"Mentés új gradiensként",
		],
		"info_gradients_not_saved": [
			"Změny v gradientu ještě nejsou uloženy",
			"Zmeny v gradientu ešte nie sú uložené",
			"Gradient changes have not yet been saved",
			"Zmiany gradientu nie zostały jeszcze zapisane",
			"A gradiens módosításai még nincsenek elmentve",
		],
		"gradient": [
			"Gradient",
			"Gradient",
			"Gradient",
			"Gradient",
			"Gradiens",
		],
		"gradients": [
			"Gradienty",
			"Gradienty",
			"Gradients",
			"Gradienty",
			"Gradiensek",
		],
		"confirm_remove_gradient": [
			"Smazat tento gradient?",
			"Zmazať tento gradient?",
			"Delete this gradient?",
			"Usunąć ten gradient?",
			"Törölni akarja ezt a gradienst?",
		],
		"palettes": [
			"Palety barev",
			"Palety farieb",
			"Color palettes",
			"Palety kolorów",
			"Színpaletták",
		],
		"predefined_colors": [
			"Předdefinované barvy",
			"Preddefinované farby",
			"Predefined colors",
			"Predefiniowane kolory",
			"Előre definiált színek",
		],
		"brand_colors": [
			"Barvy brandu",
			"Farby brandu",
			"Brand colors",
			"Kolory marki",
			"Márkaszínek",
		],
		"custom_colors": [
			"Vlastní palety",
			"Vlastné palety farieb",
			"Custom color palettes",
			"Niestandardowe palety kolorów",
			"Egyéni paletták",
		],
		"select_palette": [
			"Vybrat paletu",
			"Vybrať paletu",
			"Select palette",
			"Wybierz paletę",
			"Paletta kijelölése",
		],
		"extract_colors_from_image": [
			"Extrahovat barvy z obrázku",
			"Extrahovať farby z obrázku",
			"Extract the colors from the image",
			"Wyodrębnij kolory z obrazu",
			"Színek kivonása a képből",
		],
		"add_to_custom_palettes": [
			"Přidat k vlastním paletám",
			"Pridať k vlastným paletám",
			"Add to custom palettes",
			"Dodaj do niestandardowych palet",
			"Hozzáadás az egyéni palettákhoz",
		],
		"save_custom_colors": [
			"Uložit vlastní barvy",
			"Uložiť vlastné farby",
			"Save custom colors",
			"Zapisz własne kolory",
			"Egyéni színek mentése",
		],
		"save_as_default": [
			"Uložit jako výchozí",
			"Uložiť ako predvolený",
			"Save as default",
			"Zapisz jako domyślny",
			"Mentés alapértelmezettként",
		],
		"saved": [
			"Uloženo",
			"Uložené",
			"Saved",
			"Zapisane",
			"Elmentve",
		],
		"no_changes": [
			"Žádné změny",
			"Žiadne zmeny",
			"No changes",
			"Bez zmian",
			"Nincs módosítás",
		],
		"no_custom_palettes": [
			"Zatím nemáte žádné vlastní palety",
			"Zatiaľ nemáte žiadne vlastné palety",
			"You have no custom pallets yet",
			"Nie masz jeszcze żadnych niestandardowych palet",
			"Még nincs egyéni palettája",
		],
		"create_layer_group": [
			"Vytvořit skupinu vrstev",
			"Vytvoriť skupinu vrstiev",
			"Create a layer group",
			"Utwórz grupę warstw",
			"Rétegcsoport létrehozása",
		],
		"group": [
			"Seskupit",
			"Zoskupiť",
			"Group",
			"Do grupy",
			"Csoportosítás",
		],
		"ungroup": [
			"Oddělit",
			"Oddeliť",
			"Ungroup",
			"Rozgrupować",
			"Csoportbontás",
		],
		"delete_layer_group": [
			"Zrušit skupinu vrstev",
			"Zrušiť skupinu vrstiev",
			"Un-group",
			"Anuluj grupę warstw",
			"Rétegcsoport megszüntetése",
		],
		"toggle_visibility": [
			"Přepnout viditelnost",
			"Prepnúť viditeľnosť",
			"Toggle visibility",
			"Przełącz widoczność",
			"Láthatóság átkapcsolása",
		],
		"delete_layers": [
			"Smazat vrstvy",
			"Odstrániť vrstvy",
			"Delete layers",
			"Usuń warstwy",
			"Rétegek törlése",
		],
		"delete_layer": [
			"Smazat vrstvu",
			"Odstrániť vrstvu",
			"Delete layer",
			"Usuń warstwę",
			"Réteg törlése",
		],
		"duplicate_layer": [
			"Duplikovat vrstvu",
			"Duplikovať vrstvu",
			"Duplicate layer",
			"Powielona warstwa",
			"Réteg duplikálása",
		],
		"duplicate_layers": [
			"Duplikovat vrstvy",
			"Duplikovať vrstvy",
			"Duplicate layers",
			"Powielone warstwy",
			"Rétegek duplikálása",
		],
		"edit_layer": [
			"Upravit vrstvu",
			"Upraviť vrstvu",
			"Edit layer",
			"Edytuj warstwę",
			"Réteg szerkesztése",
		],
		"lock_layer": [
			"Zamknout vrstvu",
			"Zamknúť vrstvu",
			"Lock layer",
			"Zablokuj warstwę",
			"Réteg zárolása",
		],
		"unlock_layer": [
			"Odemknout vrstvu",
			"Odomknúť vrstvu",
			"Unlock layer",
			"Odblokuj warstwę",
			"Réteg zárolásának feloldása",
		],
		"thickness": [
			"Tloušťka",
			"Hrúbka",
			"Thickness",
			"Grubość",
			"Vastagság",
		],
		"brightness": [
			"Jas",
			"Jas",
			"Brightness",
			"Jasność",
			"Fényerő",
		],
		"contrast": [
			"Kontrast",
			"Kontrast",
			"Contrast",
			"Kontrast",
			"Kontraszt",
		],
		"show_products": [
			"Zobrazit produkty",
			"Zobraziť produkty",
			"Show products",
			"Pokaż produkty",
			"Termékek megjelenítése",
		],
		"reset_effects": [
			"Zrušit efekty",
			"Zrušiť efekty",
			"Reset effects",
			"Anuluj efekty",
			"Effektek törlése",
		],
		"auto_level": [
			"Automatické vyvážení barev",
			"Automatické vyváženie farieb",
			"Automatically adjust color levels of image",
			"Automatyczny balans kolorów",
			"Automatikus színegyensúly",
		],
		"alpha": [
			"Průhlednost",
			"Priehľadnosť",
			"Transparency",
			"Przezroczystość",
			"Áttetszőség",
		],
		"save_as_query": [
			"Uložit jako<br/> výběr",
			"Uložiť ako<br/> výber",
			"Save as <br/> query",
			"Zapisz jako<br/> wybór",
			"Mentés<br/> szűrőként",
		],
		"save_as_query_title": [
			"Uložit jako výběr",
			"Uložiť ako výber",
			"Save as query",
			"Zapisz jako wybór",
			"Mentés szűrőként",
		],
		"fie_query_type": [
			"Typ",
			"Typ",
			"Type",
			"Rodzaj",
			"Típus",
		],
		"fie_query_name": [
			"Název výběru",
			"Názov výberu",
			"Query name",
			"Nazwa wyboru",
			"Szűrőnév",
		],
		"fie_query_element": [
			"Název nového elementu v MERGADU",
			"Názov nového elementu v MERGADE",
			"Name of the new element in MERGADO",
			"Nazwa nowego elementu w MERGADO",
			"Az új elem neve a MERGADÓBAN",
		],
		"fie_query_filter": [
			"Produktový filtr",
			"Produktový filter",
			"Products filter",
			"Filtr produktu",
			"Termék szűrő",
		],
		"fie_query_is_active": [
			"Aktivní",
			"Aktívny",
			"Active",
			"Aktywny",
			"Aktív",
		],
		"query_in_use": [
			"Tento výběr je používán v šabloně",
			"Tento výber je používaný v šablóne",
			"This query is used in the template",
			"Ten wybór jest używany w szablonie",
			"Ezt a lekérdezést sablonban használja",
		],
		"fie_queries": [
			"Výběry",
			"Výbery",
			"Queries",
			"Wybory",
			"Szűrők",
		],
		"fie_queries_info": [
			"Výběry - TODO: napověda",
			"Výběry - TODO: napověda",
			"Výběry - TODO: napověda",
			"Výběry - TODO: napověda",
			"Szűrők - TODO: súgó",
		],
		"no_fie_queries_yet": [
			"Zatím nemáte žádné výběry produktů. Můžete je vytvorit v sekci produkty.",
			"Zatiaľ nemáte žiadne výbery produktov. Môžete ich vytvorit v sekcii produkty.",
			"You do not have any product selections yet. The selections can be created in the product section.",
			"Nie masz jeszcze wyboru produktów. Możesz je utworzyć w sekcji produktów.",
			"Még nincs termékcsoportja. Termékcsoportot a termék szekcióban tud létrehozni.",
		],
		"toggle_active": [
			"Přepnout aktivní/neaktivní",
			"Prepnúť aktívny / neaktívny",
			"Toggle active/inactive",
			"Przełącznik aktywny / nieaktywny",
			"Aktív/inaktív átkapcsolás",
		],
		"set_active": [
			"Přepnout aktivní",
			"Prepnúť aktívny",
			"Toggle active",
			"Przełącznik aktywny",
			"Aktív átkapcsolás",
		],
		"set_inactive": [
			"Přepnout neaktivní",
			"Prepnúť neaktívny",
			"Toggle inactive",
			"Przełącznik nieaktywny",
			"Inaktív átkapcsolás",
		],
		"image": [
			"Obrázek",
			"Obrázok",
			"Image",
			"Obrazek",
			"Kép",
		],
		"mergado_connection_verifying": [
			"Ověřuji spojení s MERGADEM",
			"Overujem spojenie s MERGADEM",
			"Checking connection with MERGADO",
			"Weryfikacja połączenia z MERGADA",
			"A MERGADÓVAL való kapcsolat ellenőrzése folyamatban",
		],
		"show_in_mergado": [
			"Ukázat v MERGADU",
			"Ukázať v MERGADU",
			"Show in MERGADO",
			"Pokaż w MERGADO",
			"Mutasd a MERGADÓBAN",
		],
		"mergado_queries": [
			"Výběry",
			"Výbery",
			"Queries",
			"Wybory",
			"Szűrők",
		],
		"mergado_products": [
			"Produkty",
			"Produkty",
			"Products",
			"Produkty",
			"Termékek",
		],
		"mergado_formats": [
			"Formáty",
			"Formáty",
			"Formats",
			"Formaty",
			"Formátumok",
		],
		"mergado_elements": [
			"Elementy",
			"Elementy",
			"Elements",
			"Elementy",
			"Elemeket",
		],
		"output_image_element": [
			"Výstupní obrázkový element",
			"Výstupný obrázkový element",
			"Output image element",
			"Element obrazu wyjściowego",
			"Kimeneti képelem",
		],
		"output_image_hidden_warning": [
			"Pozor, výstupní obrázkový element pro tento typ exportu je skrytý",
			"Pozor, výstupný obrázkový element pre tento typ exportu je skrytý",
			"Warning: the output image element for this type of export is hidden",
			"Uwaga, element obrazu wyjściowego dla tego typu eksportu jest ukryty",
			"Figyelmeztetés: az ilyen típusú exportnál a kimeneti képelem rejtett",
		],
		"not_empty_error": [
			"Toto pole je povinné",
			"Toto pole je povinné",
			"This field is required",
			"To pole jest obowiązkowe",
			"A mező kitöltése kötelező",
		],
		"drop_shadow": [
			"Stín",
			"Tieň",
			"Shadow",
			"Cień",
			"Árnyék",
		],
		"shadow_color": [
			"Barva stínu",
			"Farba tieňa",
			"Shadow color",
			"Kolor cienia",
			"Árnyékszín",
		],
		"shadow_opacity": [
			"Průhlednost",
			"Priehľadnosť",
			"Opacity",
			"Krycie",
			"Áttetszőség",
		],
		"shadow_sigma": [
			"Rozmazání",
			"Rozmazanie",
			"Blurring",
			"Blur",
			"Elmosódás",
		],
		"shadow_offset": [
			"Posunutí",
			"Posunutie",
			"Displacement",
			"Przesunięcie cienia",
			"Eltolás",
		],
		"shadow_xoffset": [
			"X",
			"X",
			"X",
			"X",
			"X",
		],
		"shadow_yoffset": [
			"Y",
			"Y",
			"Y",
			"Y",
			"Y",
		],
		"effect_sensitivity": [
			"Citlivost efektu",
			"Citlivosť efektu",
			"Effect sensitivity",
			"Czułość efektu",
			"Effekt érzékenysége",
		],
		"sensitivity": [
			"citlivost",
			"citlivosť",
			"sensitivity",
			"czułość",
			"érzékenység",
		],
		"LOW": [
			"nízká",
			"nízka",
			"low",
			"niski",
			"alacsony",
		],
		"MEDIUM": [
			"střední",
			"stredná",
			"medium",
			"średni",
			"közepes",
		],
		"HIGH": [
			"vysoká",
			"vysoká",
			"high",
			"wysoki",
			"magas",
		],
		"too_big_for_upscale": [
			"Obrázek je větší než 600 x 600 pixelů, vylepšení rozlišení není možné aplikovat. Zkuste prosím načíst jiný náhodný obrázek.",
			"Obrázok je väčší ako 600 x 600 pixelov, vylepšenie rozlíšenia nie je možné aplikovať. Skúste prosím načítať iný náhodný obrázok.",
			"The image is larger than 600 x 600 pixels, upscale cannot be applied. Please load another random image.",
			"Obraz jest większy niż 600 x 600 pikseli, nie można zastosować skalowania w górę. Proszę załadować inny losowy obraz.",
			"A kép 600 x 600 pixelnél nagyobb, a felbontásjavítás nem alkalmazható. Kérjük, próbáljon meg betölteni egy másik véletlenszerű képet.",
		],
		"only_main_image": [
			"pouze hlavní obrázek",
			"iba hlavný obrázok",
			"the main image only",
			"tylko główny obraz",
			"csak a fő kép",
		],
		"other_effects": [
			"Další efekty",
			"Ďalšie efekty",
			"Other effects",
			"Inne efekty",
			"További effektek",
		],
		"flood_fill_points": [
			"Body",
			"Body",
			"Points",
			"Zwrotnica",
			"Pontok",
		],
		"fuzz": [
			"Rozptyl",
			"Rozptyl",
			"Fuzz",
			"Dyspersja",
			"Szóródás",
		],
		"heureka_175x175": [
			"Heureka – doporučené rozměry",
			"Heureka – doporučené rozmery",
			"Heureka – recommended dimensions",
			"Heureka – zalecane wymiary",
			"Heureka – ajánlott méret",
		],
		"heureka_4096x4096": [
			"Heureka – maximální rozměry",
			"Heureka – maximálne rozmery",
			"Heureka – maximum dimensions",
			"Heureka – maksymalne wymiary",
			"Heureka – maximális méret",
		],
		"zoot_1000x745": [
			"Zoot – minimální rozměry",
			"Zoot – minimálne rozmery",
			"Zoot – minimum dimensions",
			"Zoot – minimalne wymiary",
			"Zoot – minimális méret",
		],
		"zoot_1907x2562": [
			"Zoot – doporučené rozměry",
			"Zoot – doporučené rozmery",
			"Zoot – recommended dimensions",
			"Zoot – zalecane wymiary",
			"Zoot – ajánlott méret",
		],
		"zbozi_425x440": [
			"Zboží.cz – minimální rozměry",
			"Zboží.cz – minimálne rozmery",
			"Zboží.cz – minimum dimensions",
			"Zboží.cz – minimalne wymiary",
			"Zboží.cz – minimális méret",
		],
		"zbozi_600x800": [
			"Zboží.cz – minimální rozměry (bazarové zboží)",
			"Zboží.cz – minimálne rozmery (bazárový tovar)",
			"Zboží.cz – minimum dimensions (second-hand goods)",
			"Zboží.cz – minimalne wymiary (towary używane)",
			"Zboží.cz – minimális méret (használt áruk)",
		],
		"google_100x100": [
			"Google Merchants – minimální rozměry",
			"Google Merchants – minimálne rozmery",
			"Google Merchants – minimum dimensions",
			"Google Merchants – minimalne wymiary",
			"Google Merchants – minimális méret",
		],
		"google_250x250": [
			"Google Merchants – minimální rozměry u oblečení",
			"Google Merchants – minimálne rozmery u oblečenia",
			"Google Merchants – minimum dimensions for apparel images",
			"Google Merchants – minimalne wymiary zdjęć odzieży",
			"Google Merchants – minimális méret ruházati képeknél",
		],
		"google_500x500": [
			"Google Merchants – minimální rozměry *od 31.1.2027",
			"Google Merchants – minimálne rozmery *od 31. 1. 2027",
			"Google Merchants – minimum dimensions *from 31 January 2027",
			"Google Merchants – minimalne wymiary *od 31.01.2027",
			"Google Merchants – minimális méretek *2027.01.31-től",
		],
		"google_1500x1500": [
			"Google Merchants – doporučené rozměry",
			"Google Merchants – doporučené rozmery",
			"Google Merchants – recommended dimensions",
			"Google Merchants – zalecane wymiary",
			"Google Merchants – ajánlott méret",
		],
		"glami_400x400": [
			"GLAMI – minimální rozměry",
			"GLAMI – minimálne rozmery",
			"GLAMI – minimum dimensions",
			"GLAMI – minimalne wymiary",
			"GLAMI – minimális méret",
		],
		"glami_1500x1500": [
			"GLAMI – doporučené rozměry",
			"GLAMI – doporučené rozmery",
			"GLAMI – recommended dimensions",
			"GLAMI – zalecane wymiary",
			"GLAMI – ajánlott méret",
		],
		"alza_600x600": [
			"ALZA – minimální rozměry",
			"ALZA – minimálne rozmery",
			"ALZA – minimum dimensions",
			"ALZA – minimalne wymiary",
			"ALZA – minimális méret",
		],
		"alza_1000x1000": [
			"ALZA – minimální doporučené rozměry",
			"ALZA – minimálne doporučené rozmery",
			"ALZA – minimum recommended dimensions",
			"ALZA – minimalne zalecane wymiary",
			"ALZA – ajánlott minimális méret",
		],
		"alza_1300x1300": [
			"ALZA – maximální doporučené rozměry",
			"ALZA – maximálne doporučené rozmery",
			"ALZA – maximum recommended dimensions",
			"ALZA – maximalne zalecane wymiary",
			"ALZA – ajánlott maximális méret",
		],
		"favi_600x600": [
			"FAVI – minimální rozměry",
			"FAVI – minimálne rozmery",
			"FAVI – minimum dimensions",
			"FAVI – minimalne wymiary",
			"FAVI – minimális méret",
		],
		"favi_1000x1000": [
			"FAVI – doporučené rozměry",
			"FAVI – doporučené rozmery",
			"FAVI – recommended dimensions",
			"FAVI – zalecane wymiary",
			"FAVI – ajánlott méret",
		],
		"biano_400x400": [
			"BIANO – minimální rozměry",
			"BIANO – minimálne rozmery",
			"BIANO – minimum dimensions",
			"BIANO – minimalne wymiary",
			"BIANO – minimális méret",
		],
		"biano_1500x1500": [
			"BIANO – doporučené rozměry",
			"BIANO – doporučené rozmery",
			"BIANO – recommended dimensions",
			"BIANO – zalecane wymiary",
			"BIANO – ajánlott méret",
		],
		"shopalike_250x250": [
			"Shopalike – minimální rozměry",
			"Shopalike – minimálne rozmery",
			"Shopalike – minimum dimensions",
			"Shopalike – minimalne wymiary",
			"Shopalike – minimális méret",
		],
		"shopalike_1024x1024": [
			"Shopalike – doporučené rozměry",
			"Shopalike – doporučené rozmery",
			"Shopalike – recommended dimensions",
			"Shopalike – zalecane wymiary",
			"Shopalike – ajánlott méret",
		],
		"instagram_1024x1024": [
			"Instagram – doporučené rozměry",
			"Instagram – doporučené rozmery",
			"Instagram – recommended dimensions",
			"Instagram – zalecane wymiary",
			"Instagram – ajánlott méret",
		],
		"instagram_1080x1080": [
			"Instagram",
			"Instagram",
			"Instagram",
			"Instagram",
			"Instagram",
		],
		"instagram_1080x1350": [
			"Instagram",
			"Instagram",
			"Instagram",
			"Instagram",
			"Instagram",
		],
		"instagram_1080x566": [
			"Instagram",
			"Instagram",
			"Instagram",
			"Instagram",
			"Instagram",
		],
		"instagram_1080x1920": [
			"Instagram",
			"Instagram",
			"Instagram",
			"Instagram",
			"Instagram",
		],
		"instagram_1440x1800": [
			"Instagram",
			"Instagram",
			"Instagram",
			"Instagram",
			"Instagram",
		],
		"instagram_1440x2560": [
			"Instagram",
			"Instagram",
			"Instagram",
			"Instagram",
			"Instagram",
		],
		"allegro_500x500": [
			"Allegro – minimální rozměry",
			"Allegro – minimálne rozmery",
			"Allegro – minimum dimensions",
			"Allegro – minimalne wymiary",
			"Allegro – minimális méret",
		],
		"allegro_2560x2560": [
			"Allegro – maximální rozměry",
			"Allegro – maximálne rozmery",
			"Allegro – maximum dimensions",
			"Allegro – maximalne wymiary",
			"Allegro – maximális méret",
		],
		"facebook_1024x1024": [
			"Facebook – doporučené rozměry",
			"Facebook – doporučené rozmery",
			"Facebook – recommended dimensions",
			"Facebook – zalecane wymiary",
			"Facebook – ajánlott méret",
		],
		"facebook_500x500": [
			"Facebook – minimální rozměry",
			"Facebook – minimálne rozmery",
			"Facebook – minimum dimensions",
			"Facebook – minimalne wymiary",
			"Facebook – minimális méret",
		],
		"facebook_600x600": [
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
		],
		"facebook_1080x1080": [
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
		],
		"facebook_1200x1200": [
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
		],
		"facebook_1080x1350": [
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
		],
		"facebook_1200x628": [
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
		],
		'facebook_1440x1440': [
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
		],
		'facebook_1440x1800': [
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
		],
		'facebook_1440x2560': [
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
			"Facebook",
		],
		"modio_500x500": [
			"Modio – minimální rozměry",
			"Modio – minimálne rozmery",
			"Modio – minimum dimensions",
			"Modio – minimalne wymiary",
			"Modio – minimális méret",
		],
		"modio_1024x1024": [
			"Modio – doporučené rozměry",
			"Modio – doporučené rozmery",
			"Modio – recommended dimensions",
			"Modio – zalecane wymiary",
			"Modio – ajánlott méret",
		],
		"modio_2048x2048": [
			"Modio – maximální rozměry",
			"Modio – maximálne rozmery",
			"Modio – maximum dimensions",
			"Modio – maximalne wymiary",
			"Modio – maximális méret",
		],
		"mall_1280x1024": [
			"Mall – minimální rozměry",
			"Mall – minimálne rozmery",
			"Mall – minimum dimensions",
			"Mall – minimalne wymiary",
			"Mall – minimális méret",
		],
		"mall_2000x2000": [
			"Mall – maximální rozměry",
			"Mall – maximálne rozmery",
			"Mall – maximum dimensions",
			"Mall – maximalne wymiary",
			"Mall – maximális méret",
		],
		"kaufland_1024x1024": [
			"Kaufland – minimální rozměry",
			"Kaufland – minimálne rozmery",
			"Kaufland – minimum dimensions",
			"Kaufland – minimalne wymiary",
			"Kaufland – minimális méret",
		],
		"kaufland_2048x2048": [
			"Kaufland – doporučené rozměry",
			"Kaufland – doporučené rozmery",
			"Kaufland – recommended dimensions",
			"Kaufland – zalecane wymiary",
			"Kaufland – ajánlott méret",
		],
		"snapchat_200x200": [
			"Snapchat – minimální rozměry",
			"Snapchat – minimálne rozmery",
			"Snapchat – minimum dimensions",
			"Snapchat – minimalne wymiary",
			"Snapchat – minimális méret",
		],
		"pinterest_200x300": [
			"Pinterest – minimální rozměry",
			"Pinterest – minimálne rozmery",
			"Pinterest – minimum dimensions",
			"Pinterest – minimalne wymiary",
			"Pinterest – minimális méret",
		],
		"pinterest_600x900": [
			"Pinterest – minimální rozměry",
			"Pinterest – minimálne rozmery",
			"Pinterest – minimum dimensions",
			"Pinterest – minimalne wymiary",
			"Pinterest – minimális méret",
		],
		"pinterest_1000x1500": [
			"Pinterest – doporučené rozměry",
			"Pinterest – doporučené rozmery",
			"Pinterest – recommended dimensions",
			"Pinterest – zalecane wymiary",
			"Pinterest – ajánlott méret",
		],
		"pinterest_1080x1920": [
			"Pinterest – doporučené rozměry",
			"Pinterest – doporučené rozmery",
			"Pinterest – recommended dimensions",
			"Pinterest – zalecane wymiary",
			"Pinterest – ajánlott méret",
		],
		"pinterest_1080x1080": [
			"Pinterest",
			"Pinterest",
			"Pinterest",
			"Pinterest",
			"Pinterest",
		],
		"find_format": [
			"Najít formát",
			"Nájsť formát",
			"Find format",
			"Znajdź format",
			"Formátum keresése",
		],
		"custom_formats": [
			"Vlastní formáty",
			"Vlastné formáty",
			"Custom formats",
			"Formaty niestandardowe",
			"Egyéni formátumok",
		],
		"other_formats": [
			"Další formáty",
			"Ďalšie formáty",
			"Other formats",
			"Inne formaty",
			"További formátumok",
		],
		"elements_availability": [
			"Dostupnost elementů v dynamických šablonách",
			"Dostupnosť elementov v dynamických šablónach",
			"Availability of elements in dynamic templates",
			"Dostępność elementów w szablonach dynamicznych",
			"Elemek elérhetősége dinamikus sablonokban",
		],
		"product_elements": [
			"Elementy",
			"Elementy",
			"Elements",
			"Elementy",
			"Elemek",
		],
		"filter_missing_elements": [
			"Filtrovat chybejíci nebo prázdné elementy",
			"Filtrovať chýbajúce alebo prázdne elementy",
			"Filter missing or empty elements",
			"Filtruj brakujące lub puste elementy",
			"Hiányzó vagy üres elemek szűrése",
		],
		"only_updated_products": [
			"Pouze produkty které prošly pravidly po uložení šablony",
			"Iba produkty ktoré prešli pravidlami po uložení šablóny",
			"Only products updated by MERGADO rules after template was saved",
			"Tylko produkty, które przeszły regulamin po zapisaniu szablonu",
			"Csak azok a termékek, amik a sablon mentése után megfeleltek a szabályoknak",
		],
		"ok": [
			"V pořádku",
			"OK",
			"OK",
			"OK",
			"Ok",
		],
		"empty_elements": [
			"Prázdné elementy",
			"Prázdne elementy",
			"Empty elements",
			"Puste elementy",
			"Üres elemek",
		],
		"toggle_snap_to_guides": [
			"Přichytávat",
			"Prichytávať",
			"Snap",
			"Przyciągaj",
			"Illesztés",
		],
		"toggle_snap_to_grid": [
			"Přichytávat k mřížce",
			"Prichytávať k mriežke",
			"Snap to grid",
			"Przyciągaj do siatki",
			"Rácshoz igazítás",
		],
		"toggle_snap_to_element": [
			"Přichytávat k prvku",
			"Prichytávať k prvku",
			"Snap to element",
			"Przyciągaj do elementu",
			"Elemhez igazítás",
		],
		"show_grid": [
			"Mřížka",
			"Mriežka",
			"Grid",
			"Siatka",
			"Rács",
		],
		"snap_strength": [
			"Pevnost přichycení",
			"Pevnosť pri uchopení",
			"Snap strength",
			"Siła przyciągania",
			"Illesztési erősség",
		],
		"is_anim_gif": [
			"Animovaný GIF",
			"Animovaný GIF",
			"Animated GIF",
			"Animowany GIF",
			"Animált GIF",
		],
		"outpainting": [
			"Outpainting",
			"Outpainting",
			"Outpainting",
			"Outpainting",
			"Outpainting",
		],
		"frames_delay": [
			"Zpoždění mezi smínky [ms]",
			"Oneskorenie medzi snímkami [ms]",
			"Delay between frames [ms]",
			"Opóźnienie między klatkami [ms]",
			"Képkockák közötti késleltetés [ms]",
		],
		"loops_delay": [
			"Zpoždění na konci [ms]",
			"Oneskorenie na konci slučky [ms]",
			"Delay at the end of the loop [ms]",
			"Opóźnienie na końcu pętli [ms]",
			"Késleltetés a ciklus végén",
		],
		"info_no_active_template": [
			"Aktuálně nemáte aktivní ani jednu šablonu. Feed Image Editor začne pracovat poté, co nějakou aktivujete.",
			"Aktuálne nemáte aktívnu ani jednu šablónu. Feed Image Editor začne pracovať v momente, keď nejakú z nich aktivujete.",
			"You currently have no templates active. Feed Image Editor starts working after you activate one.",
			"W tym momencie nie masz aktywnych szablonów. Feed Image Editor zacznie pracować, kiedy aktywujesz jeden lub więcej szablonów.",
			"Jelenleg nincs aktív sablonja. Ahogy aktivál egyet, a Feed Image Editor működni kezd.",
		],
		"info_no_template": [
			"<b>Nemáte vytvořenou žádnou šablonu.</b><br/>Vyberte si jednu z předchystaných šablon z galerie, nebo si vytvořte vlastní.",
			"<b>Nemáte vytvorenú žiadnu šablónu.</b><br/>Vyberte si jednu z predchystaných šablón z galérie alebo si vytvorte vlastnú.",
			"<b>You have not created a template.</b><br/>Choose one of the ready-made templates from the gallery, or create your own.",
			"<b>Stworzyłeś szablon.</b><br/>Wybierz jeden z gotowych szablonów z galerii lub stwórz swój własny.",
			"<b>Nincs létrehozott sablonja.</b><br/>Válasszon egyet a galériában lévő kész sablonok közül, vagy hozzon létre saját sablont.",
		],
		"info_workshop": [
			"Naučte se, jak využívat využívat Feed Image Editor na sto procent. Přihlaste se na školení o image marketingu, které pro vás zdarma pořádáme. <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.cz/skoleni\")>Zjistěte více</span>.",
			"Naučte sa využívať Feed Image Editor na sto percent. Prihláste sa na školenie o image marketingu, ktoré pre vás organizujeme zdarma. <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.sk/skolenie\")>Zistite viac</span>.",
			"Learn to use Feed Image Editor flawlessly. Sign up for the free image marketing workshop. <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.com/workshop\")>Find out more</span>.",
			"Naucz się jak korzystać z Feed Image Editor. Zapisz się na darmowe warsztaty. <span class=\"link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.pl/workshop\")>Dowiedz się więcej</span>.",
			"Tanulja meg száz százalékosan használni a Feed Image Editor. Iratkozzon fel ingyenes image marketing képzésünkre. <span class=\link\" onClick=Mergado.openWindow(\"https://www.feed-image-editor.cz/skoleni\")>Tudjon meg többet</span>.",
		],
		"replace_color": [
			"Nahrazení barev",
			"Nahradenie farieb",
			"Replace colors",
			"Wymiana koloru",
			"Színcsere",
		],
		"target_color": [
			"Nahradit barvu",
			"Nahradiť farbu",
			"Target color",
			"Zastąp kolor",
			"Célszín",
		],
		"replace_by_color": [
			"Barvou",
			"Farbou",
			"Fill color",
			"Według koloru",
			"Csereszín",
		],
		"add_point": [
			"Přidat bod",
			"Pridať bod",
			"Add point",
			"Dodaj punkt",
			"Pont hozzáadása",
		],
		"info_no_points": [
			"Body můžete pridat kliknutím na plátno",
			"Body môžete pridat kliknutím na plátno",
			"You can add new points by clicking on the canvas",
			"Możesz dodawać punkty, klikając płótno",
			"Pontokat a vászonra kattintva tud hozzáadni.",
		],
		"projects_overview": [
			"Přehled projektů",
			"Prehľad projektov",
			"Projects overview",
			"Przegląd projektów",
			"Projektek áttekintése",
		],
		"system": [
			"System",
			"System",
			"System",
			"System",
			"Rendszer",
		],
		"project_info": [
			"Projekt",
			"Projekt",
			"Project",
			"Projekt",
			"Projekt",
		],
		"templates": [
			"Šablony",
			"Šablóny",
			"Templates",
			"Szablony",
			"Sablonok",
		],
		"random_images": [
			"Náhodné obrázky",
			"Náhodné obrázky",
			"Random Images",
			"Losowe obrazy",
			"Random képek",
		],
		"rules": [
			"Pravidla",
			"Pravidlá",
			"Rules",
			"Zasady",
			"Szabályok",
		],
		"queries": [
			"Výběry",
			"Výbery",
			"Queries",
			"Wybory",
			"Szűrők",
		],
		"rabbit": [
			"RabbitMQ",
			"RabbitMQ",
			"RabbitMQ",
			"RabbitMQ",
			"RabbitMQ",
		],
		"points_coordinates": [
			"Relativní pozice bodů",
			"Relatívna pozícia bodov",
			"Relative points position",
			"Względne położenie punktów",
			"Relatív pontpozíciók",
		],
		"no_images_found": [
			"Nenalezeny žadné produkty obsahující obrázky",
			"Nenašli sa žiadne produkty obsahujúce obrázky",
			"No products containing images were found",
			"Nie znaleziono produktów zawierających obrazy",
			"Nincs képeket tartalmazó termék",
		],
		"show_helper": [
			"Zobrazovat pomocníka",
			"Zobraziť pomocníka",
			"Show helper",
			"Pokaż pomocnika",
			"Súgó megjelenítése",
		],
		"disable_helper": [
			"Nezobrazovat pomocníka",
			"Nezobrazovať pomocníka",
			"Don't show helper",
			"Nie pokazuj pomocnika",
			"Súgó elrejtése",
		],
		"disable_wheelzoom": [
			"Zakázat zoom kolečkem myši",
			"Zakázať zoom kolieskom myši",
			"Disable mouse wheel zoom",
			"Wyłącz zoom kółkiem myszy",
			"Egérkerékkel való zoomolás letiltása",
		],
		"helper_ok": [
			"V pořádku",
			"V poriadku",
			"Ok",
			"Ok",
			"Ok",
		],
		"helper_close": [
			"Už více nezobrazovat",
			"Už viac nezobrazovať",
			"Do not show anymore",
			"Nie pokazuj pomocnika",
			"Többször ne jelenjen meg",
		],
		"helper": [
			"Pomocník",
			"Pomocník",
			"Helper",
			"Pomocnik",
			"Súgó",
		],
		"need_help_title": [
			"Potřebujete s něčím poradit?",
			"Potrebujete s niečím poradiť?",
			"Do you need help?",
			"Potrzebujesz porady?",
			"Segítségre van szüksége?",
		],
		"need_help_text": [
			"V případě jakýchkoliv podnětů či problémů obraťte se prosím naši podporu <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>.",
			"V prípade akýchkoľvek podnetov či problémov obráťte sa prosím našu podporu <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>.",
			"In case of any suggestions or problems, please contact our support <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>.",
			"W przypadku jakichkolwiek sugestii lub problemów prosimy o kontakt z naszym wsparciem <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>.",
			"Ha bármilyen javaslata vagy problémája lenne, kérjük, lépjen kapcsolatba ügyfélszolgálatunkkal <a href=\mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>.",
		],
		"bezier_no_points": [
			"<ul><li class=\"right-arrow-marker\">Nový bod křivky přidáte kliknutím na plátno</li></ul>",
			"<ul><li class=\"right-arrow-marker\">Nový bod krivky pridáte kliknutím na plátno</li></ul>",
			"<ul><li class=\"right-arrow-marker\">Click on the canvas to add a new curve point</li></ul>",
			"<ul><li class=\"right-arrow-marker\">Kliknij płótno, aby dodać nowy punkt krzywej</li></ul>",
			"<ul><li class=\right-arrow-marker\">Új görbepont hozzáadásához kattintson a vászonra</li></ul>",
		],
		"bezier_add_points": [
			"<ul><li class=\"right-arrow-marker\">Klikněte na plátno, podržte tlačítko stisknuté a nastavte kontrolní body tažením myši. Poté uvolněte tlačítko a můžete nastavit další body.</li></ul>",
			"<ul><li class=\"right-arrow-marker\">Kliknite na plátno, podržte tlačidlo stlačené a nastavte kontrolné body ťahaním myši. Potom uvoľnite tlačidlo a môžete nastaviť ďalšie body.</li></ul>",
			"<ul><li class=\"right-arrow-marker\">Click on the canvas, hold down the button and adjust the control points by dragging the mouse. Then release the button and you can set more points.</li></ul>",
			"<ul><li class=\"right-arrow-marker\">Kliknij płótno, przytrzymaj przycisk i dostosuj punkty kontrolne, przeciągając myszą. Następnie zwolnij przycisk i możesz ustawić więcej punktów.</li></ul>",
			"<ul><li class=\right-arrow-marker\">Kattintson a vászonra, tartsa lenyomva a gombot, és az egér húzásával állítsa be a vezérlőpontokat. Majd engedje el a gombot, és további pontokat állíthat be.</li></ul>",
		],
		"bezier_unselect": [
			"<ul><li>Chcete-li změnit aktivní vrstu, můžete použít pravé tlačítko myši nebo se přepnout v seznamu vrstev.</li></ul>",
			"<ul><li>Ak chcete zmeniť aktívny vrst, môžete použiť pravé tlačidlo myši alebo sa prepnúť v zozname vrstiev.</li></ul>",
			"<ul><li>To change the active layer, you can use the right mouse button for active shape unselect or switch in the layer list.</li></ul>",
			"<ul><li>Aby zmienić aktywną warstwę, możesz użyć prawego przycisku myszy lub przełącznika na liście warstw.</li></ul>",
			"<ul><li>Az aktív réteg módosításához használja a jobb egérgombot, vagy kapcsoljon át a réteglistára.</li></ul>",
		],
		"has_reflection": [
			"Odraz",
			"Odraz",
			"Reflection",
			"Odbicie",
			"Tükörkép",
		],
		"angle": [
			"Úhel",
			"Uhol",
			"Angle",
			"Kąt",
			"Szög",
		],
		"reflection_offset": [
			"Offset",
			"Offset",
			"Offset",
			"Offsetowy",
			"Eltolás",
		],
		"reflection_opacity": [
			"Průhlednost",
			"Priehľadnosť",
			"Opacity",
			"Przezroczystość",
			"Áttetszőség",
		],
		"reflection_flip": [
			"Překlopení",
			"Prevrátiť",
			"Flip",
			"Trzepnięcie",
			"Tükrözés",
		],
		"helper_no_queries": [
			"<ul><li class=\"info-marker\">Zvolte produktový výběr, na který se bude šablona aplikovat. Na vyhledání výběru použijte filtr.</li></ul>",
			"<ul><li class=\"info-marker\">Zvoľte produktový výber, na ktorý sa bude šablóna aplikovať. Na vyhľadanie výberu použite filter.</li></ul>",
			"<ul><li class=\"info-marker\">Select the product query to which the template will be applied. Use a filter to find a selection.</li></ul>",
			"<ul><li class=\"info-marker\">Wybierz wybór produktu, do którego zostanie zastosowany szablon. Użyj filtru, aby znaleźć wybór.</li></ul>",
			"<ul><li class=\info-marker\">Válassza ki a termékcsoportot, amire alkalmazni szeretné a sablont. Használjon szűrőt a csoport kiválasztásához.</li></ul>",
		],
		"helper_one_query": [
			"<ul><li>Zvolit můžete více výběrů.</li></ul>",
			"<ul><li>Zvoliť môžete viacero výberov.</li></ul>",
			"<ul><li>You can select multiple queries.</li></ul>",
			"<ul><li>Możesz dokonać większej liczby wyborów</li></ul>",
			"<ul><li>Több szűrőt is választhat.</li></ul>",
		],
		"helper_at_least_one_query": [
			"<ul><li>Zvolené výběry najdete vždy nahoře v seznamu.</li></ul>",
			"<ul><li>Zvolené výbery nájdete vždy navrchu zoznamu.</li></ul>",
			"<ul><li>You will always find the selected queries at the top of the list.</li></ul>",
			"<ul><li>Zawsze znajdziesz wybrane pozycje na górze listy.</li></ul>",
			"<ul><li>A kiválasztottakat mindig a lista tetején találja.</li></ul>",
		],
		"helper_zero_products_query": [
			"<ul><li class=\"exclamation-marker\">Zvolený výběr neobsahuje žádné produkty.</li></ul>",
			"<ul><li class=\"exclamation-marker\">Zvolený výber neobsahuje žiadne produkty.</li></ul>",
			"<ul><li class=\"exclamation-marker\">The selected query does not contain any products.</li></ul>",
			"<ul><li class=\"exclamation-marker\">Wybrany wybór nie zawiera żadnych produktów.</li></ul>",
			"<ul><li class=\exclamation-marker\">A kiválasztott szűrő nem tartalmaz terméket.</li></ul>",
		],
		"helper_no_format": [
			"<ul><li class=\"info-marker\">Zvolte jeden z přednastavených výstupních formátů. Vlastní formát si vytvoříte na konci seznamu, nebo v Nastaveních.</li></ul>",
			"<ul><li class=\"info-marker\">Zvoľte jeden z prednastavených výstupných formátov. Vlastný formát si vytvoríte na konci zoznamu alebo v Nastaveniach.</li></ul>",
			"<ul><li class=\"info-marker\">Select one of the output formats. You create your own format at the bottom of the list or in Settings.</li></ul>",
			"<ul><li class=\"info-marker\">Wybierz jeden z formatów wyjściowych. Możesz utworzyć własny format na końcu listy lub w Ustawieniach.</li></ul>",
			"<ul><li class=\info-marker\">Válasszon egyet az előre beállított kimeneti formátumok közül. Egyéni formátumot a lista végén vagy a Beállítások menüpontban tud létrehozni.</li></ul>",
		],
		"helper_format_selected": [
			"<ul><li>Zvolte jednu z možností přizpůsobení obrázků.</li><li>Šířku přesahu upravte ručně podle potřeby.</li></ul>",
			"<ul><li>Zvoľte jednu z možností prispôsobenia obrázkov.</li><li>Šírku presahu upravte ručne podľa potreby.</li></ul>",
			"<ul><li>Select the adjustment method.</li><li>Adjust the overlap manually as required.</li></ul>",
			"<ul><li>Wybierz jedną z opcji dostosowywania obrazu.</li><li>W razie potrzeby dostosuj ręcznie szerokość nakładania.</li></ul>",
			"<ul><li>Válasszon egyet a képkorrekciós lehetőségek közül.</li><li>Az átfedés szélességét manuálisan módosítsa szükség szerint.</li></ul>",
		],
		"helper_no_layer": [
			"<ul><li class=\"info-marker\">Kliknutím na Nová vrstva do obrázků přidáte text, štítky, grafiku a další prvky.</li></ul>",
			"<ul><li class=\"info-marker\">Kliknutím na Nová vrstva pridáte do obrázkov text, štítky, grafiku a ďalšie prvky.</li></ul>",
			"<ul><li class=\"info-marker\">Click on the New Layer to add text, labels, graphics, and more to your images.</li></ul>",
			"<ul><li class=\"info-marker\">Kliknij opcję Nowa warstwa, aby dodać tekst, etykiety, grafikę i nie tylko do obrazów.</li></ul>",
			"<ul><li class=\info-marker\">Az Új réteg gombra kattintva szöveget, címkéket, ábrákat és egyéb elemeket adhat a képhez.</li></ul>",
		],
		"helper_at_least_one_layer": [
			"<ul><li>Pořadí vrstiev změníte {ArrowVIcon} přesunutím.</li><li>Vrstvy s elementy mají pevné pořadí nahoře v plátně.</li><li>Nezapomeňte si šablonu pojmenovat a uložit.</li></ul>",
			"<ul><li>Poradie vrstiev zmeníte {ArrowVIcon} presunutím.</li><li>Vrstvy s elementami majú pevné poradie na vrchu plátna.</li><li>Nezabudnite si šablónu pomenovať a uložiť.</li></ul>",
			"<ul><li>You can change the layers order by dragging {ArrowVIcon}.</li><li>The layers with the dynamic elements will be fixed on the top of the canvas.</li><li>Don't forget to name and save the template.</li></ul>",
			"<ul><li>Aby zmienić kolejność warstw, {ArrowVIcon} przesuń.</li><li>Warstwy z elementami mają ustaloną kolejność u góry obszaru roboczego.</li><li>Nie zapomnij nazwać i zapisać szablonu.</li></ul>",
			"<ul><li>A rétegek sorrendje megváltoztatható a {ArrowVIcon} áthúzásával.</li><li>Az elemeket tartalmazó rétegek fix sorrendben a vászon tetején találhatók.</li><li>Ne felejtse el elnevezni és elmenteni a sablont.</li></ul>",
		],
		"helper_two_more_layers": [
			"<ul><li>Podržte <span class=\"framed\">CTRL</span> a kurzorem označte více vrstev. Tlačítkem {GroupIcon} je seskupíte do jedné vrstvy. Stejným tlačítkem vrstvy nazpět rozdělíte.</li><li>Vodicí linky vám usnadní zarovnávání vrstev. Aktivujete a deaktivujete je tlačítkem {MagnetIcon}</li></ul>",
			"<ul><li>Podržte <span class=\"framed\">CTRL</span> a kurzorom označte viacero vrstiev. Tlačidlom {GroupIcon} ich zoskupíte do jednej vrstvy. Tým istým tlačidlom vrstvy naspäť rozdelíte.</li><li>Vodiace linky vám uľahčia zarovnávanie vrstiev. Aktivujete a deaktivujete ich tlačidlom {MagnetIcon}</li></ul>",
			"<ul><li>Press <span class=\"framed\">CTRL</span> and click on the multiple layers. You can select more layers and group them by {GroupIcon} into one layer. You can use the same button to ungroup the layer back.</li><li>Guide-lines make it easier for you to align the layers. You activate and deactivate the guidelines press {MagnetIcon} button.</li></ul>",
			"<ul><li>Przytrzymaj klawisz <span class=\"framed\">CTRL</span>  i najedź kursorem na wiele warstw. Użyj przycisku {GroupIcon} aby pogrupować je w jedną warstwę. Użyj tego samego przycisku, aby z powrotem podzielić warstwę.</li><li>Linie pomocnicze ułatwiają wyrównywanie warstw. Aktywujesz je i dezaktywujesz za pomocą przycisku {MagnetIcon}</li></ul>",
			"<ul><li>Tartsa lenyomva a <span class=\framed\">CTRL</span> billentyűt, és használja a kurzort több réteg kijelöléséhez. A {GroupIcon} gombbal egy rétegbe csoportosíthatja azokat. Ugyanezzel a gombbal a rétegek szétválaszthatók.</li><li>A vezérvonalak megkönnyítik a rétegek összehangolását. Aktiválásához és deaktiváláshoz használja ezt a gombot {MagnetIcon}</li></ul>",
		],
		"layers": [
			"Vrstvy",
			"Vrstvy",
			"Layers",
			"Warstwy",
			"Rétegek",
		],
		"brush_spacing": [
			"Rozestup",
			"Rozstup",
			"Spacing",
			"Odległość",
			"Ecsettávolság",
		],
		"brush_color": [
			"Barva",
			"Farba",
			"Color",
			"Kolor",
			"Színe",
		],
		"brush_pattern": [
			"Vzor",
			"Vzor",
			"Pattern",
			"Wzór",
			"Minta",
		],
		"brush_pattern_color": [
			"Barva vzoru",
			"Farba vzoru",
			"Pattern color",
			"Kolor wzoru",
			"Minta színe",
		],
		"brush_rotate_pattern": [
			"Natáčet vzor",
			"Natáčať vzor",
			"Rotate pattern",
			"Obróć wzór",
			"Forgatás minta",
		],
		"linewidth_profile": [
			"Profil šířky čáry",
			"Profil šírky čiary",
			"Line width profile",
			"Profil szerokości linii",
			"Vonalszélesség profil",
		],
		"uniform": [
			"stejnoměrný",
			"rovnomerný",
			"uniform",
			"mundur",
			"egyenruha",
		],
		"fade_out": [
			"postupně zeslabit",
			"postupne zoslabiť",
			"fade out",
			"stopniowo słabnąć",
			"fokozatosan gyengül",
		],
		"fade_in": [
			"postupně zesílit",
			"postupne zosilniť",
			"fade in",
			"stopniowo zwiększać siłę",
			"fokozatosan növekszik az erő",
		],
		"fading": [
			"na koncích zeslabit",
			"na koncoch zoslabiť",
			"fading both sides",
			"osłabiać na końcach",
			"hogy a végein legyengüljön",
		],
		"zoom_in": [
			"zvětšit",
			"priblížiť",
			"zoom in",
			"zbliżenie",
			"nagyítás",
		],
		"zoom_out": [
			"zmenšit",
			"oddialiť",
			"zoom out",
			"pomniejsz",
			"kicsinyítés",
		],
		"token_not_provided": [
			"Chyba ověření - token není poskytnut",
			"Chyba overenia - token nebol poskytnutý",
			"Authentication error - token not provided",
			"Błąd uwierzytelniania - nie podano tokena",
			"Hitelesítési hiba - nincs megadva biztonsági token",
		],
		"toast_online_call": [
			"Nevíte si rady, nebo potřebujete pomoct s vytvořením první obrazové kampaně? Domluvte si <span class=\"link\" onClick=Mergado.openWindow(\"https://calendly.com/feed-image-editor\")>online call s Markem</span>, který vám rád poradí, jak využít Feed Image Editor na maximum.",
			"Neviete si rady, alebo potrebujete pomôcť s vytvorením prvej obrazovej kampane? Dohodnite si <span class=\"link\" onClick=Mergado.openWindow(\"https://calendly.com/feed-image-editor\")>online call s Marekom</span>, ktorý vám poradí, ako využiť Feed Image Editor na maximum.",
			"Not sure or need help creating your first image campaign? Make an <span class=\"link\" onClick=Mergado.openWindow(\"https://calendly.com/feed-image-editor\")>online call with Marek</span>,He will be happy to advise you on how to make the most of the Feed Image Editor.",
			"Czy potrzebujesz pomocy przy tworzeniu swojej pierwszej kampanii wizerunkowej? Umów się na spotkanie <span class=\"link\" onClick=Mergado.openWindow(\"https://calendly.com/feed-image-editor\")> online z Markiem</span>, który z przyjemnością doradzi Ci, jak najlepiej wykorzystać możliwości Feed Image Editor do maksimum.",
			"Tanácstalan, netán segítségre lenne szüksége az első képkampány létrehozásához? Beszéljen meg <span class=\link\" onClick=Mergado.openWindow(\"https://calendly.com/feed-image-editor\")>egy online hívást Marekkel </span>, aki szívesen ad tanácsot, hogyan tudja a legtöbbet kihozni a Feed Image Editorból.",
		],
		"online_call_header": [
			"Chcete pomoc s nastavením nebo inspiraci pro vaše kampaně?",
			"Chcete pomoc s nastavením alebo inšpiráciu pre vaše kampane?",
			"Do you want help with setup or inspiration for your campaigns?",
			"Chcesz pomocy przy konfiguracji lub inspiracji dla swoich kampanii?",
			"Szeretne segítséget a beállításban vagy ihletet a kampányaihoz?",
		],
		"online_call": [
			"Rezervujte si krátkou bezplatnou konzultaci s Markem. Ukáže vám nejlepší postupy pro váš typ e-shopu, pomůže s nastavením a zodpoví vše, co vás zajímá.",
			"Rezervujte si krátku bezplatnú konzultáciu s Marekom. Ukáže vám najlepšie postupy pre váš typ e-shopu, pomôže s nastavením a zodpovie všetko, čo vás zaujíma.",
			"Book a short free consultation with Marek. He will show you best practices for your type of e-shop, help with the setup, and answer anything you want to know.",
			"Zarezerwuj krótką, bezpłatną konsultację z Markiem. Pokaże Ci najlepsze praktyki dla Twojego typu e-sklepu, pomoże z ustawieniami i odpowie na wszystkie pytania.",
			"Foglaljon egy rövid, ingyenes konzultációt Markkal. Megmutatja az Ön webáruház-típusához legjobb bevált gyakorlatokat, segít a beállításban, és megválaszol minden kérdést.",
		],
		"watermark_mask": [
			"Maska vodoznaku",
			"Maska vodoznaku",
			"Watermark mask",
			"Maska znaku wodnego",
			"Vízjel maszk",
		],
		"watermark_masked_image": [
			"Vodoznak",
			"Vodoznak",
			"Masked watermark image",
			"Zamaskowany znak wodny",
			"Vízjel",
		],
		"watermark_group": [
			"Skupina vodoznaků",
			"Skupina vodoznakov",
			"Watermark group",
			"Grupa znaków wodnych",
			"Vízjel csoport",
		],
		"watermark_groups": [
			"Skupiny vodoznaků",
			"Skupiny vodoznakov",
			"Watermark groups",
			"Grupy znaków wodnych",
			"Vízjel csoportok",
		],
		"watermark_methods": [
			"Metody odstranění vodoznaků",
			"Metódy odstránenia vodoznakov",
			"Watermark removal methods",
			"Metody usuwania znaku wodnego",
			"Vízjel eltávolítási módszerek",
		],
		"create_new_group": [
			"Vytvořit novou skupinu",
			"Vytvoriť novú skupinu",
			"Create new group",
			"Utwórz nową grupę",
			"Új csoport létrehozása",
		],
		"new_group": [
			"Nová skupina",
			"Nová skupina",
			"New group",
			"Nowa grupa",
			"Új csoport",
		],
		"required_field": [
			"Povinné pole",
			"Požadované pole",
			"Required field",
			"Pole wymagane",
			"Kötelező mező",
		],
		"no_watermark_masks": [
			"Zatím nemáte označené žádné vodoznaky",
			"Zatiaľ nemáte označené žiadne vodoznaky",
			"You have no watermarks marked yet",
			"Nie wybrałeś jeszcze żadnych znaków wodnych",
			"Még nincs kijelölt vízjele",
		],
		"downloaded": [
			"Staženo",
			"Stiahnuté",
			"Downloaded",
			"Pobrano",
			"Letöltve",
		],
		"status_ok": [
			"Stav v pořádku",
			"Stav v poriadku",
			"Status OK",
			"Stan OK",
			"Állapot OK",
		],
		"waiting_to_process": [
			"Čeká na zpracování",
			"Čaká na spracovanie",
			"Waiting to process",
			"Oczekiwanie na przetwarzanie",
			"Feldolgozásra vár",
		],
		"inpaint_error": [
			"Chyba odstaranění vodoznaku",
			"Chyba odstaranění vodoznaku",
			"Watermark removal error",
			"Błąd usuwania znaku wodnego",
			"Vízjel eltávolítási hiba",
		],
		"watermark_group_not_selected": [
			"Nejprve vyberte skupinu vodoznaků",
			"Najskôr vyberte skupinu vodoznakov",
			"Please select the watermark group first",
			"Najpierw wybierz grupę znaków wodnych",
			"Először válasszon vízjel csoportot",
		],
		"background": [
			"Pozadí",
			"Pozadie",
			"Background",
			"Tło",
			"Háttér",
		],
		"remove_background": [
			"Odstranit pozadí",
			"Odstrániť pozadie",
			"Remove background",
			"Usuń tło",
			"Háttér eltávolítása",
		],
		"solid_bg": [
			"Jednobarevné",
			"Jednofarebné",
			"Solid color",
			"Jednolity kolor",
			"Monokróm",
		],
		"light_bg": [
			"Světlé pozadí",
			"Svetlé pozadie",
			"Light background",
			"Jasne tło",
			"Világos háttér",
		],
		"dark_bg": [
			"Tmavé pozadí",
			"Tmavé pozadie",
			"Dark background",
			"Ciemne tło",
			"Sötét háttér",
		],
		"background_colors": [
			"Barvy",
			"Farby",
			"Colors",
			"Zabarwienie",
			"Színek",
		],
		"background_shade": [
			"Odstín pozadí",
			"Odtieň pozadia",
			"Background shade",
			"Odcień tła",
			"Háttér árnyalat",
		],
		"not_transparent_bg": [
			"Neprůhledné pozadí",
			"Nie priehľadné pozadie",
			"Not transparent",
			"Nieprzezroczyste tło",
			"Nem áttetsző háttér",
		],
		"transparent_bg": [
			"Průhledné pozadí",
			"Priehľadné pozadie",
			"Transparent background",
			"Przezroczyste tło",
			"Áttetsző háttér",
		],
		"multicolor_bg": [
			"Vícebarevné",
			"Viacfarebné",
			"Multicolor",
			"Wielokolorowe",
			"Sokszínű",
		],
		"status_not_recommended_colorspace": [
			"Barevné modely",
			"Farebné modely",
			"Color models",
			"Kolorowe modele",
			"Színmodellek",
		],
		"not_recommended_colorspace": [
			"Barevné modely",
			"Farebné modely",
			"Color models",
			"Kolorowe modele",
			"Színmodellek",
		],
		"not_recommended_colorspace_description": [
			"Vaše obrázky jsou v barevném modelu CMYK, který není vhodný pro zobrazování na obrazovkách počítačů a mobilních zařízení. Takovéto obrázky odradí vaše zákazníky. Překonvertujte obrázky do barevného modelu RGB.",
			"Vaše obrázky sú vo farebnom modely CMYK, ktorý nie je vhodný  pre zobrazovanie na obrazovkách počítačov alebo mobilných zariadení. Takéto obrázky odradia vašich zákazníkov. Prekonvertujte obrázky do farebného modelu RGB.",
			"Your images are in a CMYK color model, which is not suitable for displaying on a computer and a mobile screen. Such images draw back your customers. Convert the images to an RGB color model.",
			"Twoje obrazy są w zapisane z użyciem modelu kolorów CMYK, który nie pozwala na wyświetlanie obrazów na komputerach stacjonarnych lub urządzeniach mobilnych. Takie obrazy nie zachęcają kupujących. Przekonwertuj obrazy na model kolorów RGB.",
			"A képek CMYK színmodellűek, ezek nem alkalmas a számítógépek képernyőjén és mobileszközökön való megjelenítésre. Az ilyen képek elriasztják az ügyfeleket. Konvertálja a képeket RGB színmodellre.",
		],
		"status_unsupported_background": [
			"Pozadí obrázku",
			"Pozadie obrázku",
			"Image background",
			"Niewłaściwe tło",
			"Képháttér",
		],
		"unsupported_background": [
			"Pozadí obrázku",
			"Pozadie obrázku",
			"Image background",
			"Niewłaściwe tło",
			"Képháttér",
		],
		"unsupported_background_description": [
			"Srovnávače zboží a inzertní sítě se liší v požadavcích na pozadí produktových obrázků. Velká část z nich vyžaduje jednobarevné bílé pozadí. Pokud na ně odešlete obrázky nebo produktové fotografie s barevným pozadím, nedostanete tyto produkty do inzerce. Na některých srovnávačích to ale naopak možné je.",
			"Porovnávače tovaru a inzertné siete sa líšia v požiadavkách na pozadie produktových obrázkov. Veľká časť z nich vyžaduje jednofarebné biele pozadie. Ak na ne odošlete obrázky alebo produktové fotografie s farebným pozadím, nedostanete tieto produkty do inzercie. Na niektorých porovnávačoch to ale naopak možné je.",
			"Comparison engines and advertising channels differ in background requirements for product images. Most of them require a monochrome white background. If you submit images or product photos with a colored background, you will not receive these products for advertising. On the contrary, it is possible to use colored background images or photos for some comparators.",
			"Reklamy mogą być ograniczone a obrazy moga nie wyświetlać się właściwie ponieważ co wystąpiło co najmniej jedno z poniższych ostrzeżeń. Aby polepszyć jakość swoich reklam i obrazów produktu zastosuj jedną z poniższych sugestiii. Jeśli wprowadzisz obrazy lub produkty z kolorowym tłem, to nie będą one wyświetlane w reklamach. ",
			"Az árösszehasonlító oldalak és a hirdetési csatornák eltérnek a termékképek hátterére vonatkozó követelményeikben.  Nagyrészük monokróm fehér hátteret igényel. Ha színes hátterű képeket vagy termékfotókat tölt fel, ezek a termékek nem kerülnek reklámozásra. Egyes árösszehasonlító oldalakon viszont lehet színes hátterű képeket használni.",
		],
		"set_watermark_group_first": [
			"Nejprve nastavte skupinu vodoznaků!",
			"Najskôr nastavte skupinu vodoznakov!",
			"Please set watermark group first!",
			"Najpierw ustaw grupę znaków wodnych!",
			"Először állítsa be a vízjel csoportot!",
		],
		"unknown_preview_image_error": [
			"Chyba načítání obrázku",
			"Chyba načítavania obrázku",
			"Error loading image",
			"Błąd podczas ładowania obrazu",
			"Képbetöltési hiba",
		],
		"render_preview_error_6": [
			"Neznámá doména",
			"Neznáma doména",
			"Could not resolve host",
			"Nieznana domena",
			"Ismeretlen domain",
		],
		"render_preview_error_1": [
			"Zdrojový obrázek je prázdný",
			"Zdrojový obrázok je prázdny",
			"The source image is empty",
			"Obraz źródłowy jest pusty",
			"Üres forráskép",
		],
		"render_preview_error_420": [
			"Neznámý formát",
			"Neznámy formát",
			"Unknown format",
			"Nieznany format",
			"Ismeretlen formátum",
		],
		"render_preview_error_450": [
			"PNG obrázek má špatný CRC",
			"PNG obrázok má zlý CRC",
			"PNG CRC error",
			"Obraz PNG ma zły CRC",
			"CRC hibás PNG kép",
		],
		"render_preview_error_28": [
			"Server na kterém je obrázek neodpovídá",
			"Server na ktorom je obrázok nezodpovedá",
			"Failed to connect (operation timeout)",
			"Serwer, na którym obraz nie odpowiada",
			"A képet tartalmazó szerver nem válaszol",
		],
		"render_preview_error_35": [
			"Chyba SSL",
			"Chyba SSL",
			"SSL error: wrong signature type",
			"Błąd SSL",
			"SSL hiba",
		],
		"first_steps_wizard": [
			"Průvodce prvním nastavením",
			"Sprievodca prvým nastavením",
			"First setup guide",
			"Przewodnik pierwszej konfiguracji",
			"Első beállítás varázsló",
		],
		"skip_wizard": [
			"Nepotřebuji průvodce, chci přejít do aplikace",
			"Nepotrebujem sprievodcu, chcem prejsť do aplikácie",
			"I don't need a wizard, I want to go to the application",
			"Nie potrzebuję kreatora, chcę przejść do aplikacji",
			"Nincs szükségem varázslóra, szeretnék áttérni az alkalmazásba",
		],
		"close_wizard": [
			"Zavřít průvodce",
			"Zavrieť sprievodca",
			"Close the wizard",
			"Zamknij kreatora",
			"Varázsló bezárása",
		],
		"input_elements_map": [
			"Nastavení vstupních elementů",
			"Nastavenie vstupných elementov",
			"Input elements settings",
			"Ustawienia elementów wejściowych",
			"Bemeneti elemek beállítása",
		],
		"input_output_format": [
			"Nastavení vstupního a výstupního formátu",
			"Nastavenie vstupného a výstupného formátu",
			"Input and output format settings",
			"Ustawienia formatu wejściowego i wyjściowego",
			"Bemeneti és kimeneti formátum beállítások",
		],
		"first_steps_create_template": [
			"Hotovo. Vše je připraveno pro tvorbu první šablony.",
			"Hotovo. Všetko je pripravené na tvorbu prvej šablóny.",
			"Done. Everything is ready for creating the first template.",
			"Gotowe. Wszystko gotowe do stworzenia pierwszego szablonu.",
			"Kész. Minden készen áll az első sablon létrehozásához.",
		],
		"first_step_info": [
			"Vítejte v aplikaci Feed Image Editor, která vám pomůže s hromadní úpravou produktových obrázků vašeho e-shopu pro marketplace, sociální sítě a zbožové srovnávače.<br/>V prvním kroku si prosím vyberte kanál, na kterém chcete inzerovat:",
			"Vitajte v aplikácii Feed Image Editor, ktorá vám pomôže s hromadnou úpravou produktových obrázkov vášho e-shopu pre marketplace, sociálne siete a tovarové porovnávače.<br/>V prvom kroku si prosím vyberte kanál, na ktorom chcete inzerovať:",
			"Welcome to the Feed Image Editor application, which will help you bulk edit your e-shop's product images for marketplaces, social networks and comparison shopping.<br/>In the first step, please select the channel you want to advertise on:",
			"Witamy w aplikacji Feed Image Editor, która pomoże Ci zbiorczo edytować obrazy produktów Twojego e-sklepu dla rynków, sieci społecznościowych i porównywarek.<br/>W pierwszym kroku wybierz kanał, na którym chcesz się reklamować:",
			"Üdvözöljük a Feed Image Editor alkalmazásban, amely segít Önnek a webáruház termékképeit tömeges szerkeszteni a piactereken, közösségi hálókon és árösszehasonlító oldalakon történő használathoz.<br/>Először válassza ki a csatornát, amelyen hirdetni szeretne:",
		],
		"first_step_info_old": [
			"Vítejte v aplikaci Feed Image Editor, která vám pomůže s úpravou obrázků ve vašem e-shopu.<br/>Jako první krok prosím zkontrolujte, jestli jsme vybrali správné elementy z vašeho feedu pro použití v editoru. Poté se již můžete hned pustit do tvorby první šablony.",
			"Vitajte v aplikácií Feed Image Editor, ktorá vám pomôže s úpravou obrázkov vo vašom e-shope. <br/>Ako prvý krok prosím skontrolujte, či sme vybrali správne elementy z vášho feedu pre použitie v editore. Potom sa už môžete hneď pustiť do tvorby prvej šablóny.",
			"Welcome to the Feed Image Editor app, which helps you edit images in your online store. <br/>As a first step, please make sure we have selected the correct elements from your feed for use in the editor. Then you can start creating the first template right away.",
			"Witamy w aplikacji Feed Image Editor, która pomoże Ci edytować obrazy w Twoim e-sklepie. <br/>W pierwszej kolejności upewnij się, że wybraliśmy właściwe elementy z Twojego kanału do wykorzystania w edytorze. Następnie możesz od razu zacząć tworzyć pierwszy szablon.",
			"Üdvözöljük a Feed Image Editor alkalmazásban, amely segít Önnek a webáruházában található képek szerkesztésében.<br/>Első lépésként, kérjük, ellenőrizze, hogy a megfelelő elemeket választottuk-e ki feedjéből a szerkesztőprogramban való használathoz. Ezt követően máris nekiláthat az első sablon létrehozásának.",
		],
		"next_step": [
			"Další krok",
			"Ďalší krok",
			"Next step",
			"Następny krok",
			"Következő lépés",
		],
		"previous_step": [
			"Předešlý krok",
			"Predošlý krok",
			"Previous step",
			"Poprzedni krok",
			"Előző lépés",
		],
		"input_format": [
			"Vstupní formát",
			"Vstupný formát",
			"Input format",
			"Format wejściowy",
			"Bemeneti formátum",
		],
		"output_format": [
			"Výstpuní formát",
			"Výstupný formát",
			"Output format",
			"Format wyjściowy",
			"Kimeneti formátum",
		],
		"preferred_product_preview": [
			"Náhled preferovaného produktu",
			"Náhľad preferovaného produktu",
			"Preferred product preview",
			"Podgląd preferowanego produktu",
			"Tekintse meg kedvenc termékét előzetesen",
		],
		"date_placeholder": [
			"DD. MM. RRRR",
			"DD. MM. RRRR",
			"DD. MM. YYYY",
			"DD. MM. RRRR",
			"NN. HH. ÉÉÉÉ",
		],
		"today": [
			"Dnes",
			"Dnes",
			"Today",
			"Dziś",
			"Ma",
		],
		"news_box_header": [
			"Podívejte se na novinky z aplikace",
			"Pozrite si novinky v aplikácii",
			"See what's new in the app",
			"Zobacz nowości w aolikacji",
			"Nézze meg, milyen újdonságok vannak az alkalmazásban",
		],
		"news_box_body": [
			"<h4>Upravujte produktové obrázky přímo v chatu</h4><p>Feed Image Editor má nyní MCP server – propojení s AI asistenty jako Claude nebo ChatGPT. Místo klikání v rozhraní stačí zadat příkaz v chatu a agent za vás:<ul><li>nastaví šablony a parametry úprav</li><li>přiřadí produkty podle výběru</li><li>upraví rozměry, odstraní pozadí, zvýší rozlišení</li></ul></p><p>Pokud už máte AI asistenta připojeného přes Mergado MCP, Feed Image Editor MCP funguje automaticky a bez dalšího nastavování. V případě, že jste ještě s MCP nepracovali, klikněte na odkaz a během chvilky ho napojíte.</p>",
			"<h4>Upravujte produktové obrázky priamo v chate</h4><p>Feed Image Editor má teraz MCP server – prepojenie s AI asistentmi ako Claude alebo ChatGPT. Namiesto klikania v rozhraní stačí zadať príkaz v chate a agent za vás:<ul><li>nastaví šablóny a parametre úprav</li><li>priradí produkty podľa výberu</li><li>upraví rozmery, odstráni pozadie, zvýší rozlíšenie</li></ul></p><p>Ak už máte AI asistenta pripojeného cez Mergado MCP, Feed Image Editor MCP funguje automaticky a bez ďalšieho nastavovania. V prípade, že ste ešte s MCP nepracovali, kliknite na odkaz a behom chvíľky ho napojíte.</p>",
			"<h4>Edit product images right from your chat</h4><p>Feed Image Editor now has an MCP server – connecting AI assistants like Claude or ChatGPT directly to your editor. Instead of clicking through the interface, just type a request in chat and the agent will:<ul><li>set up templates and edit parameters</li><li>assign products based on a selection</li><li>resize images, remove backgrounds, upscale resolution</li></ul><p>If you already have an AI assistant connected via Mergado MCP, Feed Image Editor MCP works automatically – no extra setup needed. If you haven't worked with MCP yet, just click the link and connect it in a moment.</p>",
			"<h4>Edytuj zdjęcia produktów bezpośrednio w czacie</h4><p>Feed Image Editor obsługuje teraz serwer MCP, co pozwala połączyć asystentów AI, takich jak Claude czy ChatGPT, bezpośrednio z edytorem. Zamiast klikać w interfejsie, wystarczy wpisać polecenie na czacie, a asystent:<ul><li>skonfiguruje szablony i parametry edycji</li><li>przypisze produkty na podstawie dokonanego wyboru</li><li>zmieni rozmiar zdjęć, usunie tło lub zwiększy rozdzielczość</li></ul><p>Jeśli masz już połączonego asystenta AI przez Mergado MCP, Feed Image Editor MCP zadziała automatycznie – bez dodatkowej konfiguracji. Jeśli jeszcze nie korzystasz z MCP, wystarczy kliknąć link i połączyć usługę w kilka chwil.</p>",
			"<h4>Szerkessze termékképeit közvetlenül a csevegőablakból</h4><p>A Feed Image Editor immár MCP-szerverrel is rendelkezik, amely közvetlenül összeköti az olyan MI-asszisztenseket – mint például a Claude vagy a ChatGPT – a szerkesztőfelülettel. Ahelyett, hogy a menükben kattintgatna, egyszerűen írja be kérését a csevegőbe, és az asszisztens elvégzi a következőket:<ul><li>sablonok beállítása és paraméterek módosítása</li><li>termékek hozzárendelése kijelölés alapján</li><li>képméretezés, háttéreltávolítás és felbontásnövelés</li></ul><p>Ha már használ MI-asszisztenst Mergado MCP-n keresztül, a Feed Image Editor MCP-funkciója automatikusan működik – nincs szükség további beállításokra. Ha még nem dolgozott MCP-vel, egyszerűen kattintson a linkre, és pillanatok alatt csatlakoztathatja azt.</p>",
		],
		"news_box_body_link": [
			"Zjistit více →",
			"Zistiť viac →",
			"Learn more →",
			"Dowiedz się więcej →",
			"Tudjon meg többet →",
		],
		"select_template_queries": [
			"Nejdříve vyberte, na jaké produkty chcete šablonu aplikovat",
			"Najprv vyberte, na aké produkty chcete šablónu aplikovať",
			"First, select which products you want to apply the template to",
			"Najpierw wybierz produkty, do których chcesz zastosować szablon",
			"Először válassza ki, hogy mely termékekre szeretné alkalmazni a sablont.",
		],
		"set_output_image_size": [
			"Nastavte si velikost výstupních obrázků",
			"Nastavte si veľkosť výstupných obrázkov",
			"Set the size of the output images",
			"Dostosuj rozmiar obrazów wyjściowych",
			"Állítsa be a kimeneti képek méretét",
		],
		"select_from_template_gallery": [
			"Můžete si vybrat některou z našich připravených šablon",
			"Môžete si vybrať niektorú z našich pripravených šablón",
			"You can choose one of our ready-made templates",
			"Możesz wybrać jeden z naszych gotowych szablonów",
			"Választhat kész sablonjaink közül is",
		],
		"main_image_or_collage": [
			"Zvolte si, jestli chcete mít na výstupu pouze hlavní obrázek, nebo koláž hlavního a alternativních obrázků",
			"Zvoľte si, či chcete mať na výstupe iba hlavný obrázok alebo koláž hlavného a alternatívnych obrázkov",
			"Choose whether you want to have only the main image or a collage of the main one and alternative images at the output",
			"Wybierz, czy chcesz wydrukować tylko główny obraz, czy kolaż głównych i alternatywnych obrazów",
			"Válassza ki, hogy csak a fő kép vagy a fő és az alternatív képek kollázsa legyen-e a kimeneten",
		],
		"main_image_on_canvas_placement": [
			"Umístěte hlavní obrázek na plátno",
			"Umiestnite hlavný obrázok na plátno",
			"Place the main image on the canvas",
			"Umieść główny obraz na płótnie",
			"Helyezze a fő képet a vászonra",
		],
		"set_collage_layout": [
			"Nastavte výsledný vzhled koláže. Pro lepší efekt doporučujeme aktivovat funkci odstranění pozadí.",
			"Nastavte výsledný vzhľad koláže. Pre lepší efekt odporúčame aktivovať fuknciu odstránenia pozadia.",
			"Set the collage layout. For a better effect, we recommend activating the background removal feature.",
			"Ustaw układ kolażu. Aby uzyskać lepszy efekt, zalecamy włączenie funkcji usuwania tła.",
			"Állítsa be a kollázs végső megjelenését. A jobb hatás érdekében javasoljuk a háttéreltávolítás funkció aktiválását.",
		],
		"set_anim_gif": [
			"Nastavte výsledný vzhled animovaného GIFu",
			"Nastavte výsledný vzhľad animovaného GIFu",
			"Set the final appearance of the animated GIF",
			"Ustaw ostateczny wygląd animowanego pliku GIF",
			"Állítsa be az animált GIF végső megjelenését",
		],
		"position_and_rotation": [
			"Pozice a pootočení",
			"Pozícia a pootočenie",
			"Position and rotation",
			"Pozycja i rotacja",
			"Pozíció és forgás",
		],
		"apply_ai_effects_or_filters": [
			"Aplikujte AI efekty nebo filtry na produktový obrázek",
			"Aplikujte AI efekty alebo filtre na produktový obrázok",
			"Apply AI effects or filters to the product image",
			"Zastosuj efekty AI lub filtry do obrazu produktu",
			"Alkalmazza az AI effektusokat vagy szűrőket a termékképen",
		],
		"editor_step_5": [
			"Zvolte si, jestli má být šablona spuštěná hned po vytvoření, nebo až ve vybraný den",
			"Zvoľte si, či má byť šablóna spustená hneď po vytvorení alebo až vo vybraný deň",
			"Choose whether the template should be launched immediately after creation or on the selected day",
			"Wybierz, czy szablon ma być uruchamiany natychmiast po utworzeniu, czy w wybranym dniu",
			"Válassza ki, hogy a sablon a létrehozás után azonnal vagy egy kijelölt napon kezdjen-e el működni",
		],
		"editor_step_6": [
			"Vizuální podobnost obrázků",
			"Vizuálna podobnosť obrázkov",
			"Visual similarity of images",
			"Wizualne podobieństwo obrazów",
			"A képek vizuális hasonlósága",
		],
		"editor_step_7": [
			"Přidejte si další vrstvy s grafickými prvky",
			"Pridajte si ďalšie vrstvy s grafickými prvkami",
			"Add more layers with graphic elements",
			"Dodaj więcej warstw z elementami graficznymi",
			"Adjon további rétegeket a képhez grafikus elemekkel",
		],
		"helper_tips": [
			"<ul><li>Chtěli byste v appce používat vlastní font? Napište nám na support@feedimageeditor.com</li><li>Víte, že v editoru můžete používat klávesové zkratky?<div class='quote'><span class='framed'>Ins</span><span>Vložit novou vrstvu</span><br/><span class='framed'>Del</span><span>Smazat vrstvu</span><br/><span class='framed'>Ctrl + s</span><span>Uložit šablonu</span><br/><span class='framed'>Ctrl + z</span><span>Editace zpět</span><br/><span class='framed'>Ctrl + y</span><span>Editace znovu</span><br/><span class='framed'>Ctrl + c</span><span>Kopírovat vrstvu</span><br/><span class='framed'>Ctrl + v</span><span>Vložit vrstvu</span></div></li></ul>",
			"<ul><li>Chceli by ste v appke používať vlastný font? Napíšte nám na support@feedimageeditor.com</li><li>Viete, že v editore môžete používať klávesové skratky?<div class='quote'><span class='framed'>Ins</span><span>Vložiť novú vrstvu</span><br/><span class='framed'>Del</span><span>Zmazať vrstvu</span><br/><span class='framed'>Ctrl + s</span><span>Uložiť šablónu</span><br/><span class='framed'>Ctrl + z</span><span>Editácia späť</span><br/><span class='framed'>Ctrl + y</span><span>Editácia znova</span><br/><span class='framed'>Ctrl + c</span><span>Kopírovať vrstvu</span><br/><span class='framed'>Ctrl + v</span><span>Vložiť vrstvu</span></div></li></ul>",
			"<ul><li>Would you like to use your own font in the app? Contact support@feedimageeditor.com</li><li>Did you know you can use keyboard shortcuts in the editor?<div class='quote'><span class='framed'>Ins</span><span>Insert a new layer</span><br/><span class='framed'>Del</span><span>Delete layer</span><br/><span class='framed'>Ctrl + s</span><span>Save template</span><br/><span class='framed'>Ctrl + z</span><span>Undo</span><br/><span class='framed'>Ctrl + y</span><span>Redo</span><br/><span class='framed'>Ctrl + c</span><span>Copy layer</span><br/><span class='framed'>Ctrl + v</span><span>Paste layer</span></div></li></ul>",
			"<ul><li>Czy chciałbyś użyć w aplikacji własnej czcionki? Napisz do nas na support@feedimageeditor.com</li><li>Czy wiesz, że w edytorze możesz używać skrótów klawiaturowych?<div class='quote'><span class='framed'>Ins</span><span>Dodaj nową warstwę</span><br/><span class='framed'>Del</span><span>Usuń warstwę</span><br/><span class='framed'>Ctrl + s</span><span>Zapisz szablon</span><br/><span class='framed'>Ctrl + z</span><span>Wróć</span><br/><span class='framed'>Ctrl + y</span><span>Przywróć</span><br/><span class='framed'>Ctrl + c</span><span>Skopiuj warstwę</span><br/><span class='framed'>Ctrl + v</span><span>Wstaw warstwę</span></div></li></ul>",
			"<ul><li>Saját betűtípust szeretne használni az alkalmazásban? Írjon nekünk support@feedimageeditor.com</li><li>Tudta, hogy a szerkesztőben gyorsbillentyűket is használhat?<div class='quote'><span class='framed'>Ins</span><span>Új réteg beillesztése</span><br/><span class='framed'>Del</span><span>Réteg törlése</span><br/><span class='framed'>Ctrl + s</span><span>Sablon mentése</span><br/><span class='framed'>Ctrl + z</span><span>Mégsem</span><br/><span class='framed'>Ctrl + y</span><span>Mégis</span><br/><span class='framed'>Ctrl + c</span><span>Réteg másolása</span><br/><span class='framed'>Ctrl + v</span><span>Réteg beillesztése</span></div></li></ul>",
		],
		"more_fonts": [
			"Chtěli byste v appce používat vlastní font? Napište nám na <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>",
			"Chceli by ste v appke používať vlastný font? Napíšte nám na <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>",
			"Would you like to use your own font in the app? Contact <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>",
			"Czy chciałbyś użyć w aplikacji własnej czcionki? Napisz do nas na <a href=\"mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>",
			"Saját betűtípust szeretne használni az alkalmazásban? Írjon nekünk <a href=\mailto:support@feedimageeditor.com\" class=\"mail-link\">support@feedimageeditor.com</a>",
		],
		"editor_step_0": [
			"Vyberte typ šablony",
			"Vyberte typ šablóny",
			"Select template type",
			"Wybierz typ szablonu",
			"Sablontípus kiválasztása",
		],
		"layout": [
			"Rozvržení obrázků",
			"Rozvrhnutie obrázkov",
			"Image Layout",
			"Układ obrazu",
			"Képek elrendezése",
		],
		"autoonoff": [
			"Plánovač aktivity",
			"Plánovač aktivity",
			"Activity Planner",
			"Planer aktywności",
			"Tevékenység tervező",
		],
		"success": [
			"V pořádku",
			"V poriadku",
			"Status ok",
			"W porządku",
			"Sikeres kérés",
		],
		"zoom": [
			"Zvětšení",
			"Priblíženie",
			"Zoom",
			"Powiększenie",
			"Nagyítás",
		],
		"pan": [
			"Posunutí",
			"Posúvanie",
			"Pan",
			"Panoramowanie",
			"Eltolás",
		],
		"draw": [
			"Kreslit",
			"Kresliť",
			"Draw",
			"Remis",
			"Rajzolás",
		],
		"move": [
			"Posunout",
			"Posunúť",
			"Move",
			"Ruszaj się",
			"Mozgatás",
		],
		"reset_zoom": [
			"Reset zoom",
			"Reset zoom",
			"Reset zoom",
			"Reset zoom",
			"Eredeti nagyító",
		],
		"queued_at": [
			"Zařazeno do fronty",
			"Zaradené do fronty",
			"Queued At",
			"W kolejce",
			"Sorbaállítva",
		],
		"score": [
			"Skóre",
			"Skóre",
			"Score",
			"Wynik",
			"Pontszám",
		],
		"ai_tools": [
			"AI nástroje",
			"AI nástroje",
			"AI tools",
			"Narzędzia sztucznej inteligencji",
			"AI eszközök",
		],
		"missing_symbols": [
			"Tento font neobsahuje všechny symboly, živý náhled a vyrenderovaný obrázek se mohou lišit.",
			"Tento font neobsahuje všetky symboly, živý náhľad a vyrenderovaný obrázok sa môžu líšiť.",
			"This font does not contain all symbols, the live preview and the rendered image may differ.",
			"Czcionka nie zawiera wszystkich symboli, podgląd na żywo i renderowany obraz mogą się różnić.",
			"Ez a betűtípus nem tartalmazza az összes szimbólumot, az élő előnézet és a renderelt kép eltérhet.",
		],
		"characters": [
			"znaky",
			"znaky",
			"characters",
			"pismo",
			"karakterek",
		],
		"recently_used": [
			"Nedávno použité",
			"Nedávno použité",
			"Recently used",
			"Ostatnio używane",
			"Legutóbb használt",
		],
		"set_background": [
			"Nastavit pozadí",
			"Nastaviť pozadie",
			"Set background",
			"Ustaw tło",
			"Háttér beállítása",
		],
		"filters": [
			"Filtry",
			"Filtre",
			"Filters",
			"Filtry",
			"Szűrők",
		],
		"remove_background_error": [
			"Nastala chyba při odstraňování pozadí obrázku",
			"Nastala chyba pri odstraňovaní pozadia obrázku",
			"There was an error while removing the background",
			"Wystąpił błąd podczas usuwania tła obrazu",
			"Hiba történt a képháttér eltávolításakor",
		],
		"cannot_remove_background": [
			"U daného obrázku nedokážeme odstranit věrohodně pozadí",
			"U daneho obrazku nedokazeme odstranit vierohodne pozadie",
			"We cannot reliably remove the background for this image",
			"Nie możemy wiarygodnie usunąć tła tego obrazu",
			"Az adott kép esetében a képhátteret nem lehet hitelesen eltávolítani.",
		],
		"object_to_image_ratio": [
			"Objekt/obrázek",
			"Objekt/obrázok",
			"Object/image",
			"Obiekt/obraz",
			"Tárgy/kép",
		],
		"template_id": [
			"template id",
			"template id",
			"template id",
			"template id",
			"template id",
		],
		"disable_show_overlap": [
			"Nezobrazovat zónu v náhledu",
			"Nezobrazovať zónu v náhľade",
			"Do not show zone in preview",
			"Nie pokazuj strefy w podglądzie",
			"Ne mutassa a zónát az előnézetben",
		],
		"font_example": [
			"Příliš žluťoučký kůň úpěl ďábelské ódy.",
			"Kŕdeľ ďatľov učí koňa žrať kôru.",
			"The quick brown fox jumps over the lazy dog.",
			"Pchnąć w tę łódź jeża lub ośm skrzyń fig.",
			"Egy hűtlen vejét fülöncsípő, dühös mexikói úr Wesselényinél mázol Quitóban.",
		],
		"unsupported_mime_type": [
			"Nepodporovaný formát",
			"Nepodporovaný formát",
			"Unsupported file format",
			"Niewłaściwy typ mim",
			"Nem támogatott formátum",
		],
		"unsupported_file_size": [
			"Soubor je příliš velký",
			"Súbor je príliš veľký",
			"The file is too large",
			"Plik jest za duży",
			"A fájl túl nagy",
		],
		"selection": [
			"Výběr",
			"Výber",
			"Selection",
			"Wybór",
			"Szűrő",
		],
		"is_transparent": [
			"Průhledné pozadí",
			"Priehľadné pozadie",
			"Has Alpha",
			"Przezroczyste tło",
			"Áttetsző háttér",
		],
		"is_light_bg": [
			"Světlé pozadí",
			"Svetlé pozadie",
			"Light background",
			"Jasne tło",
			"Világos háttér",
		],
		"orientation": [
			"Orientace obrázku",
			"Orientácia obrázku",
			"Image orientation",
			"Orientacja obrazu",
			"Képorientáció",
		],
		"portrait": [
			"Na výšku",
			"Na výšku",
			"Portrait",
			"Pionowa",
			"Függőleges",
		],
		"landscape": [
			"Na šířku",
			"Na šírku",
			"Landscape",
			"Pozioma",
			"Vízszintes",
		],
		"bg_color_distance": [
			"Barevná vzdálenost",
			"Farebná vzdialenosť",
			"Color distance",
			"Odległość koloru",
			"Színtávolság",
		],
		"small_distance": [
			"malá",
			"malá",
			"small",
			"mały",
			"kicsi",
		],
		"big_distance": [
			"velká",
			"veľká",
			"big",
			"duża",
			"nagy",
		],
		"medium_distance": [
			"střední",
			"stredná",
			"medium",
			"średni",
			"közepes",
		],
		"bg_color": [
			"Barva pozadí",
			"Farba pozadia",
			"Background color",
			"Kolor tła",
			"Háttérszín",
		],
		"create": [
			"Vytvořit",
			"Vytvoriť",
			"Create",
			"Stwórz",
			"Létrehozás",
		],
		"create_predefined_fie_queries_title": [
			"Které z následujících výběrů si přejete vytvořit?",
			"Ktoré z nasledujúcich výberov si prajete vytvoriť?",
			"Which of the following fie queries do you want to create?",
			"Którego z poniższych wyborów chcesz dokonać?",
			"Melyiket szeretné létrehozni az alábbi szűrők közül?",
		],
		"create_predefined_fie_queries_text": [
			"Vytvořit předdefinované FIE výběry?",
			"Vytvoriť preddefinované FIE výbery?",
			"Create predefined FIE queries?",
			"Utworzyć wstępnie zdefiniowane FIE wybory?",
			"Elődefiniált FIE-lekérdezés létrehozása?",
		],
		"active_supereffect": [
			"Aktivní superefekt",
			"Aktívny superefekt",
			"Active super effect",
			"Aktywny super efekt",
			"Aktív szupereffekt",
		],
		"not_number": [
			"Není číslo",
			"Nie je číslo",
			"Not a number",
			"Nie numer",
			"Nem szám",
		],
		"prepared_text": [
			"Předchystaný text",
			"Predchystaný text",
			"The prepared text",
			"Przygotowany tekst",
			"Előkészített szöveg",
		],
		"get_now": [
			"akce",
			"akcia",
			"get now",
			"promocja",
			"akció",
		],
		"discount": [
			"sleva",
			"zľava",
			"discount",
			"zniżka",
			"kedvezmény",
		],
		"discount_and_frame": [
			"Sleva & rámeček",
			"Zľava & rámček",
			"Discount & frame",
			"Zniżka & ramka",
			"Kedvezmény & keret",
		],
		"1_plus_1_circle": [
			"1 + 1 ZDARMA",
			"1 + 1 ZADARMO",
			"BUY 1 & GET 1 FREE",
			"1 + 1 GRATIS",
			"1 + 1 INGYEN",
		],
		"buy_one_get_one_free": [
			"1+1 zdarma",
			"1+1 zdarma",
			"buy 1 & get 1 free",
			"1+1 gratis",
			"1+1 ingyen",
		],
		"last_piece": [
			"Poslední kus",
			"Posledný kus",
			"Last Piece",
			"Ostatni kawałek",
			"Utolsó darab",
		],
		"new_year_sale": [
			"Novoroční výprodej",
			"Novoročný výpredaj",
			"New Year Sale",
			"Noworoczna wyprzedaż",
			"Újévi kiárusítás",
		],
		"free_gift": [
			"dárek zdarma",
			"darček zdarma",
			"free gift",
			"prezent gratis",
			"ingyenes ajándék",
		],
		"add_to_cart": [
			"do košíku",
			"do košíka",
			"add to cart",
			"do koszyka",
			"kosárba",
		],
		"sale": [
			"výprodej",
			"výpredaj",
			"sale",
			"wyprzedaż",
			"kiárusítás",
		],
		"buy_now": [
			"koupit teď",
			"kúpiť teraz",
			"buy now",
			"kup teraz",
			"vásárlás most",
		],
		"buy": [
			"koupit",
			"kúpiť",
			"buy",
			"kup",
			"vásárlás",
		],
		"order_now": [
			"objednat",
			"objednať",
			"order now",
			"zamów",
			"rendelés most",
		],
		"free_delivery": [
			"doprava zdarma",
			"doprava zdarma",
			"free delivery",
			"darmowa dostawa",
			"ingyenes kiszállítás",
		],
		"newie": [
			"novinka",
			"novinka",
			"new",
			"nowość",
			"új",
		],
		"in_stock": [
			"skladem",
			"skladom",
			"in stock",
			"w magazynie",
			"raktáron",
		],
		"project_health": [
			"Zdraví projektu",
			"Zdravie projektu",
			"Project health",
			"Zdrowie projektu",
			"Projektállapot",
		],
		"find_by": [
			"Najít",
			"Nájsť",
			"Find by",
			"Znajdować",
			"Keresés",
		],
		"fonts": [
			"Fonty",
			"Fonty",
			"Fonts",
			"Czcionki",
			"Betűtípusok",
		],
		"send_mailgun_notifications": [
			"Posílat systémové notifikace a tipy na mail",
			"Posielať systémové notifikácie a tipy na mail",
			"Send system notifications and tips to mail",
			"Wysyłanie powiadomień systemowych i wskazówek na pocztę",
			"Rendszerértesítések és tippek küldése e-mailben",
		],
		"force_remove_alpha": [
			"Odstranění alpha kanálu z obrázku před posíláním na odstranění pozadí",
			"Odstránenie alpha kanála z obrázku pred posielaním na odstránenie pozadia",
			"Removing the alpha channel from the image before sending it for background removal",
			"Usunięcie kanału alfa z obrazu przed wysłaniem go do usunięcia tła",
			"Az alfa-csatorna eltávolítása a képből, mielőtt azt háttéreltávolításra küldenék.",
		],
		"auto_template_priority": [
			"Automaticky uspořádat pořadí šablon",
			"Automaticky usporiadať poradie šablón",
			"Reorder templates automatically",
			"Automatycznie uporządkuj kolejność szablonów",
			"Sablonok automatikus újrarendezése",
		],
		"no_watermark_mask_defined": [
			"Nejprve je potřeba označit umístění vodoznaku.",
			"Najskôr musíte označiť masku vodoznaku",
			"First you need to define the watermark mask.",
			"Musisz najpierw wybrać maskę znaku wodnego",
			"Először ki kell jelölni a vízjel helyét",
		],
		"brush": [
			"Štětec",
			"Štětec",
			"Brush",
			"Pędzel",
			"Ecset",
		],
		"eraser": [
			"Guma",
			"Guma",
			"Eraser",
			"Gumka",
			"Radír",
		],
		"brush_color": [
			"Barva štětce",
			"Farba štetca",
			"Brush color",
			"Kolor pędzla",
			"Ecsetszín",
		],
		"main_image_opt": [
			"Hlavní obrázek",
			"Hlavný obrázok",
			"Main picture",
			"Zdjęcie główne",
			"Fő kép",
		],
		"layout_opt": [
			"Koláž",
			"Koláž",
			"Layout",
			"Kolaż",
			"Kollázs",
		],
		"skip_refresh_images": [
			"Stahovat obrázky jen při změně jejich URL",
			"Sťahovať obrázky len pri zmene ich URL",
			"Download images only when their URL changes",
			"Pobieraj obrazy tylko wtedy, gdy zmieni się ich adres URL",
			"Képek letöltése csak, ha az URL címük változik",
		],
		"skip_refresh_images_hint": [
			"Nevytěžuje tolik server s uloženými obrázky. Pozn: pokud url obrázku zůstane stejná, pouze se změní obsah, nelze tuto změnu zjistit automaticky.",
			"Nevyťažuje toľko server s uloženými obrázkami. Pozn: pokiaľ url obrázku zostane rovnaká, iba sa zmení obsah, nemožno túto zmenu zistiť automaticky.",
			"The storage with the images will not be loaded too much. Note however if the image url remains the same and the content changes, this change cannot be detected automatically.",
			"Serwer z zapisanymi obrazami nie zużywa tak dużo. Uwaga: jeśli adres URL obrazu pozostaje ten sam, zmienia się tylko treść, ta zmiana nie może zostać wykryta automatycznie.",
			"Nem terheli annyira a szervert a tárolt képekkel. Megj: ha a kép url-je ugyanaz marad, csak a tartalom változik, ez a változás nem érzékelhető automatikusan.",
		],
		"or": [
			"nebo",
			"alebo",
			"or",
			"lub",
			"vagy",
		],
		"preferred_product_id": [
			"Preferované ID",
			"Preferované ID",
			"Preferred ID",
			"Preferowany identyfikator",
			"Előnyben részesített ID",
		],
		"random_product_id": [
			"Načtený produkt",
			"Načítaný produkt",
			"Loaded product",
			"Załadowany produkt",
			"Betöltött termék",
		],
		"other": [
			"jiný",
			"iný",
			"other",
			"inny",
			"egyéb",
		],
		"group_all_templates": [
			'Všechny šablony',
			'Všetky šablóny',
			'All templates',
			'Wszystkie szablony',
			"Összes sablon",
		],
		"group_discounts_and_sales": [
			'Akce a slevy',
			'Akcie a zľavy',
			'Discounts and sales',
			'Rabaty i wyprzedaże',
			"Akciók és kedvezmények",
		],
		"group_black_friday": [
			'Black Friday',
			'Black Friday',
			'Black Friday',
			'Black Friday',
			"Black Friday",
		],
		"group_gift": [
			'Dárek zdarma',
			'Darček zdarma',
			'Free gift',
			'Darmowy prezent',
			"Ingyenes ajándék",
		],
		"group_free_delivery": [
			'Doprava zdarma',
			'Doprava zdarma',
			'Free delivery',
			'Darmowa dostawa',
			"Ingyenes kiszállítás",
		],
		"group_new_year_sale": [
			"Novoroční výprodej",
			"Novoročný výpredaj",
			"New Year Sale",
			"Noworoczna wyprzedaż",
			"Újévi kiárusítás",
		],
		"group_viva_magenta": [
			"Viva Magenta",
			"Viva Magenta",
			"Viva Magenta",
			"Viva Magenta",
			"Viva Magenta",
		],
		"group_midjourney": [
			"Midjourney",
			"Midjourney",
			"Midjourney",
			"Midjourney",
			"Midjourney",
		],
		"group_generic": [
			"Univerzální šablony",
			"Univerzálne šablóny",
			"Generic templates",
			"Uniwersalne szablony",
			"Univerzális sablonok",
		],
		"group_new": [
			'Novinky',
			'Novinky',
			'New arrivals',
			'Nowości',
			"Újdonságok",
		],
		"group_seasonal": [
			'Sezónní kampaně',
			'Sezónne kampane',
			'Seasonal campaigns',
			'Kampanie sezonowe',
			"Szezonális kampányok",
		],
		"group_availability": [
			'Skladová dostupnost',
			'Skladová dostupnosť',
			'Stock availability',
			'Dostępność magazynowa',
			"Elérhetőség",
		],
		"group_christmas": [
			'Vánoční kampaň',
			'Vianočná kampaň',
			'Christmas campaign',
			'Świąteczna kampania',
			"Karácsonyi kampány",
		],
		"group_effects": [
			"Efekty",
			"Efekty",
			"Effects",
			"Efekty",
			"Effektek",
		],
		"group_background": [
			"Pozadí",
			"Pozadie",
			"Background",
			"Tło",
			"Háttér",
		],
		"group_warranty": [
			"Záruka",
			"Záruka",
			"Warranty",
			"Gwarancja",
			"Garancia",
		],
		"group_valentine": [
			"Valentýn",
			"Valentín",
			"Valentine's Day",
			"Walentynki",
			"Valentin-nap",
		],
		"group_size_variant": [
			"Velikostní varianty",
			"Veľkostné varianty",
			"Size variations",
			"Warianty rozmiarowe",
			"Méretvariációk",
		],
		"custom": [
			"Vlastní",
			"Vlastné",
			"Custom",
			"Dodaj",
			"Egyéni",
		],
		"no_watermark_groups_yet": [
			"Zatím nemáte žádné skupiny vodoznaků.",
			"Zatiaľ nemáte žiadne skupiny vodoznakov.",
			"You don't have any watermark groups yet.",
			"Nie masz jeszcze żadnych grup znaków wodnych.",
			"Még nincs vízjel csoportja.",
		],
		"no_watermark_groups_published_yet": [
			"Zatím nemáte žádné odeslané skupiny vodoznaků.",
			"Zatiaľ nemáte žiadne odoslané skupiny vodoznakov.",
			"You have no published watermark groups yet.",
			"Nie masz jeszcze przesłanych grup znaków wodnych.",
			"Még nincs elküldött vízjel csoportja.",
		],
		"start_here": [
			"Začněte zde",
			"Začnite tu",
			"Start here",
			"Zacznij tutaj",
			"Kezdje itt",
		],
		"select_images_to_watermark_groups": [
			"Vyberte několik obrázků se stejným vodoznakem.",
			"Vyberte niekoľko obrázkov s rovnakým vodoznakom.",
			"Please select several images with the same watermark.",
			"Wybierz kilka obrazów z tym samym znakiem wodnym.",
			"Válasszon ki néhány képet ugyanazzal a vízjellel.",
		],
		"watermark_groups_info_0": [
			"Pro každý typ vodoznaku je třeba označit několik obrázků stejným vodoznakem. Tyto obrázky budou použity k trénování modelu.",
			"Pre každý typ vodoznaku je potrebné označiť niekoľko obrázkov rovnakým vodoznakom. Tieto obrázky sa použijú na trénovanie modelu.",
			"For each type of watermark, you need to mark a few images with the same watermark. These images will be used for training the model.",
			"Dla każdego rodzaju znaku wodnego musisz oznaczyć kilka obrazów tym samym znakiem wodnym. Te obrazy będą używane do trenowania modelu.",
			"Minden vízjel típushoz több képet kell megjelölnie ugyanazzal a vízjellel. Ezek a képek kerülnek felhasználásra a modell tréninghez.",
		],
		"watermark_groups_info_1": [
			"todo",
			"todo",
			"todo",
			"todo",
			"todo",
		],
		"images_from_mergado": [
			"Obrázky z MERGADA",
			"Obrázky z MERGADA",
			"Images from MERGADO",
			"Obrazy z MERGADO",
			"Képek a MERGADÓBÓL",
		],
		"images_from_fie": [
			"Produktové obrázky z pravidel",
			"Produktové obrázky z pravidiel",
			"Product images from MERGADO rules",
			"Zdjęcia produktów z regulaminu",
			"Termékképek a MERGADO szabályokból",
		],
		'images_from_upload': [
			"Nahrané obrázky",
			"Nahrané obrázky",
			"Uploaded images",
			"przesłane obrazy",
			"Feltöltött képek",
		],
		"select_images_with_same_watermark": [
			"Vyberte obrázky",
			"Vyberte obrázky",
			"Select images",
			"Wybierz obrazy",
			"Képek kiválasztása",
		],
		"create_watermark_mask": [
			"Zamalujte štětcem vodoznak",
			"Zamaľujte štetcom vodoznak",
			"Paint the watermark with a brush",
			"Pomaluj znak wodny pędzlem",
			"Fesse fel ecsettel a vízjelet",
		],
		"create_watermark_group": [
			"Vytvořit",
			"Vytvoriť",
			"Create",
			"Utwórz",
			"Létrehozás",
		],
		"create_new_watermark_group": [
			"Vytvořit novou skupinu obrázků",
			"Vytvořit novou skupinu obrázků",
			"Vytvořit novou skupinu obrázků",
			"Vytvořit novou skupinu obrázků",
			"Új képcsoport létrehozása",
		],
		"append_to_watermark_group": [
			"Připojit",
			"Pripojiť",
			"Append",
			"Połącz",
			"Csatolás",
		],
		"to_wm_group": [
			"do skupiny",
			"do skupiny",
			"to group",
			"do grupy",
			"csoporthoz",
		],
		"add": [
			"Přidat",
			"Pridať",
			"Add",
			"Dodać",
			"Hozzáadás",
		],
		"add_image": [
			"Přidat obrázek",
			"Pridať obrázok",
			"Add image",
			"Dodaj zdjęcie",
			"Kép hozzáadása",
		],
		"no_watermark_mask": [
			"Označtě prosím vodoznak",
			"Označte prosím vodoznak",
			"Please mark the watermark",
			"Proszę zaznaczyć znak wodny",
			"Jelölje ki a vízjelet",
		],
		"publish_to_trainer": [
			"Odeslat ke trénování",
			"Odoslať na trénovanie",
			"Send to trainer",
			"Wyślij do pociągu",
			"Tréningre küldés",
		],
		"images_in_group": [
			"Obrázky ve skupině",
			"Obrázky v skupine",
			"Pictures in a group",
			"Zdjęcia w grupie",
			"Képek a csoportban",
		],
		"rename": [
			"Přejmenovat",
			"Premenovať",
			"Rename",
			"Przemianować",
			"Átnevezés",
		],
		"group_exists": [
			"Skupina s tímto názvem už existuje",
			"Skupina s týmto názvom už existuje",
			"Group already exists",
			"Grupa o tej nazwie już istnieje",
			"Ilyen nevű csoport már létezik",
		],
		"cannot_be_empty": [
			"Nesmí být prázdné",
			"Nesmú byť prázdne",
			"Cannot be empty",
			"Nie może być pusty",
			"Nem lehet üres",
		],
		"sent": [
			"Odesláno",
			"Odoslané",
			"Sent",
			"Wysłano",
			"Elküldve",
		],
		"confirm_remove_group_image": [
			"Smazat obrázek ze skupiny vodoznaků?",
			"Zmazať obrázok zo skupiny vodoznakov?",
			"Delete image from watermark group?",
			"Usunąć obraz z grupy znaków wodnych?",
			"Törölni szeretné a képet a vízjel csoportból?",
		],
		"confirm_remove_group": [
			"Smazat skupinu vodoznaků",
			"Zmazať skupinu vodoznakov",
			"Delete a watermark group",
			"Usuń grupę znaków wodnych",
			"Vízjel csoport törlése",
		],
		"empty_watermark_group": [
			"Skupina vodoznaků neobsahuje žádné obrázky. Začněte nahráním obrázků do skupiny.",
			"Skupina vodoznakov neobsahuje žiadne obrázky. Začnite nahraním obrázkov do skupiny.",
			"The watermark group does not contain any images. Start by uploading images to a group.",
			"Grupa znaków wodnych nie zawiera żadnych obrazów. Zacznij od przesłania zdjęć do grupy.",
			"A vízjel csoport nem tartalmaz képeket. Kezdjen el képeket feltölteni a csoportba.",
		],
		"unpublished_group": [
			"Skupina nebyla odeslána k trénování modelu",
			"Skupina nebola odoslaná na trénovanie modelu",
			"The group was not sent to train the model",
			"Grupa nie została wysłana do szkolenia modelki",
			"A csoport nem lett elküldve modell tréningre.",
		],
		"watermark_group_hash_diff": [
			"Skupina byla změněna. Je potřeba odeslat znovu pro trénování.",
			"Skupina bola zmenená. Je potrebné odoslať znova na trénovanie.",
			"The group has been changed. Please re-send it for training.",
			"Grupa została zmieniona. Musisz wysłać ponownie na szkolenie.",
			"A csoport módosítva lett. Újra el kell küldeni tréningre.",
		],
		"watermark_group_some_images_without_mask": [
			"Některé produkty v této skupině nemají označený vodoznak.",
			"Niektoré produkty v tejto skupine nemajú označený vodoznak.",
			"Some products in this group have no watermark mask.",
			"Niektóre produkty z tej grupy nie posiadają znaku wodnego.",
			"Néhány termék ebben a csoportban nem rendelkezik megjelölt vízjellel.",
		],
		"spacing": [
			"Mezery",
			"Mezery",
			"Spacing",
			"Rozstaw",
			"Hézagok",
		],
		"line_spacing": [
			"Řádkování",
			"Riadkovanie",
			"Line spacing",
			"Odstępy między wierszami",
			"Sortávolság",
		],
		"letter_spacing": [
			"Rozpal",
			"Prestrkanie",
			"Letter spacing",
			"Tracking",
			"Betűtávolság",
		],
		"lines_and_letters_spacing": [
			"Mezery mezi písmeny",
			"Medzery medzi písmenami",
			"Spaces between letters",
			"Odstępy między literami",
			"Szóközök a betűk között",
		],
		"publish_to_detector": [
			"Odeslat do detektoru vodoznaků",
			"Odoslať do detektora vodoznakov",
			"Send to watermark detector",
			"Wyślij do detektora znaku wodnego",
			"Küldés a vízjel detektorba",
		],
		"published": [
			"Odesláno",
			"Odoslané",
			"Published",
			"Wysłano",
			"Elküldve",
		],
		"no_gradients_yet": [
			"Zatím nemáte vytvořený žádný gradient",
			"Zatiaľ nemáte vytvorený žiadny gradient",
			"You have no gradient yet",
			"Nie masz jeszcze utworzonego gradientu",
			"Még nincs létrehozott gradiens",
		],
		"results": [
			"Výsledky",
			"Výsledky",
			"Results",
			"Wyniki",
			"Eredmények",
		],
		"no_results_yet": [
			"Zatím žádné výsledky",
			"Zatiaľ žiadne výsledky",
			"No results yet",
			"Brak wyników",
			"Még nincs eredmény",
		],
		"template_name_max_100": [
			"max délka názvu je 100 znaků",
			"max dĺžka názvu je 100 znakov",
			"max name length is 100 characters",
			"maksymalna długość nazwy to 100 znaków",
			"a név maximális hossza 100 karakter",
		],
		"clockwise": [
			"Po směru hodinových ručiček",
			"V smere hodinových ručičiek",
			"Clockwise",
			"Zgodnie ze wskazówkami zegara",
			"Az óramutató járásával megegyező irányban",
		],
		"counter_clockwise": [
			"Proti směru hodinových ručiček",
			"Proti smeru hodinových ručičiek",
			"Counter clockwise",
			"Przeciwnie do ruchu wskazówek zegara",
			"Az óramutató járásával ellentétes irányban",
		],
		"no_color": [
			"žádná",
			"žiadna",
			"none",
			"brak",
			"nincs",
		],
		"text_stroke": [
			"Obrys textu",
			"Ťah textu",
			"Text stroke",
			"Obrys tekstu",
			"Szövegvázlat",
		],
		"text_stroke_underlayer": [
			"Obrys jako podklad (nemění se tloušťka textu)",
			"Obrys ako podklad (nemení sa hrúbka textu)",
			"Outline as background (text thickness remains unchanged)",
			"Kontur jako tło (grubość tekstu pozostaje bez zmian)",
			"Körvonal háttérként (a szöveg vastagsága változatlan marad)",
		],
		"text_stroke_inside": [
			"Obrys kolem textu na úkor tloušťky textu",
			"Obrys okolo textu na úkor hrúbky textu",
			"Outline around the text at the expense of text thickness",
			"Obrys wokół tekstu kosztem jego grubości",
			"Körvonal a szöveg körül, a szöveg vastagságának rovására",
		],
		"text_padding": [
			"Odsazení textu",
			"Odsadenie textu",
			"Text padding",
			"Wypełnienie tekstu",
			"Szövegkitöltés",
		],
		"select_format_to_see_templates": [
			"Pro prohlížení grafických šablon nejprve zvolte výstupní formát obrázků.",
			"Ak chcete zobraziť grafické šablóny, najprv vyberte formát výstupného obrázka.",
			"To view graphic templates, first select the output image format.",
			"Aby wyświetlić szablony graficzne, należy najpierw wybrać format obrazu wyjściowego.",
			"A grafikus sablonok megtekintéséhez először válassza ki a kimeneti képformátumot.",
		],
		"warn_inactive_fie_queries": [
			"Tyto předdefinované výběry nejsou aktivní",
			"Tieto preddefinované výbery nie sú aktívne",
			"These predefined selections are not active",
			"Te predefiniowane wybory nie są aktywne",
			"Ezek az előre meghatározott kijelölések nem aktívak",
		],
		"warn_rules_not_applied_yet": [
			"Tyto výběry ještě nejsou v seznamu, protože neproběhla pravidla",
			"Tieto výbery ešte nie sú v zozname, pretože neprebehli pravidlá",
			"These queries are not listed because the rules have not run yet",
			"Te wybory nie są jeszcze wyświetlane, ponieważ reguły nie zostały uruchomione",
			"Ezek a kijelölések még nem szerepelnek a listában, mert a szabályok még nem futottak le",
		],
		"random_colors": [
			"Náhodné barvy",
			"Náhodné farby",
			"Random colors",
			"Losowe kolory",
			"Véletlenszerű színek",
		],
		"random_gradients": [
			"Náhodné gradienty",
			"Náhodné prechody",
			"Random gradients",
			"Losowe gradienty",
			"Véletlen színátmenetek",
		],
		"dominant_color": [
			"Barva z produktu",
			"Farba z produktu",
			"Color from product",
			"Kolor z produktu",
			"Szín a termékből",
		],
		"warn_transparent_background": [
			"Pokud chcete u obrázků na výstupu <b>průhledné pozadí</b>, vyberte v Nastaveních jako výstupní formát .png.",
			"Ak chcete mať <b>priehľadné pozadie</b> výstupných obrázkov, vyberte v Nastaveniach ako výstupný formát .png.",
			"If you want a <b>transparent background</b> for the output images, select .png as the output format in Settings.",
			"Jeśli chcesz, aby obrazy wyjściowe miały <b>przezroczyste tło</b>, wybierz .png jako format wyjściowy w Ustawieniach.",
			"Ha átlátszó <b>hátteret szeretne</b> a kimeneti képekhez>, válassza a .png formátumot a Beállítások menüpontban.",
		],
		"import_palette": [
			"Importovat paletu",
			"Importovať paletu",
			"Import palette",
			"Importuj paletę",
			"Import paletta",
		],
		"delete_palette": [
			"Smazat paletu",
			"Odstrániť paletu",
			"Delete palette",
			"Usuń paletę",
			"Törölje a palettát",
		],
		"add_color": [
			"Přidat barvu",
			"Pridať farbu",
			"Add color",
			"Dodaj kolor",
			"Szín hozzáadása",
		],
		"group_easter_campaign": [
			"Velikonoční kampaň",
			"Veľkonočná kampaň",
			"Easter campaign",
			"Kampania wielkanocna",
			"Húsvéti kampány",
		],
		"happy_easter": [
			"Veselé Velikonoce",
			"Veselá Veľká noc",
			"Veselé Velikonoce",
			"Wesołego Alleluja",
			"Kellemes Húsvéti Ünnepeket",
		],
		"easter_discounts": [
			"VELIKONOČNÍ SLEVY",
			"veľkonočné zľavy",
			"Easter discounts",
			"Rabaty wielkanocne",
			"Húsvéti kedvezmények",
		],
		"easters": [
			"VELIKONOČNÍ",
			"VEĽKONOČNÉ",
			"EASTER",
			"WIELKANOC",
			"HÚSVÉTI",
		],
		"spring": [
			"JARNÍ",
			"JARNÉ",
			"SPRING",
			"WIOSENNY",
			"TAVASZI",
		],
		"spring_sales": [
			"Jarní výprodej",
			"Jarný výpredaj",
			"Spring sale",
			"Wiosenna wyprzedaż",
			"Téli kiárusítás",
		],
		"spring_discounts": [
			"Jarní slevy",
			"Jarné zľavy",
			"Spring discounts",
			"Wiosenne rabaty",
			"Tavaszi kedvezmények",
		],
		"discounts": [
			"SLEVY",
			"ZĽAVY",
			"SALES",
			"OBROTY",
			"ÉRTÉKESÍTÉS",
		],
		"discount_30": [
			"SLEVA 30%",
			"ZĽAVA 30%",
			"DISCOUNT 30%",
			"ZNIŻKA 30%",
			"KEDVEZMÉNY 30%",
		],
		"discounts_30": [
			"SLEVY -30%",
			"ZĽAVY -30%",
			"DISCOUNTS -30%",
			"RABATY -30%",
			"KEDVEZMÉNYEK -30%",
		],
		"up_to_20": [
			"až 20%",
			"až 20%",
			"20% OFF",
			"do 20%",
			"legfeljebb 20%",
		],
		"right": [
			"PRÁVĚ",
			"PRÁVE",
			"RIGHT",
			"TYLKO",
			"ÉPPEN",
		],
		"now": [
			"TEĎ",
			"TERAZ",
			"NOW",
			"TERAZ",
			"MOST",
		],
		"click_here": [
			"KLIKNI ZDE",
			"KLIKNI TU",
			"CLICK HERE",
			"KLIKNIJ TUTAJ",
			"KATTINTS IDE",
		],
		"buy_here": [
			"NAKUPUJ ZDE",
			"NAKUPUJ TU",
			"SHOP HERE",
			"KUP TUTAL",
			"VÁSÁRLÁS ITT",
		],
		"watermark_mark_images": [
			"Vyberte a označte 10 až 15 obrázků, které obsahují stejný vodoznak.",
			"Vyberte a označte 10 až 15 obrázkov, ktoré obsahujú rovnaký vodoznak.",
			"Select and mark 10 to 15 images that contain the same watermark.",
			"Wybierz i oznacz od 10 do 15 obrazów zawierających ten sam znak wodny.",
			"Válasszon ki és címkézz fel 10–15 képet, amelyek ugyanazt a vízjelet tartalmazzák.",
		],
		"watermark_max_images": [
			"Max 15 obrázků",
			"Max 15 obrázkov",
			"Max 15 images",
			"Max 15 obrazów",
			"Max 15 kép",
		],
		"watermark_min_images": [
			"Min 10 obrázků",
			"Min 10 obrázkov",
			"Min 10 images",
			"Min 10 obrazów",
			"Min 10 kép",
		],
		"marked_watermarks": [
			"označených vodoznaků",
			"označených vodoznakov",
			"marked watermarks",
			"zaznaczone znaki wodne",
			"jelölt vízjelek",
		],
		"not_published_yet": [
			"zatím neodesláno",
			"zatiaľ neodoslané",
			"not published yet",
			"jeszcze nie wysłane",
			"még nincs elküldve",
		],
		"text_orientation": [
			"Orientace textu",
			"Orientácia textu",
			"Text orientation",
			"Orientacja tekstu",
			"Szöveg tájolása",
		],
		"horizontal_orientation": [
			"vodorovně",
			"vodorovne",
			"horizontally",
			"poziomo",
			"vízszintesen",
		],
		"vertical_orientation": [
			"svisle",
			"zvisle",
			"vertically",
			"pionowo",
			"függőlegesen",
		],
		"clip_mask": [
			"Maska ořezu",
			"Maska orezu",
			"Clip mask",
			"Maska przycinająca",
			"Nyíró maszk",
		],
		"add_clip_mask": [
			"Přidat masku ořezu",
			"Pridať masku orezu",
			"Add clip mask",
			"Dodaj maskę przycinającą",
			"Vágómaszk hozzáadása",
		],
		"invert_clip_mask": [
			"Invertovat masku ořezu",
			"Invertovať masku orezu",
			"Invert clipping mask",
			"Odwróć maskę przycinającą",
			"Invert vágómaszk",
		],
		"finish": [
			"Dokončit",
			"Skončiť",
			"Finish",
			"Skończyć",
			"Befejez",
		],
		"watermark_is_marked": [
			"Vodoznak je označen",
			"Vodoznak je označený",
			"The watermark is marked",
			"Znak wodny jest zaznaczony",
			"A vízjel meg van jelölve",
		],
		"already_used_image": [
			"Obrázek byl již použit",
			"Obrázok bol už použitý",
			"Image has already been used",
			"Obraz został już użyty",
			"A képet már használták",
		],
		"new_group": [
			"Nová skupina",
			"Nová skupina",
			"New group",
			"Nowa grupa",
			"Új csoport",
		],
		"check_elements_title": [
			"Ověření dostupnosti ručně zadaných elementů",
			"Overenie dostupnosti ručne zadaných elementov",
			"Checking the availability of manually entered elements",
			"Sprawdzanie dostępności ręcznie wprowadzanych elementów",
			"Kézzel bevitt elemek elérhetőségének ellenőrzése",
		],
		"some_elements_not_available": [
			"Zdá se, že některé z ručně zadaných elementů nejsou dostupné. Navrhované změny:",
			"Zdá sa, že niektoré z ručne zadaných elementov nie sú dostupné. Navrhované zmeny:",
			"Some of the manually entered elements seem to be unavailable. There are some suggested changes:",
			"Niektóre ręcznie wprowadzone elementy wydają się być niedostępne. Sugerowane zmiany to:",
			"A manuálisan beírt elemek egy része nem elérhető. A javasolt változtatások a következők:",
		],
		"apply_all_suggested_changes": [
			"Aplikovat všechny navrhované změny",
			"Aplikovať všetky navrhované zmeny",
			"Apply all suggested changes",
			"Zastosuj wszystkie sugerowane zmiany",
			"Alkalmazza az összes javasolt változtatást",
		],
		"apply_only_selected_changes": [
			"Aplikovat vybrané změny",
			"Aplikovať vybrané zmeny",
			"Apply selected changes",
			"Zastosuj wybrane zmiany",
			"Alkalmazza a kiválasztott módosításokat",
		],
		"template_layer": [
			"Vrstva v šabloně",
			"Vrstva šablóny",
			"Template layer",
			"Warstwa szablonu",
			"Sablon réteg",
		],
		"e_img_url": [
			"Element s adresou obrázku",
			"Element s adresou obrázku",
			"Image URL element",
			"Element adresu URL obrazu",
			"Kép url eleme",
		],
		"e_img_url_input": [
			"Vstupní element s adresou obrázku",
			"Vstupný element s adresou obrázku",
			"Input image URL element",
			"Wprowadź element adresu URL obrazu",
			"Írja be a kép URL-elemét",
		],
		"e_alt_img_url": [
			"Element s adresou alternativního obrázku",
			"Element s adresou alternatívneho obrázku",
			"Alternative Image URL element",
			"Element z adresem alternatywnego obrazu",
			"Alternatív kép url elem",
		],
		"e_alt_img_url_input": [
			"Vstupní element s adresou alternativního obrázku",
			"Vstupný element s adresou alternatívneho obrázku",
			"Alternative image input element",
			"Wprowadź element adresu alternatywnego URL obrazu",
			"Beviteli elem alternatív képcímmel",
		],
		"e_item_id": [
			"Element s ITEM ID",
			"Element s ITEM ID",
			"ITEM ID element",
			"Element identyfikatora przedmiotu",
			"Elemazonosító elem",
		],
		"e_name": [
			"Element s názvem produktu",
			"Element s názvom produktu",
			"Product name element",
			"Element nazwy produktu",
			"Terméknév elem",
		],
		"e_productno": [
			"Element s číslem produktu",
			"Element s číslom produktu",
			"Product number element",
			"Element numeru produktu",
			"Termékszám elem",
		],
		"e_price_vat": [
			"Element s cenou",
			"Element s cenou",
			"Price element",
			"Element ceny",
			"Ár elem",
		],
		"e_url": [
			"Element s adresou do obchodu",
			"Element s adresou do obchodu",
			"Shop url element",
			"Element adresu URL sklepu",
			"Bolt url eleme",
		],
		"e_ean": [
			"EAN element",
			"EAN element",
			"EAN element",
			"Element EAN",
			"EAN elem",
		],
		"template": [
			"šablona",
			"šablóna",
			"template",
			"szablon",
			"sablon",
		],
		"layer": [
			"vrstva",
			"vrstva",
			"layer",
			"warstwa",
			"réteg",
		],
		"audit_promo_templates": [
			"Ukázkové šablony v auditu",
			"Ukážkové šablóny v audite",
			"Audit promo templates",
			"Przykładowe szablony w audycie",
			"Minta sablonok az ellenőrzésben",
		],
		"save_and_rerender_promo": [
			"Uložit a vyrenderovat promo u existujích projektů",
			"Uložit a vyrenderovat promo u existujích projektů",
			"Save and re-render promo for existing projects",
			"Save and re-render promo for existing projects",
			"Save and re-render promo for existing projects",
		],
		"reload_saved": [
			"Znovu načíst uložené",
			"Znovu načíst uložené",
			"Reload saved",
			"Reload saved",
			"Reload saved",
		],
		"back_to_predefined": [
			"Zpět předdefinované",
			"Zpět předdefinované",
			"Back to predefined",
			"Back to predefined",
			"Back to predefined",
		],
		"reset_filters": [
			"Zrušit filtry",
			"Zrušiť filtre",
			"Reset filters",
			"Anuluj filtry",
			"Törölje a szűrőket",
		],
		"delete_layout_image_error": [
			"Chyba při mazání obrázku z rozložení",
			"Chyba pri mazaní obrázku z rozloženia",
			"Error deleting image from layout",
			"Błąd podczas usuwania obrazu z układu",
			"Hiba történt a kép törlésekor az elrendezésből",
		],
		"has_complex_background": [
			"Komplexní pozadí",
			"Komplexné pozadie",
			"Complex background",
			"Złożone tło",
			"Összetett háttér",
		],
		"complex_background_threshold": [
			"práh pro komplexní pozadí",
			"prah pre komplexné pozadie",
			"complex background threshold",
			"próg dla złożonego tła",
			"komplex háttér küszöbértéke",
		],
		"empty_background_probability": [
			"pravděpodobnost prázdného pozadí",
			"pravdepodobnosť prázdneho pozadia",
			"empty background probability",
			"prawdopodobieństwo pustego tła",
			"az üres háttér valószínűsége",
		],
		"object_bounding_box_to_image_ratio": [
			"poměr rámečku ohraničení objektu ku obrázku",
			"pomer rámčeka ohraničenia objektu k obrázku",
			"object bounding box to image ratio",
			"stosunek obwiedni obiektu do obrazu",
			"objektumhatároló doboz képaránya",
		],
		"set_template_size": [
			"Nastavit rozměry šablony (doporučeno)",
			"Nastaviť rozmery šablóny (odporúča sa)",
			"Set template size (recommended)",
			"Ustaw wymiary szablonu (zalecane)",
			"Sablon méreteinek beállítása (ajánlott)",
		],
		"keep_original_image_size": [
			"Ponechat původní rozměry obrázku",
			"Ponechať pôvodné rozmery obrázku",
			"Keep original image size",
			"Zachowaj oryginalne wymiary obrazu",
			"Tartsa meg a kép eredeti méreteit",
		],
		"no_template_size_is_selected_title": [
			"Chybí rozměry šablony",
			"Chýba rozmery šablóny",
			"Template size is not set",
			"Brak wymiarów szablonu",
			"Hiányoznak a sablon méretei",
		],
		"no_template_size_is_selected": [
			"Nemáte vybrané rozměry šablony. Pokud máte v šabloně další vrstvy, mohou být mimo viditelnou oblast.",
			"Nemáte vybrané rozmery šablóny. Pokiaľ máte v šablóne ďalšie vrstvy, môžu byť mimo viditeľnú oblasť.",
			"You have no size selected. If you more layers in the template, the layers may be out of the visible area.",
			"Nie masz wybranych wymiarów szablonu. Jeśli w szablonie znajdują się inne warstwy, mogą one znajdować się poza widocznym obszarem.",
			"Nincsenek kiválasztott sablondimenziók. Ha más rétegek is vannak a sablonban, akkor azok a látható területen kívül lehetnek.",
		],
		"gradient_stop_points": [
			"koncové barvy gradientu",
			"koncové farby gradientu",
			"gradient stop-points",
			"kolory końcowe gradientu",
			"gradiens végszínek",
		],
		"is_autocrop": [
			"Autocrop",
			"Autocrop",
			"Autocrop",
			"Autocrop",
			"Autocrop",
		],
		"new_alternative_template": [
			"Nová šablona alternativních obrázků",
			"Nová šablóna alternatívnych obrázkov",
			"New alternate images template",
			"Nowy alternatywny szablon obrazów",
			"Új alternatív képek sablon",
		],
		"alternative_template": [
			"Šablona alternativních obrázků",
			"Šablóna alternatívnych obrázkov",
			"Alternative images template",
			"Alternatywny szablon obrazów",
			"Alternatív képek sablon",
		],
		"alternative_templates": [
			"Šablony alternativních obrázků",
			"Šablóny alternatívnych obrázkov",
			"Alternative images templates",
			"Alternatywne szablony obrazów",
			"Alternatív képsablonok",
		],
		"main_templates": [
			"Šablony hlavních obrázků",
			"Šablóny hlavných obrázkov",
			"Main image templates",
			"Główne szablony obrazów",
			"Fő képsablonok",
		],
		"image_offset": [
			"Posun obrázku vůči vymezenému tvaru",
			"Posun obrázku voči vymedzenému tvaru",
			"Image offset relatively to the layout image shape",
			"Przesunięcie obrazu względem zdefiniowanego kształtu",
			"A kép eltolása a meghatározott alakzathoz képest",
		],
		"collage_image_shape": [
			"Tvar",
			"Tvar",
			"Shape",
			"Kształt",
			"Alak",
		],
		"rect": [
			"Obdélník",
			"Obdĺžnik",
			"Rectangle",
			"Prostokąt",
			"Téglalap",
		],
		"ellipse": [
			"Elipsa",
			"Elipsa",
			"Ellipse",
			"Elipsa",
			"Ellipszis",
		],
		"selected": [
			"Vybrané",
			"Vybraté",
			"Selected",
			"Wybrany",
			"Kiválasztott",
		],
		"import": [
			"Import",
			"Import",
			"Import",
			"Import",
			"Import",
		],
		"no_templates_found": [
			"Nenalezeny žádné šablony",
			"Nenájdené žiadne šablóny",
			"No templates found",
			"Nie znaleziono żadnych szablonów",
			"Nem található sablon",
		],
		"auto_priority": [
			"Automaticky uspořádat",
			"Automaticky usporiadať",
			"Reorder automatically",
			"Automatycznie uporządkuj",
			"Automatikus újrarendezése",
		],
		"manual_priority": [
			"Uspořádat ručně",
			"Usporiadať ručne",
			"Reorder manually",
			"Ułóż ręcznie",
			"Kézi rendezés",
		],
		"right_now": [
			"PRÁVĚ TEĎ",
			"PRÁVĚ TEĎ",
			"SHOP NOW",
			"SHOP NOW",
			"SHOP NOW",
		],
		"limited_offer": [
			"OMEZENÁ NABÍDKA",
			"OMEZENÁ NABÍDKA",
			"LIMITED OFFER",
			"LIMITED OFFER",
			"LIMITED OFFER",
		],
		"sale2": [
			"AKCE",
			"AKCIA",
			"SALE",
			"SALE",
			"SALE",
		],
		"sales_up_to_50": [
			"SLEVY AŽ 50%",
			"SLEVY AŽ 50%",
			"UP TO 50%",
			"UP TO 50%",
			"UP TO 50%",
		],
		"sale_up_to_50": [
			"SLEVA AŽ 50%",
			"SLEVA AŽ 50%",
			"UP TO 50%",
			"UP TO 50%",
			"UP TO 50%",
		],
		"sales_up_to": [
			'SLEVY AŽ',
			'SLEVY AŽ',
			'SALE',
			'SALE',
			'SALE',
		],
		"this_week": [
			"TENTO TÝDEN",
			"TENTO TÝDEN",
			"THIS WEEK",
			"THIS WEEK",
			"THIS WEEK",
		],
		"shop_here": [
			'nakupuj zde',
			'nakupuj zde',
			'buy here',
			'buy here',
			'buy here',
		],
		"discounts2": [
			"SLEVY",
			"SLEVY",
			"DISCOUNTS",
			"DISCOUNTS",
			"DISCOUNTS",
		],
		"textInsideShape": [
			"Text uvnitř tvaru",
			"Text vo vnútri tvaru",
			"Text inside shape",
			"Tekst wewnątrz kształtu",
			"Szöveg egy alakzaton belül",
		],
		"element_not_selected": [
			"nebyl vybrán element",
			"nebol vybraný element",
			"no element selected",
			"nie wybrano żadnego elementu",
			"nincs elem kiválasztva",
		],
		"invalid_color": [
			"neplatná barva",
			"neplatná farba",
			"invalid color",
			"nieprawidłowy kolor",
			"érvénytelen szín",
		],
		"invalid_email": [
			"neplatný email",
			"neplatný email",
			"invalid email",
			"nieprawidłowy adres e-mail",
			"érvénytelen email cím",
		],
		"letter_case": [
			"Velikost písmen",
			"Veľkosť písmen",
			"Letter case",
			"Wielkość liter",
			"Kis-és nagybetűk",
		],
		"keep": [
			"beze změn",
			"bez zmien",
			"keep",
			"bez zmian",
			"változtatások nélkül",
		],
		"to_upper_case": [
			"na velká písmena",
			"na veľké písmená",
			"to upper case",
			"wielkimi literami",
			"nagybetűvel",
		],
		"to_lower_case": [
			"na malá písmena",
			"na malé písmená",
			"to lower case",
			"na małe litery",
			"kisbetűkre",
		],
		"first_letter_to_upper_case": [
			"první písmeno velké",
			"prvé písmeno veľké",
			"first letter to upper case",
			"pierwsza litera wielka",
			"első betű nagybetűvel",
		],
		"first_letter_to_lower_case": [
			"první písmeno malé",
			"prvé písmeno malé",
			"first letter to lower case",
			"pierwsza litera mała",
			"első betű kisbetű",
		],
		"first_word_letter_to_upper_case": [
			"první písmeno ve slově velké",
			"prvé písmeno v slove veľké",
			"first word letter to upper case",
			"pierwsza litera słowa wielka",
			"a nagy szó első betűje",
		],
		"has_person": [
			"Postava v obrázku",
			"Postava v obrázku",
			"A person in the picture",
			"A person in the picture",
			"A person in the picture",
		],
		"person_detected": [
			"postava detekována",
			"postava detekována",
			"has person",
			"has person",
			"has person",
		],
		"person_not_detected": [
			"postava nedetekována",
			"postava nedetekována",
			"person not detected",
			"person not detected",
			"person not detected",
		],
		"columns": [
			"Sloupce",
			"Stĺpce",
			"Columns",
			"Kolumny",
			"Szlopok",
		],
		"is_keep_size": [
			"Zachovat původní formát",
			"Zachovať pôvodný formát",
			"Keep the original format",
			"Zachowaj oryginalny format",
			"Tartsa meg az eredeti formátumot",
		],
		"is_keep_size_info": [
			"Máte vybráno ponechat původní rozměry. Nelze vkládat vrstvy, pouze efekty.",
			"Máte vybrané ponechať pôvodné rozmery. Nie je možné vkladať vrstvy, iba efekty.",
			"You have selected to keep the original dimensions. Cannot insert layers, only effects.",
			"Wybrano zachowanie oryginalnych wymiarów. Nie można wstawiać warstw, tylko efekty.",
			"Úgy döntött, hogy megtartja az eredeti méreteket. Nem lehet rétegeket beszúrni, csak effektusokat.",
		],
		"contact_email": [
			"Kontaktní email",
			"Kontaktný email",
			"Contact email",
			"Kontaktowy e-mail",
			"Kapcsolattartó e-mail",
		],

		"element_short_item_id": [
			"ITEM_ID",
			"ITEM_ID",
			"ITEM_ID",
			"ITEM_ID",
			"ITEM_ID",
		],
		"element_short_url": [
			"URL",
			"URL",
			"URL",
			"URL",
			"URL",
		],
		"element_short_cpc": [
			"CPC",
			"CPC",
			"CPC",
			"CPC",
			"CPC",
		],
		"element_short_name": [
			"NAME",
			"NAME",
			"NAME",
			"NAME",
			"NAME",
		],
		"element_short_img_url": [
			"IMG_URL",
			"IMG_URL",
			"IMG_URL",
			"IMG_URL",
			"IMG_URL",
		],
		"element_short_img_url_input": [
			"IMG_URL",
			"IMG_URL",
			"IMG_URL",
			"IMG_URL",
			"IMG_URL",
		],
		"element_short_alt_img_url": [
			"IMG_ALTERNATIVE",
			"IMG_ALTERNATIVE",
			"IMG_ALTERNATIVE",
			"IMG_ALTERNATIVE",
			"IMG_ALTERNATIVE",
		],
		"element_short_alt_img_url_input": [
			"IMG_ALTERNATIVE",
			"IMG_ALTERNATIVE",
			"IMG_ALTERNATIVE",
			"IMG_ALTERNATIVE",
			"IMG_ALTERNATIVE",
		],
		"element_short_price_vat": [
			"PRICE_VAT",
			"PRICE_VAT",
			"PRICE_VAT",
			"PRICE_VAT",
			"PRICE_VAT",
		],
		"element_short_delivery_date": [
			"DELIVERY_DATE",
			"DELIVERY_DATE",
			"DELIVERY_DATE",
			"DELIVERY_DATE",
			"DELIVERY_DATE",
		],
		"element_short_manufacturer": [
			"MANUFACTURER",
			"MANUFACTURER",
			"MANUFACTURER",
			"MANUFACTURER",
			"MANUFACTURER",
		],
		"element_short_categorytext": [
			"CATEGORY",
			"CATEGORY",
			"CATEGORY",
			"CATEGORY",
			"CATEGORY",
		],
		"element_short_ean": [
			"EAN",
			"EAN",
			"EAN",
			"EAN",
			"EAN",
		],
		"steps_first_perex": [
			"<h4>Vítejte v rozšíření Feed Image Editor</h4><p class='perex'>Pomůžeme vám rychle a jednoduše upravovat produktové obrázky pro váš e-shop. Aby vše fungovalo správně, společně nastavíme několik základních kroků.</p>",
			"<h4>Vitajte v rozšírení Feed Image Editor</h4><p class='perex'>Pomôžeme vám rýchlo a jednoducho upravovať produktové obrázky pre váš e-shop. Aby všetko fungovalo správne, spoločne nastavíme niekoľko základných krokov.</p>",
			"<h4>Welcome to the Feed Image Editor extension</h4><p class='perex'>We will help you quickly and easily edit product images for your e-shop. To ensure everything works correctly, we will set up a few basic steps together.</p>",
			"<h4>Witamy w aplikacji Feed Image Editor</h4><p class='perex'>Pomożemy ci szybko i łatwo edytować zdjęcia produktów dla twojego sklepu internetowego. Aby wszystko działało poprawnie, wspólnie ustawimy kilka podstawowych kroków.</p>",
			"<h4>Üdvözöljük a Feed Image Editor alkalmazásban</h4><p class='perex'>Segítünk gyorsan és egyszerűen szerkeszteni a termékképeket a webáruházához. Annak érdekében, hogy minden megfelelően működjön, közösen beállítunk néhány alapvető lépést.</p>",
		],
		"steps_last_perex": [
			"Teď se můžete pustit do zdokonalování svých produktových obrázků. Vyberte si, s jakými úpravami chcete začít v původní šabloně.",
			"Teraz sa môžete pustiť do zdokonaľovania svojich produktových obrázkov. Vyberte si, s akými úpravami chcete začať v úvodnej šablóne.",
			"Now you can jump into improving your product images. Select which editing you'd like to begin with in your initial template.",
			"Teraz możesz przystąpić do poprawy zdjęć produktów. Wybierz, od którego rodzaju edycji chcesz rozpocząć w swoim wstępnym szablonie.",
			"Most már elkezdheti tökéletesíteni termékképeit. Válassza ki, hogy az eredeti sablonban milyen szerkesztésekkel akar kezdeni.",
		],
		"steps_first_header": [
			"Zkontrolujte elementy ve vašem Mergado feedu",
			"Skontrolujte elementy vo vašom Mergado feede",
			"Check the elements in your Mergado feed",
			"Sprawdź elementy w swoim feedzie Mergado",
			"Ellenőrizze a Mergado feed elemeit",
		],
		"steps_first_subheader": [
			"Než začnete tvořit první šablonu nebo kampaň, ujistěte se, že jsme správně vybrali klíčové elementy z vašeho produktového feedu. Slouží k tomu, aby se do obrázků doplňovaly správné informace jako například cena, název, značka nebo dostupnost.",
			"Skôr než začnete vytvárať prvú šablónu alebo kampaň, uistite sa, že sme správne vybrali kľúčové elementy z vášho produktového feedu. Slúžia na to, aby sa do obrázkov dopĺňali správne informácie, ako napríklad cena, názov, značka alebo dostupnosť.",
			"Before you start creating your first template or campaign, make sure we have correctly selected the key elements from your product feed. These are used to ensure that the correct information such as price, name, brand, or availability is added to the images.",
			"Zanim zaczniesz tworzyć pierwszą szablonę lub kampanię, upewnij się, że prawidłowo wybraliśmy kluczowe elementy z twojego produktowego feedu. Służą one temu, aby na obrazach pojawiały się poprawne informacje, takie jak cena, nazwa, marka czy dostępność.",
			"Mielőtt elkezdené létrehozni az első sablont vagy kampányt, győződjön meg arról, hogy helyesen választottuk ki a termékfeed kulcselemeit. Ezek arra szolgálnak, hogy a képeken a megfelelő információk jelenjenek meg, például ár, név, márka vagy elérhetőség.",
		],
		"steps_need_inspiration_perex": [
			"Najdete ji v editovatelných šablonách, které jsme pro vás připravili.",
			"Nájdite ju v editovateľných šablónach, ktoré sme pre vás pripravili.",
			"Check out these templates we've prepared for you.",
			"Sprawdź te edytowalne szablony, które dla ciebie przygotowaliśmy.",
			"Megtalálja azokat az Ön számára elkészített szerkeszthető sablonokban.",
		],
		"steps_need_inspiration": [
			"Potřebujete inspiraci?",
			"Potrebujete inšpiráciu?",
			"Need inspiration?",
			"Potrzebujesz inspiracji?",
			"Inspirációra van szüksége?",
		],
		"first_steps_title": [
			"Průvodce prvním nastavením",
			"Sprievodca prvým nastavením",
			"First setup guide",
			"Przewodnik pierwszej konfiguracji",
			"Első beállítás varázsló",
		],

		"steps_third": [
			"Zůstaňme v kontaktu",
			"Zostaňme v kontakte",
			"Let's keep in touch",
			"Zostanmy w kontakcie",
			"Maradjunk kapcsolatban",
		],
		"steps_third_subscribe": [
			"Přihlašuji se rovněž k odběru newsletteru",
			"Prihlasujem sa tiež na odber newslettera",
			"I also subscribe to the newsletter",
			"Zapisuję się również do newslettera",
			"Feliratkozom a hírlevélre is",
		],
		"create_first_template": [
			"Vytvořit první šablonu",
			"Vytvoriť prvú šablónu",
			"Create first template",
			"Utwórz pierwszy szablon",
			"Első sablon létrehozása",
		],
		"steps_create_blank": [
			"Přidání grafických prvků a CTA",
			"Pridanie grafických prvkov a CTA",
			"Add graphics and CTA",
			"Dodaj grafikę i CTA",
			"CTA és grafikai elemek hozzáadása",
		],
		"steps_create_resize": [
			"Změna velikosti na konkrétní formát",
			"Zmena veľkosti na konkrétny formát",
			"Resize images to suit specific format",
			"Zmniejsz do określonego formatu",
			"Konkrét formátumra való átméretezés",
		],

		"steps_create_upscale": [
			"Vylepšení kvality",
			"Vylepšenie kvality",
			"Enhance the quality",
			"Popraw jakość",
			"Minőség javítása",
		],

		"steps_create_bg_removal": [
			"Odstranit pozadí",
			"Odstrániť pozadie",
			"Crop background",
			"Usuń tło",
			"Háttér eltávolítása",
		],
		"steps_create_watermarks": [
			"Odstranit vodoznak",
			"Odstrániť vodoznak",
			"Erase image watermarks",
			"Usuń znak wodny",
			"Vízjel eltávolítása",
		],
		"steps_create_header": [
			"Hotovo! Můžete začít tvořit",
			"Hotovo! Môžete začať tvoriť",
			"Ready to go! You can start creating",
			"Gotowe! Możesz zaczynać tworzyć",
			"Kész! Elkezdheti a munkát",
		],
		"steps_create_perex": [
			"Všechno je připraveno. Nyní můžete začít upravovat své produktové obrázky a vytvářet první šablony.",
			"Všetko je pripravené. Teraz môžete začať upravovať svoje produktové obrázky a vytvárať prvé šablóny.",
			"Everything is ready. You can now start editing your product images and creating your first templates.",
			"Wszystko jest przygotowane. Teraz możesz zacząć edytować swoje zdjęcia produktowe i tworzyć pierwsze szablony.",
			"Minden elő van készítve. Most már elkezdheti a termékképek szerkesztését és az első sablonok létrehozását.",
		],
		"steps_who_are_you_title": [
			"Abychom vám mohli doporučit ty správné funkce a nastavení, řekněte nám, kdo jste.",
			"Aby sme vám mohli odporučiť tie správne funkcie a nastavenia, povedzte nám, kto ste.",
			"To recommend the right features and settings for you, tell us who you are.",
			"Abyśmy mogli polecić Państwu odpowiednie funkcje i ustawienia, prosimy, powiedzcie nam, kim jesteście.",
			"Hogy ajánlhassuk Önnek a megfelelő funkciókat és beállításokat, árulja el nekünk, ki Ön.",
		],
		"steps_who_are_you_subtitle": [
			"Díky tomu vám nastavíme služby přesně na míru.",
			"Vďaka tomu vám nastavíme služby presne na mieru.",
			"This way, we will set up the services exactly tailored to your needs.",
			"Dzięki temu skonfigurujemy usługi dokładnie na miarę.",
			"Így pontosan az igényeire szabjuk a szolgáltatásokat.",
		],
		"steps_categorization_title": [
			"Jaký typ e-shopu provozujete?",
			"Aký typ e-shopu prevádzkujete?",
			"What type of online store do you run?",
			"Jaki typ e-sklepu prowadzisz?",
			"Milyen típusú webáruházat üzemeltet?",
		],
		"steps_categorization": [
			"Vyberte kategorii, která nejlépe odpovídá vašemu sortimentu. Díky vaší odpovědi vám dodáme lepší služby přesně na míru.",
			"Vyberte kategóriu, ktorá najlepšie zodpovedá vášmu sortimentu. Vďaka vašej odpovedi vám poskytneme lepšie služby presne na mieru.",
			"Select the category that best matches your assortment. Your answer will help us provide you with better, tailor-made services.",
			"Wybierz kategorię, która najlepiej odpowiada Twojemu asortymentowi. Dzięki Twojej odpowiedzi dostarczymy ci lepiej dopasowane, spersonalizowane usługi.",
			"Válassza ki a kategóriát, amely a legjobban megfelel a kínálatának. A válasza alapján személyre szabottabb szolgáltatásokat tudunk nyújtani.",
		],
		"steps_third_email": [
			"Vaše e-mailová adresa",
			"Vaša e-mailová adresa",
			"Your e-mail address",
			"Twój adres e-mailowy",
			"Az Ön e-mail címe",
		],
		"steps_third_sublabel": [
			"Budeme vám posílat systémová upozornění, když nastane cokoli důležitého.",
			"Budeme vám posielať systémové upozornenia, keď nastane čokoľvek dôležité.",
			"We will send you system notifications whenever something important happens.",
			"Będziemy wysyłać Ci powiadomienia systemowe, gdy tylko wydarzy się coś ważnego.",
			"Rendszerértesítéseket fogunk küldeni, amikor valami fontos történik.",
		],
		"steps_second": [
			"Výstupní nastavení",
			"Výstupné nastavenia",
			"Output settings",
			"Ustawienia wyjściowe",
			"Kimeneti beállítások",
		],
		"output_image_format_sublabel": [
			"Vyberte výstupní formát obrázků.",
			"Vyberte výstupný formát obrázkov.",
			"Select the output image format.",
			"Wybierz format wyjściowy obrazów.",
			"Válassza ki a képek kimeneti formátumát.",
		],
		"output_image_compression_sublabel": [
			"Nastavení úrovně kvality komprese.",
			"Nastavenie úrovne kvality kompresie.",
			"Compression quality level setting.",
			"Ustawienie poziomu jakości kompresji.",
			"A tömörítés minőségi szintjének beállítása.",
		],
		"auto_compression_to_size_sublabel": [
			"Automatická komprese do velikosti",
			"Redukcia dátovej veľkosti",
			"Data size reduction",
			"Redukcja rozmiaru danych",
			"Adatméret csökkentése",
		],
		"steps_third_email_sublabel": [
			"Budeme vám posílat upozornění, když nastane cokoli důležitého.",
			"Ak sa niečo dôležité stane, zašleme vám notifikáciu.",
			"We will send you notifications when anything important occurs.",
			"Będziemy wysyłać powiadomienia, gdy zajdzie coś ważnego.",
			"Ha bármilyen fontos dolog történne, értesítést küldünk Önnek.",
		],
		"visual_similarity": [
			"Vizuální podobnost",
			"Vizuálna podobnosť",
			"Visual similarity",
			"Podobieństwo wizualne",
			"Vizuális hasonlóság",
		],
		"ai_params": [
			"Doplnění parametrů do produktů",
			"Doplnenie parametrov do produktov",
			"Adding parameters to products",
			"Dodawanie parametrów do produktów",
			"Paraméterek hozzáadása termékekhez",
		],
		"ai_params_generate": [
			"Vygenerovat parametry z obrázků do feedu",
			"Vygenerovať parametre z obrázkov do feedu",
			"Generate parameters from images to feed",
			"Generuj parametry z obrazów do kanału",
			"Paraméterek generálása képekből a hírcsatornához",
		],
		"ai_params_is_running_on_background": [
			"Na pozadí probíhá AI analýza obrázků a generování parametrů",
			"Na pozadí prebieha AI analýza obrázkov a generovanie parametrov",
			"AI image analysis and parameter generation takes place in the background",
			"Analiza obrazu AI i generowanie parametrów odbywają się w tle",
			"A mesterséges intelligencia által végzett képelemzés és paramétergenerálás a háttérben történik.",
		],
		"similar_images": [
			"podobné obrázky",
			"podobné obrázky",
			"similar images",
			"podobne obrazy",
			"hasonló képek",
		],
		"find_similar_images": [
			"Najít podobné obrázky",
			"Nájsť podobné obrázky",
			"Find similar images",
			"Znajdź podobne obrazy",
			"Keressen hasonló képeket",
		],
		"searching_in_progress": [
			"Probíhá vyhledávání",
			"Prebieha vyhľadávanie",
			"Searching in progress",
			"Trwa wyszukiwanie",
			"Keresés folyamatban",
		],
		"create_list_and_publish_to_visual_similarity": [
			"Exportovat seznam obrázků a najít podobné",
			"Exportovať obrázky v šablóne a nájsť podobné",
			"Export images in a template and find similar ones",
			"Eksportuj obrazy w szablonie i znajdź podobne",
			"Exportáljon képeket egy sablonba, és keressen hasonlókat",
		],
		"visual_similarity_last_update_at": [
			"Funkce vizuální podobnosti je momentálně vypnutá. Výsledky jsou aktuální k ",
			"Funkcia vizuálnej podobnosti je momentálne vypnutá. Výsledky sú aktuálne k ",
			"The visual similarity feature is currently disabled. Results are current as of ",
			"Funkcja podobieństwa wizualnego jest obecnie wyłączona. Wyniki są aktualne na dzień ",
			"A vizuális hasonlóság funkció jelenleg le van tiltva. Az eredmények aktuálisak ",
		],
		"image_cannot_be_downloaded": [
			"Obrázek nelze stáhnout",
			"Obrázok sa nedá stiahnuť",
			"Image cannot be downloaded",
			"Nie można pobrać obrazu",
			"A kép nem tölthető le",
		],
		"product_has_no_image": [
			"Produkt nemá obrázek",
			"Produkt nemá obrázok",
			"Product has no image",
			"Produkt nie ma obrazu",
			"A terméken nincs kép",
		],
		"missing_image_element": [
			"Chybí obrázkový element",
			"Chýba obrázkový element",
			"Missing IMG element",
			"Brakuje elementu obrazu",
			"Hiányzik egy képelem",
		],
		"visual_similarity_enabled": [
			"Najít podobné obrázky",
			"Nájsť podobné obrázky",
			"Find similar images",
			"Znajdź podobne obrazy",
			"Hasonló képek keresése",
		],
		"visual_similarity_n": [
			"Počet podobných obrázků",
			"Počet podobných obrázkov",
			"Number of similar images",
			"Liczba podobnych obrazów",
			"Hasonló képek száma",
		],
		"visual_similarity_threshold": [
			"Index podobnosti",
			"Index podobnosti",
			"Similarity index",
			"Indeks podobieństwa",
			"Hasonlósági index",
		],
		"visual_similarity_search_products_in": [
			"Hledat podobné v šablonách",
			"Hľadať podobné v šablónach",
			"Search similar in templates",
			"Szukaj podobnych w szablonach",
			"Keressen hasonlót a sablonokban",
		],
		"feature_enabled": [
			"Funkce je zapnuta",
			"Funkcia je zapnutá",
			"Feature is on",
			"Funkcja jest włączona",
			"A funkció engedélyezve van",
		],
		"feature_disabled": [
			"Funkce je vypnuta",
			"Funkcia je vypnutá",
			"Feature is off",
			"Funkcja jest wyłączona",
			"A funkció le van tiltva",
		],
		"upload_images": [
			"Nahrát obrázky",
			"Nahrať obrázky",
			"Upload images",
			"Przesyłać zdjęcia",
			"Képek feltöltése",
		],
		"download_images": [
			"Stáhnout obrázky",
			"Stiahnuť obrázky",
			"Download images",
			"Pobierz obrazy",
			"Képek letöltése",
		],
		"download_image": [
			"Stáhnout obrázek",
			"Stiahnuť obrázok",
			"Download image",
			"Pobierz obraz",
			"Kép letöltése",
		],
		"upload_image": [
			"Nahrát obrázek",
			"Nahrať obrázok",
			"Upload image",
			"Prześlij obraz",
			"Kép feltöltése",
		],
		"uploaded_images": [
			"Nahrané obrázky",
			"Nahrané obrázky",
			"Uploaded pictures",
			"Feltöltött képek",
			"Przesłane zdjęcia",
		],
		'external_image': [
			"Grafické prvky",
			"Grafické prvky",
			"Graphical elements",
			"Elementy graficzne",
			"Grafikai elemek",
		],
		"blog_link": [
			"https://www.feed-image-editor.cz/blog",
			"https://www.feed-image-editor.sk/blog",
			"https://www.feed-image-editor.com/blog",
			"https://www.feed-image-editor.pl/blog",
			"https://www.feed-image-editor.com/blog",
		],
		"please_select_templates": [
			"Vyberte šablony, ve kterých chcete hledat podobné produkty",
			"Vyberte šablóny, v ktorých chcete hľadať podobné produkty",
			"Select the templates in which you want to search for similar products",
			"Wybierz szablony, w których chcesz szukać podobnych produktów",
			"Válassza ki azokat a sablonokat, amelyekben hasonló termékeket szeretne keresni",
		],
		"loading_results": [
			"Načítám výsledky",
			"Načítavam výsledky",
			"Loading results",
			"Ładowanie wyników",
			"Az eredmények betöltése",
		],
		"exporting": [
			"Exportuji produkty",
			"Exportujem produkty",
			"Exporting products",
			"Eksportuję produkty",
			"Termékeket exportálok",
		],
		"task_queued": [
			"Task zařazen do fronty",
			"Task zaradený do frontu",
			"Task queued",
			"Zadanie w kolejce",
			"Feladat sorban áll",
		],
		"waiting_before_publish": [
			"Čekám před odesláním tasku",
			"Čakám pred odoslaním tasku",
			"Waiting before publish task",
			"Czekam z wysłaniem zadania",
			"Várok a feladat elküldése előtt",
		],
		"popup_box_header": [
			"Důležité oznámení. Měníme cenu za Feed Image Editor",
			"Důležité oznámení. Měníme cenu za Feed Image Editor",
			"Important Announcement. We are changing price for Feed Image Editor",
			"Important Announcement. We are changing price for Feed Image Editor",
			"Important Announcement. We are changing price for Feed Image Editor",
		],
		"popup_box_body": [
			"<p>Dobrý den,<br/><br/>od <b>1. 9. 2024</b> upravujeme cenu za aplikaci Feed Image Editor. Výše měsíčního poplatku bez DPH bude 1986 Kč (79 €). Máme pro vás však výhodnou nabídku. Pokud jste již naším klientem, máte měsíční fakturační období a do 31. 7. 2024 <b>přejdete na roční, budete mít celý rok aplikaci za 1028,8 Kč bez DPH (38,4 €) na měsíc</b>. Nabídka platí také pro nové klienty, kteří si aplikaci na rok předplatí do 31. 7. 2024.</p><p>⇨ podrobně popsané scénáře přechodu na nový ceník najdete na <span class=\"link\" onClick=Mergado.openWindow(\"https://preview.mailerlite.io/preview/540026/emails/127288531702777107\")>tomto odkazu</span><p/><p>Roční fakturace vám navíc přinese 20% slevu na Mergado a všechny další aplikace z Mergado Store. Čas na to máte do 31. 7. 2024 (včetně).<p/><p>Cena je uvedena za jeden projekt.</p>",
			"<p>Dobrý den,<br/><br/>od <b>1. 9. 2024</b> upravujeme cenu za aplikaci Feed Image Editor. Výše měsíčního poplatku bez DPH bude 1986 Kč (79 €). Máme pro vás však výhodnou nabídku. Pokud jste již naším klientem, máte měsíční fakturační období a do 31. 7. 2024 <b>přejdete na roční, budete mít celý rok aplikaci za 1028,8 Kč bez DPH (38,4 €) na měsíc</b>. Nabídka platí také pro nové klienty, kteří si aplikaci na rok předplatí do 31. 7. 2024.</p><p>⇨ podrobně popsané scénáře přechodu na nový ceník najdete na <span class=\"link\" onClick=Mergado.openWindow(\"https://preview.mailerlite.io/preview/540026/emails/127288531702777107\")>tomto odkazu</span><p/><p>Roční fakturace vám navíc přinese 20% slevu na Mergado a všechny další aplikace z Mergado Store. Čas na to máte do 31. 7. 2024 (včetně).<p/><p>Cena je uvedena za jeden projekt.</p>",
			"<p>Hello,<br/><br/>from <b>September 1, 2024</b>, we are adjusting the price for the Feed Image Editor application. The monthly fee without VAT will be 79 €. However, we have a special offer for you. If you are already our client with a monthly billing period and <b>switch to annual billing by July 31, 2024, you will have the application for the whole year at 38,4 € per month without VAT</b>. This offer also applies to new clients who will subscribe to the application for a year by July 31, 2024.</p><p>⇨ detailed scenarios for the transition to the new pricing can be found at <span class=\"link\" onClick=Mergado.openWindow(\"https://preview.mailerlite.io/preview/540026/emails/127294576066037196\")>this link</span></p><p>Additionally, annual billing will bring you a 20% discount on Mergado and all other applications from the Mergado Store. You have time until July 31, 2024 (inclusive).<br/><br/>Prices are per project.</p>",
			"<p>Hello,<br/><br/>from <b>September 1, 2024</b>, we are adjusting the price for the Feed Image Editor application. The monthly fee without VAT will be 79 €. However, we have a special offer for you. If you are already our client with a monthly billing period and <b>switch to annual billing by July 31, 2024, you will have the application for the whole year at 38,4 € per month without VAT</b>. This offer also applies to new clients who will subscribe to the application for a year by July 31, 2024.</p><p>⇨ detailed scenarios for the transition to the new pricing can be found at <span class=\"link\" onClick=Mergado.openWindow(\"https://preview.mailerlite.io/preview/540026/emails/127294576066037196\")>this link</span></p><p>Additionally, annual billing will bring you a 20% discount on Mergado and all other applications from the Mergado Store. You have time until July 31, 2024 (inclusive).<br/><br/>Prices are per project.</p>",
			"<p>Hello,<br/><br/>from <b>September 1, 2024</b>, we are adjusting the price for the Feed Image Editor application. The monthly fee without VAT will be 79 €. However, we have a special offer for you. If you are already our client with a monthly billing period and <b>switch to annual billing by July 31, 2024, you will have the application for the whole year at 38,4 € per month without VAT</b>. This offer also applies to new clients who will subscribe to the application for a year by July 31, 2024.</p><p>⇨ detailed scenarios for the transition to the new pricing can be found at <span class=\"link\" onClick=Mergado.openWindow(\"https://preview.mailerlite.io/preview/540026/emails/127294576066037196\")>this link</span></p><p>Additionally, annual billing will bring you a 20% discount on Mergado and all other applications from the Mergado Store. You have time until July 31, 2024 (inclusive).<br/><br/>Prices are per project.</p>",
			"<p>Hello,<br/><br/>from <b>September 1, 2024</b>, we are adjusting the price for the Feed Image Editor application. The monthly fee without VAT will be 79 €. However, we have a special offer for you. If you are already our client with a monthly billing period and <b>switch to annual billing by July 31, 2024, you will have the application for the whole year at 38,4 € per month without VAT</b>. This offer also applies to new clients who will subscribe to the application for a year by July 31, 2024.</p><p>⇨ detailed scenarios for the transition to the new pricing can be found at <span class=\"link\" onClick=Mergado.openWindow(\"https://preview.mailerlite.io/preview/540026/emails/127294576066037196\")>this link</span></p><p>Additionally, annual billing will bring you a 20% discount on Mergado and all other applications from the Mergado Store. You have time until July 31, 2024 (inclusive).<br/><br/>Prices are per project.</p>",
		],
		"understand": [
			"Rozumím",
			"Rozumiem",
			"I understand",
			"Rozumiem",
			"Megértem",
		],
		"rerender": [
			"Přegenerovat",
			"Pregenerovať",
			"Re-render",
			"Przegenerować",
			"Túlgenerálni",
		],
		"redownload": [
			"Znovu stáhnout",
			"Znovu stiahnuť",
			"Re-download",
			"Pobierz ponownie",
			"Újratöltés",
		],
		"to_be_processed": [
			"Zbývá spracovat",
			"Zostáva spracovať",
			"To be processed",
			"Pozostaje do przetworzenia",
			"Még feldolgozásra vár",
		],
		"similarity_less_than_n": [
			"K danému produktu se u zvolené hodnoty indexu podobnosti nepovedlo dohledat zvolený počet podobných obrázků. Zvažte snížení hodnoty indexu podobnosti.",
			"K danému produktu sa pri zvolenej hodnote indexu podobnosti nepodarilo dohľadať zvolený počet podobných obrázkov. Zvážte zníženie hodnoty indexu podobnosti.",
			"The selected number of similar images could not be found for the given product for the selected value of the similarity index. Consider reducing the similarity index value.",
			"Nie udało się znaleźć wybranej liczby podobnych zdjęć dla danego produktu dla wybranej wartości wskaźnika podobieństwa. Rozważ zmniejszenie wartości wskaźnika podobieństwa.",
			"Nem található a kiválasztott számú hasonló kép az adott termékhez a hasonlósági index kiválasztott értékéhez. Fontolja meg a hasonlósági index értékének csökkentését.",
		],
		"similarity_n_limit_info": [
			"Nastavte počet podobných obrázků, který se má k danému produktu vyhledat. K některým produktům se při dané hodnotě indexu podobnosti nemusí nutně tento počet vyhledat. V takovém případě zvažte snížení hodnoty indexu podobnosti.",
			"Nastavte počet podobných obrázkov, ktorý sa má k danému produktu vyhľadať. K niektorým produktom sa pri danej hodnote indexu podobnosti nemusí nutne tento počet vyhľadať. V takom prípade zvážte zníženie hodnoty indexu podobnosti.",
			"Set the number of similar images to be searched for the given product. Some products may not necessarily be searched for this number at a given similarity index value. In this case, consider reducing the similarity index value.",
			"Ustaw liczbę podobnych zdjęć, które mają być wyszukiwane dla danego produktu. Niektóre produkty niekoniecznie muszą być wyszukiwane pod kątem tej liczby przy danej wartości wskaźnika podobieństwa. W takim przypadku należy rozważyć zmniejszenie wartości wskaźnika podobieństwa.",
			"Állítsa be az adott termékhez keresendő hasonló képek számát. Előfordulhat, hogy egyes termékek nem feltétlenül erre a számra keresnek egy adott hasonlósági indexérték mellett. Ebben az esetben fontolja meg a hasonlósági index értékének csökkentését.",
		],
		"similarity_threshold_info": [
			"Index podobnosti určuje míru, jak moc podobné obrázky se mají k produktu vyhledat. Čím vyšší hodnota, tím podobnější obrázky. Hodnota 1 vyhledá naprosto stejné obrázky.",
			"Index podobnosti určuje mieru, ako veľmi podobné obrázky sa majú k produktu vyhľadať. Čím vyššia hodnota, tým podobnejšie obrázky. Hodnota 1 vyhľadá úplne rovnaké obrázky.",
			"The similarity index determines how similar images are to be searched for the product. The higher the value, the more similar the images. A value of 1 will find exactly the same images.",
			"Indeks podobieństwa określa, w jaki sposób podobne obrazy mają być wyszukiwane pod kątem produktu. Im wyższa wartość, tym bardziej podobne obrazy. Wartość 1 spowoduje znalezienie dokładnie tych samych obrazów.",
			"A hasonlósági index határozza meg, hogy a termékhez hogyan kell hasonló képeket keresni. Minél nagyobb az érték, annál hasonlóbbak a képek. Az 1-es érték pontosan ugyanazokat a képeket találja.",
		],
		"fill_similarity_title": [
			"Zapisování výsledků do výstupního feedu",
			"Zapisovanie výsledkov do výstupného feedu",
			"Export results to the output feed",
			"Zapisywanie wyników do źródła wyjściowego",
			"Eredmények írása a kimeneti feedbe",
		],
		"fill_similarity_ids_element": [
			"ID vizuálně podobných produktů",
			"ID vizuálne podobných produktov",
			"IDs of visually similar products",
			"Identyfikatory produktów podobnych wizualnie",
			"A vizuálisan hasonló termékek azonosítói",
		],
		"fill_similarity_image_urls_element": [
			"URL adresy vizuálně podobných obrázků",
			"URL adresy vizuálne podobných obrázkov",
			"URL addresses of visually similar images",
			"Adresy URL wizualnie podobnych obrazów",
			"A vizuálisan hasonló képek URL-címei",
		],
		"no_items_filtered": [
			"Nenalezli jsme žádný výběr",
			"Nenašli sme žiadny výber",
			"We did not find any selection",
			"Nie znaleźliśmy żadnego wyboru",
			"Nem találtunk válogatást",
		],

		"no_match_with_element_regexp": [
			"Element nevyhovuje filtru elementů pro aplikaci pravidel (element_regex)",
			"Element nevyhovuje filtru elementov pre aplikáciu pravidiel (element_regex)",
			"The element does not match the rule application element filter (element_regex)",
			"Element nie pasuje do filtra elementu aplikacji reguły (element_regex)",
			"Az elem nem egyezik a szabályalkalmazás elemszűrőjével (element_regex)",
		],
		"advanced_settings": [
			"Pokročilá nastavení",
			"Pokročilé nastavenia",
			"Advanced settings",
			"Ustawienia zaawansowane",
			"Speciális beállítások",
		],
		"mergado_max_payload_size": [
			"Maximální počet znaků odeslaných v jednom requestu. Maximální možná hodnota je 15 000 000 znaků.",
			"Maximálny počet znakov odoslaných v jednom requeste. Maximálna možná hodnota je 15 000 000 znakov.",
			"Maximum number of characters sent in one data request. Maximum possible value is 15 000 000 characters.",
			"Maksymalna liczba znaków wysyłanych w jednym żądaniu. Maksymalna możliwa wartość to 15 000 000 znaków.",
			"Az egy kérésben elküldött karakterek maximális száma. A maximális lehetséges érték 15 000 000 karakter.",
		],
		"mergado_element_regex": [
			"Regularní výraz podle kterého budou filtrovány elementy projektu",
			"Regularný výraz podľa ktorého budú filtrované elementy projektu",
			"Regular expression according to which the project elements will be filtered",
			"Wyrażenie regularne, według którego będą filtrowane elementy projektu",
			"Reguláris kifejezés, amely szerint a projektelemek szűrve lesznek",
		],
		"mergado_xml_equivalent": [
			"Mergado XML elementy, jejichž ekvivalent pro daný formát bude odeslán z Mergada.",
			"Mergado XML elementy, ktorých ekvivalent pre daný formát bude odoslaný z Mergada.",
			"Mergado XML elements whose equivalent for the given format will be sent from Mergado.",
			"Elementy XML Mergado, których odpowiednik w danym formacie zostanie wysłany z Mergado.",
			"Mergado XML-elemek, amelyek megfelelője az adott formátumnak, a Mergado-ból kerül elküldésre.",
		],
		"suggested_elements_to_be_excluded": [
			"Navrhované elementy, které můžete vynechat při aplikaci pravidel",
			"Navrhované elementy, ktoré môžete vynechať pri aplikácii pravidiel",
			"Suggested elements you can omit when applying the rules",
			"Sugerowane elementy, które możesz pominąć przy stosowaniu reguł",
			"Javasolt elemek, amelyeket kihagyhat a szabályok alkalmazása során",
		],
		"alt_levels": [
			"Úrovně obrázků alternativní šablony",
			"Úrovne obrázkov alternatívnej šablóny",
			"Alternative template image levels",
			"Alternatywne poziomy obrazów szablonów",
			"Alternatív sablonképszintek",
		],
		"levels": [
			"Úrovně aplikování",
			"Úrovne aplikovania",
			"Application levels",
			"Poziomy aplikacji",
			"Alkalmazási szintek",
		],
		"assigned_templates": [
			"Přiřazené hlavní šablony",
			"Priradené hlavné šablóny",
			"Assigned main templates",
			"Przypisane szablony główne",
			"Hozzárendelt fő sablonok",
		],
		"no_assigned_templates": [
			"Žádné přiřazené šablony",
			"Žiadne priradené šablóny",
			"No assigned templates",
			"Brak przypisanych szablonów",
			"Nincsenek hozzárendelt sablonok",
		],
		"necessary": [
			"Nezbytné",
			"Nevyhnutné",
			"Necessary",
			"Koniecznie",
			"Szükségszerűen",
		],
		"exclude_some": [
			"Vynechat vybrané",
			"Vynechať vybrané",
			"Exclude some",
			"Pomiń wybrane",
			"Kijelölt kihagyása",
		],
		"regexp": [
			"Regulární výraz",
			"Regulárny výraz",
			"Regular expression",
			"Wyrażenie regularne",
			"Szabályos kifejezés",
		],
		"mergado_apply_elements": [
			"Které elementy se mají do FIE posílat při aplikaci pravidel",
			"Ktoré elementy sa majú do FIE posielať pri aplikácii pravidiel",
			"Which elements should be sent to the FIE when applying the rules",
			"Które elementy należy przesłać do FIE przy stosowaniu przepisów",
			"Mely elemeket kell elküldeni a FIE-nek a szabályok alkalmazásakor",
		],
		"necessary_elements": [
			"Elementy nezbytné pro bezproblémový chod FIE",
			"Elementy nevyhnutné pre chod FIE",
			"Elements necessary for the operation of FIE",
			"Elementy niezbędne do działania FIE",
			"A FIE működéséhez szükséges elemek",
		],
		"selected_mergado_equivalent": [
			"Vybrané ekvivalenty Mergado elementů",
			"Vybrané ekvivalenty Mergado elementov",
			"Selected equivalents of Mergado elements",
			"Wybrane odpowiedniki elementów Mergado",
			"Mergado elemek válogatott megfelelői",
		],
		"categories": [
			"Kategorie",
			"Kategórie",
			"Categories",
			"Kategorie",
			"Kategóriák",
		],
		"fashion": [
			"Móda",
			"Móda",
			"Fashion",
			"Moda",
			"Divat",
		],
		"beauty": [
			"Krása",
			"Krása",
			"Beauty",
			"Uroda",
			"Szépség",
		],
		"health": [
			"Zdraví",
			"Zdravie",
			"Health",
			"Zdrowie",
			"Egészség",
		],
		"pets": [
			"Domácí zvířata",
			"Domáce zvieratá",
			"Pets",
			"Zwierzęta domowe",
			"Háziállatok",
		],
		"electronics": [
			"Elektronika",
			"Elektronika",
			"Electronics",
			"Elektronika",
			"Elektronika",
		],
		"home_and_garden": [
			"Domov a zahrada",
			"Domov a záhrada",
			"Home and garden",
			"Dom i ogród",
			"Otthon és kert",
		],
		"kids": [
			"Děti",
			"Deti",
			"Kids",
			"Dzieci",
			"Gyerekek",
		],
		"sports": [
			"Sporty",
			"Športy",
			"Sports",
			"Lekkoatletyka",
			"Sport",
		],
		"books": [
			"Knihy",
			"Knihy",
			"Books",
			"Książki",
			"Könyveket",
		],
		"cars": [
			"Auta",
			"Autá",
			"Cars",
			"Samochody",
			"Autók",
		],
		"services_and_experiences": [
			"Služby a zkušenosti",
			"Služby a skúsenosti",
			"Services and experiences",
			"Usługi i doświadczenia",
			"Szolgáltatások és tapasztalatok",
		],
		"other_category": [
			"Jiné",
			"Iné",
			"Other",
			"Inny",
			"Más",
		],
		"back_to_original": [
			"Vrátit pozadí",
			"Vrátiť pozadie",
			"Back to the original",
			"Zwróć tło",
			"Vissza a háttérben",
		],
		"paint_transparent": [
			"Odstranit pozadí",
			"Odstrániť pozadie",
			"Remove background",
			"Usuń tło",
			"Távolítsa el a hátteret",
		],
		"waiting_for_product_to_be_loaded": [
			"Čeká se na načtení produktu",
			"Čaká sa na načítanie produktu",
			"Waiting for product to be loaded",
			"Oczekiwanie na załadowanie produktu",
			"Várakozás a termék betöltésére",
		],
		"should_rerender": [
			"Označené k přerenderovaní",
			"Malo by sa znova vykresliť",
			"Should re-render",
			"Należy ponownie renderować",
			"Újra kellene renderelni",
		],
		"should_redownload": [
			"Označené ke znovustažení",
			"Malo by sa znova stiahnuť",
			"Should redownload",
			"Należy ponownie pobrać",
			"Újra kellene tölteni",
		],
		"has_alt_images": [
			"Má alternativní obrázky",
			"Má alternatívne obrázky",
			"Has alternative images",
			"Ma alternatywne obrazy",
			"Alternatív képeket tartalmaz",
		],
		"anim-gif": [
			"Anim GIF",
			"Anim GIF",
			"Anim GIF",
			"Anim GIF",
			"Anim GIF",
		],
		"auto-wmremove": [
			"Odstranění vodoznaků",
			"Odstránenie vodoznakov",
			"Watermarks removal",
			"Usuń znaki wodne",
			"Vízjelek eltávolítása"
		],
		"format_preset": [
			"Předchystaný",
			"Predchystaný",
			"Pre-prepared",
			"Przygotowany wcześniej",
			"Előre elkészítve",
		],
		"format_original": [
			"Původní",
			"Pôvodný",
			"Original",
			"Oryginalny",
			"Eredeti",
		],
		"format_custom": [
			"Vlastní",
			"Vlastný",
			"Custom",
			"Niestandardowy",
			"Egyedi",
		],
		"turned_off": [
			"vypnuto",
			"vypnuté",
			"turned off",
			"wyłączony",
			"kikapcsolva",
		],
		"mode": [
			"režim",
			"režim",
			"mode",
			"tryb",
			"mód",
		],
		"inpainting_create_mask": [
			"Vyznačte oblasti pro inpainting.",
			"Vyznačte oblasti pre inpainting.",
			"Mark the areas for inpainting.",
			"Zaznacz obszary, które zostaną zamalowane.",
			"Jelölje ki a festéshez szükséges területeket.",
		],
		"inpainting_how_to_deal_with_diff_size": [
			"Jak přizpůsobit různé velikosti masky a obrázku",
			"Ako prispôsobiť rôzne veľkosti masky a obrázku",
			"How to deal with the different mask and image sizes",
			"Jak dostosować różne rozmiary masek i obrazów",
			"Különböző maszk- és képméretek kezelése",
		],
		"position_relative_to": [
			"Pozice relativní vůči",
			"Pozícia relatívna voči",
			"Position relative to",
			"Pozycja względem",
			"Pozíció relatívan",
		],
		"scale_mask_to_image_size": [
			"Naškálovat masku na velikost obrázku",
			"Naškálovať masku na veľkosť obrázku",
			"Scale mask to image size",
			"Skaluj maskę do rozmiaru obrazu",
			"Maszk méretezése a kép méretéhez",
		],
		"scale_to_size": [
			"Přizpůsobit velikost",
			"Prispôsobiť veľkosť",
			"Scale to size",
			"Dostosuj rozmiar",
			"Méret testreszabása",
		],
		"object_position": [
			"Poloha objektu",
			"Poloha objektu",
			"Object position",
			"Pozycja obiektu",
			"Objektum pozíciója",
		],
		"complex_background": [
			"Komplexní pozadí",
			"Komplexné pozadie",
			"Complex background",
			"Złożone tło",
			"Komplex háttér",
		],
		"edit_element_content": [
			"Upravit obsah elementu",
			"Upraviť obsah elementu",
			"Edit element content",
			"Edytuj zawartość elementu",
			"Elem tartalmának szerkesztése",
		],
		"prefix": [
			"text před",
			"text pred",
			"prefix",
			"tekst przed",
			"szöveg előtte",
		],
		"suffix": [
			"text za",
			"text za",
			"suffix",
			"tekst po",
			"szöveg utána",
		],
		"decimals": [
			"počet míst",
			"počet miest",
			"decimals",
			"liczba miejsc",
			"ülőhelyek száma",
		],
		"separator": [
			"oddělovač",
			"oddeľovač",
			"separator",
			"separator",
			"szétválasztó",
		],
		"replace": [
			"nahradit",
			"nahradiť",
			"replace",
			"zastępować",
			"cserélni",
		],
		"find_as_regexp": [
			"najít jako regulární výraz",
			"nájsť ako regulárny výraz",
			"find as regular expression",
			"znajdź jako wyrażenie regularne",
			"reguláris kifejezésként keres",
		],
		"symbol_table": [
			"Speciální symboly měn",
			"Špeciálne symboly mien",
			"Special currency symbols",
			"Specjalne symbole walutowe",
			"Speciális pénznemszimbólumok",
		],
		"find_and_replace": [
			"Najít a nahradit",
			"Nájsť a nahradiť",
			"Find and replace",
			"Znajdź i zamień",
			"Keresés és csere",
		],
		"add_text": [
			"Vložit text",
			"Vložiť text",
			"Add text",
			"Wstaw tekst",
			"Szöveg beszúrása",
		],
		"decimal_places": [
			"Desetinná místa",
			"Desatinné miesta",
			"Decimal places",
			"Miejsca dziesiętne",
			"Tizedesjegyek",
		],
		"thousands_separation": [
			"Oddělit tisíce",
			"Oddeliť tisíce",
			"Separate thousands",
			"Oddziel tysiące",
			"Ezresek elválasztása",
		],
		"short_url_with_extension": [
			"Kratší url s příponou souboru",
			"Kratšie url s príponou súboru",
			"Shorter url with file extension",
			"Krótszy adres URL z rozszerzeniem pliku",
			"Rövidebb URL fájlkiterjesztéssel",
		],
		"short_url_with_extension_info": [
			"Kratší forma výstupní url adresy zahrnující příponu podle výstupního formátu obrázku. Některé srovnávače vyžadují příponu obrázku v adrese.",
			"Kratšia forma výstupnej url adresy zahŕňajúca príponu podľa výstupného formátu obrázku. Niektoré porovnávače vyžadujú príponu obrázku v adrese.",
			"A shorter form of the output URL address including an extension according to the output image format. Some shopping engines require an extension in the address.",
			"Krótsza forma adresu URL wyjściowego zawierająca rozszerzenie zgodnie z formatem obrazu wyjściowego. Niektóre testy porównawcze wymagają rozszerzenia obrazu w adresie.",
			"A kimeneti URL-cím rövidebb formája, amely a kimeneti képformátumnak megfelelő kiterjesztést tartalmaz. Egyes teljesítménymutatók képkiterjesztést igényelnek a címben.",
		],
		"gradient_is_used_by_template": [
			"Tento gradient je používán šablonou a nelze jej tedy smazat.",
			"Tento gradient je používaný šablónou a nemožno ho teda zmazať.",
			"This gradient is used by the template and cannot be deleted.",
			"Ten gradient jest używany przez szablon i nie można go usunąć.",
			"Ezt a színátmenetet a sablon használja, és nem törölhető.",
		],
		"no_search_image_results": [
			"Nebyly nalezeny žádné obrázky odpovídající hledanému výrazu.",
			"Neboli nájdené žiadne obrázky zodpovedajúce hľadanému výrazu.",
			"No images were found matching the search term.",
			"Nie znaleziono obrazów odpowiadających wyszukiwanemu terminowi.",
			"Nem található a keresési kifejezésnek megfelelő kép.",
		],
		"import_from_project": [
			"Import z projektu",
			"Import z projektu",
			"Import from project",
			"Importuj z projektu",
			"Importálás a projektből",
		],
		"choose_project": [
			"Zvolte projekt",
			"Zvoľte projekt",
			"Choose project",
			"Wybierz projekt",
			"Válasszon egy projektet",
		],
		"no_other_projects_of_user": [
			"Žádné projekty ze kterých lze importovat.",
			"Žiadne projekty z ktorých je možné importovať.",
			"No projects to import from.",
			"Brak projektów do zaimportowania.",
			"Nincsenek importálható projektek.",
		],
		"loading_queries": [
			"Načítám výběry z Mergada",
			"Načítavam výbery z Mergada",
			"Loading queries from Mergado",
			"Ładowanie selekcji z Mergado",
			"Kiválasztások betöltése Mergadoból",
		],
		"loading_template": [
			"Načítám šablonu",
			"Načítavam šablónu",
			"Loading template",
			"Ładowanie szablonu",
			"A sablon betöltése",
		],
		"text_mode": [
			"Textový režim",
			"Textový režim",
			"Text mode",
			"Tryb tekstowy",
			"Szöveges mód",
		],
		"total_icons": [
			"Počet ikon",
			"Počet ikon",
			"Total",
			"Razem ikony",
			"Összes ikon",
		],
		"try_icons": [
			"Vyzkoušet ikony",
			"Vyskúšať ikony",
			"Try out the icons",
			"Wypróbuj ikony",
			"Próbáld ki az ikonokat.",
		],
		"icon_color": [
			"Barva ikon",
			"Farba ikon",
			"Icon color",
			"Kolor ikony",
			"Ikon színe",
		],
		"did_not_found_stickers": [
			"Nenašli jste vhodné samolepky?",
			"Nenašli ste vhodné samolepky?",
			"Didn't find the right stickers?",
			"Nie znalazłeś odpowiednich naklejek?",
			"Nem találtad meg a megfelelő matricákat?",
		],
		"ai_elements_to_feed": [
			"Obohacení feedu pomocí AI",
			"Obohatenie feedu pomocou AI",
			"Feed AI enrichment",
			"Wzbogacanie paszy za pomocą sztucznej inteligencji",
			"Takarmánydúsítás mesterséges intelligenciával",
		],
		'mcp': [
			'MCP',
			'MCP',
			'MCP',
			'MCP',
			'MCP',
		],
	}
}

